<template>

  <html lang="en">
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, shrink-to-fit=no"
      />

      <title>
        BTA Group : Bimbingan Belajar Online/Offline Terbaik No 1 Pilihan
        Keluarga Indonesia
      </title>
      <meta
        name="google-site-verification"
        content="irvXi25F9xnCfRglR3SgfhW3ISCEfusZ0hGAmCNokaA"
      />
      <!-- Global site tag (gtag.js) - Google Analytics -->
    </head>

    <body>

      <!-- ===============================================-->
      <!--    Popup-->
      <!-- ===============================================-->

 		<b-modal
      v-model="popup"
      size="md"
      modal-class="border-0"
      header-class="background-primary"
      footer-class="justify-content-center"
      v-bind:centered="true"
      v-bind:hide-footer="true"
    >
      
      <!-- HEADER --> 
      <!------------>   
    
      <template slot="modal-header">
        <h4
          class="container text-uppercase text-white font-weight-bold text-center mb-0"
        >
          UPDATE TERBARU BTA
        </h4>
      </template>

      <!-- BODY --> 
      <!------------>

      <div class="d-block text-center p-3">

        <!-- NOTIF TO -->
						<!-- script TO line 1349 -->
						<!-- script TO di file layout header line 327 -->


        <div class="rounded p-3 mb-4 text-left shadow-sm" 
             style="background-color: #fff3cd; border-left: 5px solid #ffc107;">
             
          <div class="d-flex align-items-center mb-2">
            <div class="mr-3 display-4">📢</div> 
            <div>
              <h5 class="font-weight-bold text-dark mb-0" style="line-height: 1.2;">
                HASIL TO & ANALISIS SUDAH KELUAR!
              </h5>
              <small class="text-muted">Cek evaluasi belajarmu sekarang.</small>
            </div>
          </div>

          <b-button 
            block 
            variant="danger" 
            class="font-weight-bold mt-2 shadow-sm py-2"
            style="border-radius: 50px; font-size: 1rem;"
            @click="checkLoginAndGo"
          >
            LIHAT NILAI SAYA SEKARANG &rarr;
          </b-button>
        </div>

        
        <!-- SOSMED -->

        <div class="d-flex overflow-auto mb-3" style="scroll-snap-type: x mandatory; gap: 15px; padding-bottom: 10px;">

          <!-- Berita 1 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center;">
              <a href="https://keberhasilan.btagroup.co.id/sma2026.html" target="_blank" rel="noopener noreferrer" style="display: block;">
                <img 
                  src="/static/images/page/about/popupselamat2026.png" 
                  alt="Poster Pengumuman" 
                  style="width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
              </a>
            </div>

            <!-- Berita 2 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center;">
              <a href="https://api.whatsapp.com/send?phone=6285772897428&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Kota+Wisata+Cibubur%3F" target="_blank" rel="noopener noreferrer" style="display: block;">
                <img 
                  src="/static/images/page/about/CaBarBTA8KotWis.jpeg" 
                  alt="Poster Pengumuman" 
                  style="width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
              </a>
            </div>

            <!-- Berita 3 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center; display: flex; flex-direction: column;">
              <iframe 
                src="https://www.instagram.com/p/DZIGRj2km4g/embed" 
                width="100%" 
                frameborder="0" 
                scrolling="no" 
                allowtransparency="true"
                style="flex-grow: 1; max-width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
              </iframe>
            </div>
        </div>

        <div class="mt-4">
            <h5 class="font-weight-bold text-dark" style="font-size: 1.1rem;">Mau Info Lebih Lanjut?</h5>
            <p class="text-muted mb-4 small">
              Dapatkan update bimbel, tips belajar & kegiatan seru BTA lainnya. 
              <br>Yuk, follow kami!
            </p>
            
            <div class="d-flex flex-wrap justify-content-center align-items-center">
                <a href="https://www.instagram.com/btagroup_" target="_blank" class="btn btn-primary m-1 btn-sm" style="background-color: #E1306C; border-color: #E1306C; min-width: 120px;">
                    Instagram
                </a>
                
                <a href="https://www.tiktok.com/@btagroup_" target="_blank" class="btn btn-dark m-1 btn-sm" style="background-color: #000000; border-color: #000000; min-width: 120px;">
                    TikTok
                </a>
            </div>
        </div>

        <!-- TUTUP -->

        <button
        v-on:click="popup = false"
        class="btn btn-sm btn-outline-danger px-3 mt-5 mb-3 d-block mx-auto"
        style="font-size: 0.8rem;"
        >
        Tutup
        </button>

      </div>
    </b-modal>

      <!-- ===============================================-->
      <!--    Main Content Layout                         -->
      <!-- ===============================================-->
      <main class="main" id="top">

        <!-- ===============================================-->
        <!-- 1. HERO SECTION BARU (Adaptive & Zoom Locked)  -->
        <!-- ===============================================-->
        <section class="hero-section" id="home">
          <div class="hero-bg-overlay"></div>

          <div class="container hero-container">
            <div class="row align-items-center">

              <!-- LEFT: Title, Selectors & Stats -->
              <div class="col-lg-7 hero-col-content">
                <h1 class="hero-title">
                  Bimbingan Belajar <br>
                  <span class="text-highlight">Terbaik</span> Untuk Pelajar <br>
                  di Seluruh Indonesia
                </h1>
                
                <p class="hero-subtitle">
                  Program lengkap, pengajar berpengalaman, dan sistem belajar teruji untuk membantumu meraih prestasi terbaik.
                </p>

                <!-- Selectors Card -->
                <div class="hero-selector-card" :class="{ 'selector-pulse-glow': isSelectorGlowing }" id="hero-selector-box">
                  <!-- Program -->
                  <div class="selector-group">
                    <span class="selector-label">Pilih Program</span>
                    <div class="selector-control-wrapper">
                      <!-- Mortarboard/Graduation Cap SVG -->
                      <div class="selector-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"/>
                          <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z"/>
                        </svg>
                      </div>
                      <select class="selector-select" v-model="selectedProgram" @change="onProgramChange">
                        <option value="">Pilih Program</option>
                        <option 
                          v-for="program in programList" 
                          :key="program.id" 
                          :value="program.id"
                          :disabled="isProgramDisabledInCabang(program.id)"
                        >
                          {{ program.name }}{{ isProgramDisabledInCabang(program.id) ? ' (Tidak tersedia di cabang ini)' : '' }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="selector-separator"></div>

                  <!-- Cabang -->
                  <div class="selector-group">
                    <span class="selector-label">Pilih Cabang</span>
                    <div class="selector-control-wrapper">
                      <!-- Map Marker/Geo Pin SVG -->
                      <div class="selector-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                        </svg>
                      </div>
                      <select class="selector-select" v-model="selectedCabang" @change="onCabangChange">
                        <option value="">Pilih Cabang</option>
                        <option 
                          v-for="branch in primaryBranches" 
                          :key="branch.id" 
                          :value="branch.id"
                          :disabled="isCabangDisabledForProgram(branch.id)"
                        >
                          {{ branch.name }}{{ isCabangDisabledForProgram(branch.id) ? ' (Program tidak tersedia)' : '' }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Submit Button -->
                  <button class="btn-register" @click="registerNow">
                    Mulai Daftar 
                    <svg class="bi bi-arrow-right-short ms-2" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16" style="vertical-align: middle;">
                      <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path>
                    </svg>
                  </button>
                </div>

                <!-- Stats Cards -->
                <div class="hero-stats-row">
                  <div class="stat-card">
                    <div class="stat-icon-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4 0 1 1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                      </svg>
                    </div>
                    <div class="stat-text"><strong>100.000+</strong><br>Alumni</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-icon-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="m8 0 1.669.864 1.864-.047.533 1.785 1.764.633.02 1.874 1.3 1.348-.52 1.801.864 1.669-.864 1.669.52 1.801-1.3 1.348-.02 1.874-1.764.633-.533 1.785-1.864-.047L8 16l-1.669-.864-1.864.047-.533-1.785-1.764-.633-.02-1.874-1.3-1.348.52-1.801-.864-1.669.864-1.669-.52-1.801 1.3-1.348.02-1.874 1.764-.633.533-1.785 1.864.047L8 0z"/>
                        <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 5.018 12.1 4 11.794z"/>
                      </svg>
                    </div>
                    <div class="stat-text"><strong>40 Tahun</strong><br>Pengalaman</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-icon-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8.447.276a.5.5 0 0 0-.894 0L7.19 1H2.5A1.5 1.5 0 0 0 1 2.5V10h14V2.5A1.5 1.5 0 0 0 13.5 1H8.809L8.447.276zM1 11v.5A1.5 1.5 0 0 0 2.5 13h2.902L4.03 15.804a.5.5 0 1 0 .894.448L6.486 13h3.028l1.562 3.252a.5.5 0 1 0 .894-.448L10.598 13h2.902a1.5 1.5 0 0 0 1.5-1.5V11H1z"/>
                      </svg>
                    </div>
                    <div class="stat-text"><strong>Pengajar</strong><br>Berpengalaman</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-icon-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Zm1 2.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-6 3v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-6 3v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-6 3v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"/>
                      </svg>
                    </div>
                    <div class="stat-text"><strong>13 Cabang</strong><br>Utama &amp; Mitra</div>
                  </div>
                </div>
              </div>

              <!-- RIGHT: Visual, Floating Trophy, Socials & LOCKED BACKGROUND -->
              <div class="col-lg-5 hero-col-visual">
                
                <!-- BAGIAN DIAGONAL MERAH DISISIPKAN DI SINI (LOCKED BEHIND THE GIRL) -->
                <div class="hero-diagonal-red"></div>

                <div class="hero-image">
                  <img :src="gambarHomes[0].image" class="img-fluid" alt="BTA Hero">
                </div>

                <!-- Trophy Card -->
                <div class="trophy-card">
                  <div class="trophy-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.319.232.319.437a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5c0-.205.125-.389.319-.437L4.742 13.1V10.92c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.012-.48-.02-1.029-.02-1.637l.008-.344a28.09 28.09 0 0 1-.708-1.954zm10.802 0a28.091 28.091 0 0 1-.708 1.954l.007.344c.002.608-.006 1.157-.018 1.637a2 2 0 0 0 .72-3.935z"/>
                    </svg>
                  </div>
                  <div class="stars-row">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>
                  </div>
                  <h4 class="trophy-title">Terpercaya</h4>
                  <h3 class="trophy-year">Sejak <span>1980-an</span></h3>
                  <p class="trophy-subtext">Membantu Generasi Berprestasi</p>
                </div>

                <!-- Social Media Buttons -->
                <div class="social-media-container">
                  <a class="social-icon-btn" href="https://www.instagram.com/btagroup_" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"></path>
                    </svg>
                  </a>
                  <a class="social-icon-btn" href="https://www.youtube.com/channel/UCkPXrArTezFJ1nRNXX-csug" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"></path>
                    </svg>
                  </a>
                  <a class="social-icon-btn" href="https://www.tiktok.com/@btagroup_" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"></path>
                    </svg>
                  </a>
                  <a class="social-icon-btn" href="https://web.facebook.com/btagroupofficial" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"></path>
                    </svg>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </section>

        <!-- ===============================================-->
        <!-- Penutup Hero Section-->
        <!-- ===============================================-->


        <!-- ===============================================-->
        <!-- Info Carousel Section-->
        <!-- ===============================================-->

        <section class="py-5" id="banners">
          <div class="container">
            <!-- Card Utama Pembungkus Carousel -->
            <div class="card banners-card border-0 shadow-sm p-4 p-md-5">
              <div class="card-body p-0">
                
                <!-- Header Teks di dalam Card -->
                <div class="banners-header mb-4">
                  <h3 class="banners-title mb-2">Informasi & Pengumuman BTA Group</h3>
                  <p class="banners-subtitle text-muted mb-0">
                    Temukan informasi terbaru, pengumuman penting, dan kegiatan terbaru dari BTA Group.
                  </p>
                </div>

                <!-- Wrapper Carousel dengan Posisi Relative -->
                <div class="position-relative w-100">
                  
                  <!-- Ditambahkan w-100 agar carousel selalu melebar penuh meskipun gambar rusak/loading -->
                  <div class="carousel slide w-100" id="carouselBanners" data-bs-ride="carousel">
                    
                    <!-- Slide Gambar (Inner) dengan Sudut Membulat -->
                    <div class="carousel-inner rounded-4 overflow-hidden">
                      
                      <!-- Slide 1 -->
                      <div class="carousel-item active" data-bs-interval="3000">
                        <a href="https://api.whatsapp.com/send?phone=6285772897428&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Kota+Wisata+Cibubur%3F" target="_blank" class="d-block w-100">
                          <img class="img-fluid w-100 d-block banner-image" src="/static/images/page/about/BannerCaBarBTA8KotWis.jpeg" alt="Cabang Baru BTA 8 Kota Wisata" />
                        </a>
                      </div>
                      
                      <!-- Slide 2 -->
                      <div class="carousel-item" data-bs-interval="3000">
                        <a href="https://btagroup.co.id/contact" target="_blank" class="d-block w-100">
                          <img class="img-fluid w-100 d-block banner-image" src="/static/images/page/about/BannerDaftar2627.jpeg" alt="Ayo Mendaftar!" />
                        </a>
                      </div>
                      
                      <!-- Slide 3 -->
                      <div class="carousel-item" data-bs-interval="3000">
                        <a href="https://keberhasilan.btagroup.co.id/sma2026.html" target="_blank" class="d-block w-100">
                          <img class="img-fluid w-100 d-block banner-image" src="/static/images/page/about/BannerSelamatPTN2526.jpeg" alt="Selamat PTN" />
                        </a>
                      </div>
                      
                    </div>

                    <!-- Tombol Navigasi Kustom (Menggunakan gambar panah CSS, bebas dari dependency font eksternal) -->
                    <button class="carousel-control-prev custom-carousel-btn" type="button" data-bs-target="#carouselBanners" data-bs-slide="prev">
                      <span class="custom-carousel-icon prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    
                    <button class="carousel-control-next custom-carousel-btn" type="button" data-bs-target="#carouselBanners" data-bs-slide="next">
                      <span class="custom-carousel-icon next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>

                    <!-- Indikator Titik (Dots) di Bawah Carousel -->
                    <div class="carousel-indicators position-static mt-4 mb-0">
                      <button type="button" data-bs-target="#carouselBanners" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                      <button type="button" data-bs-target="#carouselBanners" data-bs-slide-to="1" aria-label="Slide 2"></button>
                      <button type="button" data-bs-target="#carouselBanners" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </section>

        <!-- ===============================================-->
        <!-- Penutup Info Carousel Section-->
        <!-- ===============================================-->


        <!-- ===============================================-->
        <!-- Program Bimbingan Section                      -->
        <!-- ===============================================-->

        <section id="services" class="services-section">
          <div class="container">
            
            <!-- Title Section (Angka 4 Dihapus & Responsive) -->
            <div class="row">
              <div class="col-lg-8 mx-auto text-center mb-4">
                <h2 class="section-title">
                  <span class="title-ray-left"></span>
                  <span class="text-orange">Program</span> Unggulan BTA Group
                  <span class="title-ray-right"></span>
                </h2>
                <p class="section-subtitle">
                  Pilih program yang paling sesuai dengan kebutuhan dan tujuan belajarmu.<br>
                  Informasi lengkap akan menyesuaikan cabang pilihanmu.
                </p>
              </div>
            </div>

            <!-- Cards Grid (Menyala Aktif Berdasarkan selectedProgram) -->
            <div class="row justify-content-center">
              <div class="col-xl-12">
                <div class="program-grid">
                  
                  <!-- CARD 1: KELAS 12 SMA -->
                  <div class="prog-card card-theme-orange" :class="{ 'active-highlight': isProgramHighlighted('sma12'), 'prog-card-disabled': isProgramDisabledInCabang('sma12') }">
                    <div class="prog-card-top">
                      <div class="prog-index-row">
                        <span class="prog-index-badge">01</span>
                        <span class="prog-pill-label">{{ getProgramDetails('sma12').badge }}</span>
                      </div>
                      <h4 class="prog-card-title">Kelas 12 SMA</h4>
                      <div v-if="isProgramDisabledInCabang('sma12')" class="prog-card-disabled-badge">
                        ⚠️ Tidak Tersedia di {{ getSelectedCabangName() }}
                      </div>
                      <p class="prog-card-desc-top">
                        {{ getProgramDetails('sma12').desc }}
                      </p>
                      <img src="/static/images/page/about/natasya-home-new-resize2.png" alt="Siswa Kelas 12" class="prog-student-img" />
                    </div>
                    <div class="prog-card-bottom">
                      <div class="prog-info-grid">
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8V6zm6 0h2v2h-2V6z"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('sma12').info1Label }}</span>
                            <span class="info-val">{{ getProgramDetails('sma12').info1Val }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">Kapasitas Kelas</span>
                            <span class="info-val">{{ getProgramDetails('sma12').capacity }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item span-2">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('sma12').polaLabel }}</span>
                            <span class="info-val">{{ getProgramDetails('sma12').polaVal }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="prog-focus-box">
                        <span class="focus-box-icon">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                        </span>
                        <div class="focus-box-text">
                          <strong class="focus-title">{{ getProgramDetails('sma12').focusTitle }}</strong>
                          <span class="focus-bold">{{ getProgramDetails('sma12').focusBold }}</span>
                          <span class="focus-desc">{{ getProgramDetails('sma12').focusDesc }}</span>
                        </div>
                      </div>
                      <button v-if="!isProgramDisabledInCabang('sma12')" v-on:click="modal12 = true" class="prog-card-btn">
                        Pelajari Program Ini &rarr;
                      </button>
                      <button v-else disabled class="prog-card-btn prog-card-btn-disabled">
                        Tidak Tersedia di Cabang Ini
                      </button>
                    </div>
                  </div>

                  <!-- CARD 2: KELAS 10 & 11 SMA -->
                  <div class="prog-card card-theme-blue" :class="{ 'active-highlight': isProgramHighlighted('sma10'), 'prog-card-disabled': isProgramDisabledInCabang('sma10') }">
                    <div class="prog-card-top">
                      <div class="prog-index-row">
                        <span class="prog-index-badge">02</span>
                        <span class="prog-pill-label">{{ getProgramDetails('sma10').badge }}</span>
                      </div>
                      <h4 class="prog-card-title">Kelas 10 &amp; 11 SMA</h4>
                      <div v-if="isProgramDisabledInCabang('sma10')" class="prog-card-disabled-badge">
                        ⚠️ Tidak Tersedia di {{ getSelectedCabangName() }}
                      </div>
                      <p class="prog-card-desc-top">
                        {{ getProgramDetails('sma10').desc }}
                      </p>
                      <img src="/static/images/page/about/natasya-home-new-resize2.png" alt="Siswa Kelas 10/11" class="prog-student-img" />
                    </div>
                    <div class="prog-card-bottom">
                      <div class="prog-info-grid">
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8V6zm6 0h2v2h-2V6z"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('sma10').info1Label }}</span>
                            <span class="info-val">{{ getProgramDetails('sma10').info1Val }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">Kapasitas Kelas</span>
                            <span class="info-val">{{ getProgramDetails('sma10').capacity }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item span-2">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('sma10').polaLabel }}</span>
                            <span class="info-val">{{ getProgramDetails('sma10').polaVal }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="prog-focus-box">
                        <span class="focus-box-icon">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><polyline points="9 11 12 14 22 4"></polyline></svg>
                        </span>
                        <div class="focus-box-text">
                          <strong class="focus-title">{{ getProgramDetails('sma10').focusTitle }}</strong>
                          <span class="focus-bold">{{ getProgramDetails('sma10').focusBold }}</span>
                          <span class="focus-desc">{{ getProgramDetails('sma10').focusDesc }}</span>
                        </div>
                      </div>
                      <button v-if="!isProgramDisabledInCabang('sma10')" v-on:click="modal10 = true" class="prog-card-btn">
                        Pelajari Program Ini &rarr;
                      </button>
                      <button v-else disabled class="prog-card-btn prog-card-btn-disabled">
                        Tidak Tersedia di Cabang Ini
                      </button>
                    </div>
                  </div>

                  <!-- CARD 3: KELAS 8 & 9 SMP -->
                  <div class="prog-card card-theme-green" :class="{ 'active-highlight': isProgramHighlighted('smp'), 'prog-card-disabled': isProgramDisabledInCabang('smp') }">
                    <div class="prog-card-top">
                      <div class="prog-index-row">
                        <span class="prog-index-badge">03</span>
                        <span class="prog-pill-label">{{ getProgramDetails('smp').badge }}</span>
                      </div>
                      <h4 class="prog-card-title">Kelas 8 &amp; 9 SMP</h4>
                      <div v-if="isProgramDisabledInCabang('smp')" class="prog-card-disabled-badge">
                        ⚠️ Tidak Tersedia di {{ getSelectedCabangName() }}
                      </div>
                      <p class="prog-card-desc-top">
                        {{ getProgramDetails('smp').desc }}
                      </p>
                      <img src="/static/images/page/about/natasya-home-new-resize2.png" alt="Siswa SMP" class="prog-student-img" />
                    </div>
                    <div class="prog-card-bottom">
                      <div class="prog-info-grid">
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8V6zm6 0h2v2h-2V6z"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('smp').info1Label }}</span>
                            <span class="info-val">{{ getProgramDetails('smp').info1Val }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">Kapasitas Kelas</span>
                            <span class="info-val">{{ getProgramDetails('smp').capacity }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item span-2">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('smp').polaLabel }}</span>
                            <span class="info-val">{{ getProgramDetails('smp').polaVal }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="prog-focus-box">
                        <span class="focus-box-icon">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
                        </span>
                        <div class="focus-box-text">
                          <strong class="focus-title">{{ getProgramDetails('smp').focusTitle }}</strong>
                          <span class="focus-bold">{{ getProgramDetails('smp').focusBold }}</span>
                          <span class="focus-desc">{{ getProgramDetails('smp').focusDesc }}</span>
                        </div>
                      </div>
                      <button v-if="!isProgramDisabledInCabang('smp')" v-on:click="modal9 = true" class="prog-card-btn">
                        Pelajari Program Ini &rarr;
                      </button>
                      <button v-else disabled class="prog-card-btn prog-card-btn-disabled">
                        Tidak Tersedia di Cabang Ini
                      </button>
                    </div>
                  </div>

                  <!-- CARD 4: ALUMNI / GAP YEAR -->
                  <div class="prog-card card-theme-purple" :class="{ 'active-highlight': isProgramHighlighted('alumni'), 'prog-card-disabled': isProgramDisabledInCabang('alumni') }">
                    <div class="prog-card-top">
                      <div class="prog-index-row">
                        <span class="prog-index-badge">04</span>
                        <span class="prog-pill-label">{{ getProgramDetails('alumni').badge }}</span>
                      </div>
                      <h4 class="prog-card-title">Alumni / Gap Year</h4>
                      <div v-if="isProgramDisabledInCabang('alumni')" class="prog-card-disabled-badge">
                        ⚠️ Tidak Tersedia di {{ getSelectedCabangName() }}
                      </div>
                      <p class="prog-card-desc-top">
                        {{ getProgramDetails('alumni').desc }}
                      </p>
                      <img src="/static/images/page/about/natasya-home-new-resize2.png" alt="Siswa Alumni" class="prog-student-img" />
                    </div>
                    <div class="prog-card-bottom">
                      <div class="prog-info-grid">
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8V6zm6 0h2v2h-2V6z"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('alumni').info1Label }}</span>
                            <span class="info-val">{{ getProgramDetails('alumni').info1Val }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">Kapasitas Kelas</span>
                            <span class="info-val">{{ getProgramDetails('alumni').capacity }}</span>
                          </div>
                        </div>
                        <div class="prog-info-item span-2">
                          <span class="info-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                          </span>
                          <div class="info-text">
                            <span class="info-label">{{ getProgramDetails('alumni').polaLabel }}</span>
                            <span class="info-val">{{ getProgramDetails('alumni').polaVal }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="prog-focus-box">
                        <span class="focus-box-icon">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                        </span>
                        <div class="focus-box-text">
                          <strong class="focus-title">{{ getProgramDetails('alumni').focusTitle }}</strong>
                          <span class="focus-bold">{{ getProgramDetails('alumni').focusBold }}</span>
                          <span class="focus-desc">{{ getProgramDetails('alumni').focusDesc }}</span>
                        </div>
                      </div>
                      <button v-if="!isProgramDisabledInCabang('alumni')" v-on:click="modalAl = true" class="prog-card-btn">
                        Pelajari Program Ini &rarr;
                      </button>
                      <button v-else disabled class="prog-card-btn prog-card-btn-disabled">
                        Tidak Tersedia di Cabang Ini
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- ============================================ -->
          <!-- POP-UP MODAL KELAS 12 SMA                    -->
          <!-- ============================================ -->
          <b-modal
            v-model="modal12"
            size="xl"
            centered
            hide-footer
            hide-header
            content-class="p-0 border-0 rounded-24 custom-popup"
            modal-class="program-popup-modal"
          >
            <div class="popup-wrapper">
              <button class="popup-close-btn" v-on:click="modal12 = false" aria-label="Tutup Popup">&times;</button>
              
              <!-- Header Section -->
              <div class="popup-header-clean">
                <span class="popup-badge-clean badge-red">PROGRAM UTAMA KELAS 12 SMA</span>
                <h2 class="popup-title-clean">KELAS 12 SMA</h2>
                <h3 class="popup-subtitle-clean text-red-theme">Bimbingan Intensif Persiapan Masuk PTN (SNBP, UTBK-SNBT &amp; Ujian Mandiri)</h3>
                <p class="popup-desc-clean">
                  Program terintegrasi untuk mempersiapkan siswa secara matang menghadapi seleksi PTN dan ujian sekolah. Memadukan pemantapan materi sekolah, review konsep dasar, hingga pembekalan intensif menghadapi UTBK-SNBT, SIMAK UI, CBT UM UGM, dan seleksi mandiri lainnya.
                </p>

                <!-- Quick Highlights Bar -->
                <div class="popup-highlights-bar">
                  <div class="highlight-item" v-if="getProgramDetails('sma12').highlight1">
                    <span class="highlight-dot dot-red"></span>
                    <span>{{ getProgramDetails('sma12').highlight1 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma12').highlight2">
                    <span class="highlight-dot dot-red"></span>
                    <span>{{ getProgramDetails('sma12').highlight2 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma12').highlight3">
                    <span class="highlight-dot dot-red"></span>
                    <span>{{ getProgramDetails('sma12').highlight3 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma12').highlight4">
                    <span class="highlight-dot dot-red"></span>
                    <span>{{ getProgramDetails('sma12').highlight4 }}</span>
                  </div>
                </div>
              </div>

              <!-- Keunggulan & Fasilitas Program -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Keunggulan &amp; Fasilitas Belajar</h4>
                  <span class="section-subtitle-clean">Standar fasilitas bimbingan di seluruh cabang BTA Group</span>
                </div>
                <div class="popup-benefits-grid">
                  <div class="benefit-box border-red">
                    <div class="benefit-num-tag num-red">01</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Kelas Semi-Privat &amp; Kondusif</strong>
                      <p class="benefit-body">Kapasitas terbatas 10–15 siswa per kelas sehingga pengajar dapat fokus memantau pemahaman setiap siswa secara personal.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-red">
                    <div class="benefit-num-tag num-red">02</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Standby Teacher &amp; Konsultasi</strong>
                      <p class="benefit-body">Layanan bimbingan mandiri di luar jam les reguler untuk konsultasi PR, pembedahan materi sulit, serta persiapan ulangan harian.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-red">
                    <div class="benefit-num-tag num-red">03</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Simulasi Try Out Berkala</strong>
                      <p class="benefit-body">Tryout online &amp; offline berkala dengan sistem penilaian standar nasional UTBK, analisis ranking komprehensif, dan video pembahasan.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-red">
                    <div class="benefit-num-tag num-red">04</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Rasionalisasi &amp; Konseling PTN</strong>
                      <p class="benefit-body">Pendampingan strategi pemilihan jurusan dan universitas impian berbasis pemetaan minat bakat, rekam nilai rapor, dan tren passing grade.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tahapan Kurikulum Belajar -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Tahapan Program Belajar</h4>
                  <span class="section-subtitle-clean">Alur kurikulum terstruktur menuju seleksi PTN</span>
                </div>
                <div class="popup-stages-grid">
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-red">Fase 1</span>
                      <span class="stage-timing">Semester 1</span>
                    </div>
                    <strong class="stage-name">Penguatan Konsep &amp; Rapor</strong>
                    <p class="stage-desc">Fokus pendalaman materi sekolah demi mendongkrak nilai rapor semester 5 (jalur SNBP) serta pengenalan dasar TPS UTBK.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-red">Fase 2</span>
                      <span class="stage-timing">Semester 2</span>
                    </div>
                    <strong class="stage-name">Pemantapan &amp; Persiapan Ujian</strong>
                    <p class="stage-desc">Pembahasan intensif tipe soal UTBK-SNBT, review materi kelas X–XI, persiapan Asesmen Sekolah, dan tryout SIMAK UI &amp; UM UGM.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-red">Fase 3</span>
                      <span class="stage-timing">Pasca Ujian Sekolah</span>
                    </div>
                    <strong class="stage-name">Super Intensif &amp; Drilling Soal</strong>
                    <p class="stage-desc">Sesi belajar harian dengan drilling ribuan soal latihan prediktif, simulasi waktu ujian, dan evaluasi progres setiap pekan.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-red">Fase 4</span>
                      <span class="stage-timing">Ujian Masuk PTN</span>
                    </div>
                    <strong class="stage-name">Jalur Mandiri &amp; Finalisasi PTN</strong>
                    <p class="stage-desc">Pendampingan seleksi mandiri PTN favorit serta konsultasi personal finalisasi pemilihan program studi dan kampus impian.</p>
                  </div>
                </div>
              </div>

              <!-- Pilihan Waktu Belajar (Pola Hari) -->
              <div class="popup-schedule-box">
                <div class="schedule-head-row">
                  <h5 class="schedule-title">Pilihan Pola Hari &amp; Waktu Belajar di Cabang</h5>
                  <span class="schedule-note">* Pilihan sesi disesuaikan dengan ketersediaan kuota masing-masing cabang</span>
                </div>
                <div class="schedule-cols-grid">
                  <div class="schedule-col" v-for="(col, sIdx) in (getProgramDetails('sma12').scheduleCols || [])" :key="sIdx">
                    <span class="sched-badge">{{ col.badge }}</span>
                    <p class="sched-text" v-html="col.text"></p>
                  </div>
                </div>
              </div>

              <!-- Materi yang Dipelajari -->
              <div class="popup-subjects-box">
                <h5 class="subjects-box-title">Mata Pelajaran yang Dipelajari</h5>
                <div class="subjects-tag-list">
                  <span class="subject-tag-clean tag-red-clean">TPS (Penalaran Umum, Kuantitatif, Bacaan &amp; Menulis)</span>
                  <span class="subject-tag-clean tag-red-clean">Literasi Bahasa Indonesia &amp; Bahasa Inggris</span>
                  <span class="subject-tag-clean tag-red-clean">Penalaran Matematika</span>
                  <span class="subject-tag-clean tag-red-clean">TKA Saintek (Fisika, Kimia, Biologi, Mat Lanjut)</span>
                  <span class="subject-tag-clean tag-red-clean">TKA Soshum (Ekonomi, Geografi, Sosiologi, Sejarah)</span>
                </div>
              </div>

              <!-- Cabang & WhatsApp Action Bar -->
              <div class="popup-action-card">
                <div class="action-card-left">
                  <span class="action-card-label">CABANG BIMBINGAN TERPILIH</span>
                  <div v-if="selectedCabang" class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title">{{ getSelectedCabangName() }}</h4>
                      <span class="action-branch-badge" :class="isAvailableInBranch('sma12') ? 'badge-available' : 'badge-unavailable'">
                        {{ isAvailableInBranch('sma12') ? 'Tersedia' : 'Belum Tersedia' }}
                      </span>
                    </div>
                    <p class="action-branch-desc" v-if="isAvailableInBranch('sma12')">
                      Program Kelas 12 SMA aktif dan dapat didaftarkan di cabang ini. Silakan hubungi admin cabang untuk konfirmasi kuota kelas.
                    </p>
                    <p class="action-branch-desc text-danger" v-else>
                      Program ini belum dibuka di cabang yang Anda pilih. Silakan pilih cabang alternatif BTA lainnya.
                    </p>
                  </div>
                  <div v-else class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title text-muted">Cabang Belum Dipilih</h4>
                    </div>
                    <p class="action-branch-desc">
                      Pilih cabang bimbingan terlebih dahulu untuk melihat ketersediaan jadwal dan kuota kelas.
                    </p>
                  </div>
                </div>
                <div class="action-card-right">
                  <div class="branch-dropdown-wrapper">
                    <button class="action-btn-secondary" v-on:click="showBranchDropdown = !showBranchDropdown">
                      <svg class="action-btn-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                      <span>{{ selectedCabang ? 'Ganti Cabang' : 'Pilih Cabang' }}</span>
                    </button>
                    <ul v-if="showBranchDropdown" class="action-dropdown-list">
                      <li v-for="b in primaryBranches" :key="b.id" v-on:click="selectCabangFromModal(b.id)" class="action-dropdown-item">
                        {{ b.name }}
                      </li>
                    </ul>
                  </div>
                  <a :href="getWhatsAppUrl('sma12')" target="_blank" class="action-btn-primary btn-red-primary">
                    <svg class="action-btn-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 001.335 4.963L2 22l5.233-1.372a9.932 9.932 0 004.773 1.218h.004c5.502 0 9.986-4.478 9.988-9.986a9.974 9.974 0 00-2.925-7.064A9.948 9.948 0 0012.012 2zm5.787 14.41c-.247.696-1.443 1.265-1.996 1.328-.5.056-1.155.086-1.85-.14a11.39 11.39 0 01-4.708-3.08 10.375 10.375 0 01-2.096-3.23c-.332-.578-.65-1.258-.65-1.92 0-1.365.704-2.034.954-2.288.25-.254.67-.32.993-.32.105 0 .205.003.29.008.25.013.376.03.54.37.202.42.693 1.693.753 1.82.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.3-.36.42-.12.12-.24.25-.1.49a8.125 8.125 0 001.522 1.884c.642.57 1.182.934 1.815 1.255.195.106.376.09.516-.07.153-.177.67-.783.847-1.05.176-.268.353-.223.593-.133.24.09 1.527.72 1.79.85.263.13.438.196.503.31.065.113.065.658-.182 1.353z"/></svg>
                    <span>Konsultasi &amp; Pendaftaran</span>
                  </a>
                </div>
              </div>

            </div>
          </b-modal>

          <!-- ============================================ -->
          <!-- POP-UP MODAL KELAS 10/11 SMA                 -->
          <!-- ============================================ -->
          <b-modal
            v-model="modal10"
            size="xl"
            centered
            hide-footer
            hide-header
            content-class="p-0 border-0 rounded-24 custom-popup"
            modal-class="program-popup-modal"
          >
            <div class="popup-wrapper">
              <button class="popup-close-btn" v-on:click="modal10 = false" aria-label="Tutup Popup">&times;</button>
              
              <!-- Header Section -->
              <div class="popup-header-clean">
                <span class="popup-badge-clean badge-purple">PROGRAM REGULER KELAS 10 &amp; 11 SMA</span>
                <h2 class="popup-title-clean">KELAS 10 &amp; 11 SMA</h2>
                <h3 class="popup-subtitle-clean text-purple-theme">Pondasi Kuat Prestasi Rapor Sekolah &amp; Persiapan Dini Seleksi PTN</h3>
                <p class="popup-desc-clean">
                  Program bimbingan yang fokus pada penguasaan konsep dasar mata pelajaran sekolah, mendongkrak nilai rapor semester demi membuka peluang jalur SNBP, serta mengenalkan karakter soal penalaran UTBK-SNBT sejak awal secara bertahap.
                </p>

                <!-- Quick Highlights Bar -->
                <div class="popup-highlights-bar">
                  <div class="highlight-item" v-if="getProgramDetails('sma10').highlight1">
                    <span class="highlight-dot dot-purple"></span>
                    <span>{{ getProgramDetails('sma10').highlight1 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma10').highlight2">
                    <span class="highlight-dot dot-purple"></span>
                    <span>{{ getProgramDetails('sma10').highlight2 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma10').highlight3">
                    <span class="highlight-dot dot-purple"></span>
                    <span>{{ getProgramDetails('sma10').highlight3 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('sma10').highlight4">
                    <span class="highlight-dot dot-purple"></span>
                    <span>{{ getProgramDetails('sma10').highlight4 }}</span>
                  </div>
                </div>
              </div>

              <!-- Keunggulan & Fasilitas Program -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Keunggulan &amp; Fasilitas Belajar</h4>
                  <span class="section-subtitle-clean">Standar fasilitas bimbingan di seluruh cabang BTA Group</span>
                </div>
                <div class="popup-benefits-grid">
                  <div class="benefit-box border-purple">
                    <div class="benefit-num-tag num-purple">01</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Pemantapan Konsep Dasar</strong>
                      <p class="benefit-body">Penguasaan materi kurikulum sekolah secara terstruktur dan bertahap agar siswa tidak sekadar menghafal rumus melainkan paham konsep.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-purple">
                    <div class="benefit-num-tag num-purple">02</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Standby Teacher &amp; Tanya PR</strong>
                      <p class="benefit-body">Guru standby siap mendampingi pembahasan pekerjaan rumah (PR), tugas sekolah yang sulit, dan persiapan ulangan harian.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-purple">
                    <div class="benefit-num-tag num-purple">03</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Evaluasi PTS, PAS &amp; Try Out</strong>
                      <p class="benefit-body">Pembekalan dan latihan soal intensif menjelang Penilaian Tengah Semester dan Penilaian Akhir Semester untuk memaksimalkan nilai rapor.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-purple">
                    <div class="benefit-num-tag num-purple">04</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Pengenalan Dini Pola UTBK</strong>
                      <p class="benefit-body">Pembiasaan tipe soal penalaran dan literasi tingkat lanjut secara bertahap sejak kelas 10 dan 11 untuk kesiapan seleksi PTN.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tahapan Kurikulum Belajar -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Tahapan Program Belajar</h4>
                  <span class="section-subtitle-clean">Alur bimbingan akademik berkelanjutan</span>
                </div>
                <div class="popup-stages-grid">
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-purple">Fase 1</span>
                      <span class="stage-timing">Semester Ganjil</span>
                    </div>
                    <strong class="stage-name">Penguatan Konsep Mata Pelajaran</strong>
                    <p class="stage-desc">Review materi kurikulum sekolah secara mendalam agar siswa mampu mengikuti pembelajaran sekolah dengan percaya diri.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-purple">Fase 2</span>
                      <span class="stage-timing">Menjelang Ujian</span>
                    </div>
                    <strong class="stage-name">Persiapan PTS &amp; PAS</strong>
                    <p class="stage-desc">Pendampingan latihan soal intensif dan tryout ujian semester untuk mendongkrak capaian nilai rapor sekolah.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-purple">Fase 3</span>
                      <span class="stage-timing">Semester Genap</span>
                    </div>
                    <strong class="stage-name">Pengenalan Soal Skolastik &amp; Penalaran</strong>
                    <p class="stage-desc">Pengenalan pola soal tes potensi skolastik dan literasi dasar sebagai langkah awal persiapan seleksi PTN.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-purple">Fase 4</span>
                      <span class="stage-timing">Akhir Tahun Ajaran</span>
                    </div>
                    <strong class="stage-name">Evaluasi Rapor &amp; Konsultasi Jurusan</strong>
                    <p class="stage-desc">Pemetaan perkembangan nilai akademik siswa dan konsultasi awal arah minat program studi perguruan tinggi.</p>
                  </div>
                </div>
              </div>

              <!-- Pilihan Waktu Belajar (Pola Hari) -->
              <div class="popup-schedule-box">
                <div class="schedule-head-row">
                  <h5 class="schedule-title">Pilihan Pola Hari &amp; Waktu Belajar di Cabang</h5>
                  <span class="schedule-note">* Pilihan sesi disesuaikan dengan ketersediaan kuota masing-masing cabang</span>
                </div>
                <div class="schedule-cols-grid">
                  <div class="schedule-col" v-for="(col, sIdx) in (getProgramDetails('sma10').scheduleCols || [])" :key="sIdx">
                    <span class="sched-badge">{{ col.badge }}</span>
                    <p class="sched-text" v-html="col.text"></p>
                  </div>
                </div>
              </div>

              <!-- Materi yang Dipelajari -->
              <div class="popup-subjects-box">
                <h5 class="subjects-box-title">Mata Pelajaran yang Dipelajari</h5>
                <div class="subjects-tag-list">
                  <span class="subject-tag-clean tag-purple-clean">Matematika (Dasar &amp; Lanjut)</span>
                  <span class="subject-tag-clean tag-purple-clean">Fisika, Kimia, Biologi (Peminatan IPA)</span>
                  <span class="subject-tag-clean tag-purple-clean">Ekonomi, Geografi, Sosiologi, Sejarah (Peminatan IPS)</span>
                  <span class="subject-tag-clean tag-purple-clean">Bahasa Indonesia &amp; Bahasa Inggris</span>
                  <span class="subject-tag-clean tag-purple-clean">Pengenalan Tes Potensi Skolastik (TPS)</span>
                </div>
              </div>

              <!-- Cabang & WhatsApp Action Bar -->
              <div class="popup-action-card">
                <div class="action-card-left">
                  <span class="action-card-label">CABANG BIMBINGAN TERPILIH</span>
                  <div v-if="selectedCabang" class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title">{{ getSelectedCabangName() }}</h4>
                      <span class="action-branch-badge" :class="isAvailableInBranch('sma10') ? 'badge-available' : 'badge-unavailable'">
                        {{ isAvailableInBranch('sma10') ? 'Tersedia' : 'Belum Tersedia' }}
                      </span>
                    </div>
                    <p class="action-branch-desc" v-if="isAvailableInBranch('sma10')">
                      Program Kelas 10/11 SMA aktif dan dapat didaftarkan di cabang ini. Silakan hubungi admin cabang untuk konfirmasi kuota kelas.
                    </p>
                    <p class="action-branch-desc text-danger" v-else>
                      Program ini belum dibuka di cabang yang Anda pilih. Silakan pilih cabang alternatif BTA lainnya.
                    </p>
                  </div>
                  <div v-else class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title text-muted">Cabang Belum Dipilih</h4>
                    </div>
                    <p class="action-branch-desc">
                      Pilih cabang bimbingan terlebih dahulu untuk melihat ketersediaan jadwal dan kuota kelas.
                    </p>
                  </div>
                </div>
                <div class="action-card-right">
                  <div class="branch-dropdown-wrapper">
                    <button class="action-btn-secondary" v-on:click="showBranchDropdown = !showBranchDropdown">
                      <svg class="action-btn-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                      <span>{{ selectedCabang ? 'Ganti Cabang' : 'Pilih Cabang' }}</span>
                    </button>
                    <ul v-if="showBranchDropdown" class="action-dropdown-list">
                      <li v-for="b in primaryBranches" :key="b.id" v-on:click="selectCabangFromModal(b.id)" class="action-dropdown-item">
                        {{ b.name }}
                      </li>
                    </ul>
                  </div>
                  <a :href="getWhatsAppUrl('sma10')" target="_blank" class="action-btn-primary btn-purple-primary">
                    <svg class="action-btn-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 001.335 4.963L2 22l5.233-1.372a9.932 9.932 0 004.773 1.218h.004c5.502 0 9.986-4.478 9.988-9.986a9.974 9.974 0 00-2.925-7.064A9.948 9.948 0 0012.012 2zm5.787 14.41c-.247.696-1.443 1.265-1.996 1.328-.5.056-1.155.086-1.85-.14a11.39 11.39 0 01-4.708-3.08 10.375 10.375 0 01-2.096-3.23c-.332-.578-.65-1.258-.65-1.92 0-1.365.704-2.034.954-2.288.25-.254.67-.32.993-.32.105 0 .205.003.29.008.25.013.376.03.54.37.202.42.693 1.693.753 1.82.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.3-.36.42-.12.12-.24.25-.1.49a8.125 8.125 0 001.522 1.884c.642.57 1.182.934 1.815 1.255.195.106.376.09.516-.07.153-.177.67-.783.847-1.05.176-.268.353-.223.593-.133.24.09 1.527.72 1.79.85.263.13.438.196.503.31.065.113.065.658-.182 1.353z"/></svg>
                    <span>Konsultasi &amp; Pendaftaran</span>
                  </a>
                </div>
              </div>

            </div>
          </b-modal>

          <!-- ============================================ -->
          <!-- POP-UP MODAL KELAS 8/9 SMP                   -->
          <!-- ============================================ -->
          <b-modal
            v-model="modal9"
            size="xl"
            centered
            hide-footer
            hide-header
            content-class="p-0 border-0 rounded-24 custom-popup"
            modal-class="program-popup-modal"
          >
            <div class="popup-wrapper">
              <button class="popup-close-btn" v-on:click="modal9 = false" aria-label="Tutup Popup">&times;</button>
              
              <!-- Header Section -->
              <div class="popup-header-clean">
                <span class="popup-badge-clean badge-blue">PROGRAM REGULER KELAS 7, 8 &amp; 9 SMP</span>
                <h2 class="popup-title-clean">KELAS 7, 8 &amp; 9 SMP</h2>
                <h3 class="popup-subtitle-clean text-blue-theme">Bimbingan Prestasi Akademik Sekolah &amp; Sukses Masuk SMA/SMK Unggulan</h3>
                <p class="popup-desc-clean">
                  Program bimbingan komprehensif untuk mendongkrak penguasaan konsep dasar sains, matematika, dan bahasa, mengoptimalkan nilai rapor sekolah, serta mempersiapkan siswa sedini mungkin menembus SMA/SMK negeri dan swasta favorit.
                </p>

                <!-- Quick Highlights Bar -->
                <div class="popup-highlights-bar">
                  <div class="highlight-item" v-if="getProgramDetails('smp').highlight1">
                    <span class="highlight-dot dot-blue"></span>
                    <span>{{ getProgramDetails('smp').highlight1 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('smp').highlight2">
                    <span class="highlight-dot dot-blue"></span>
                    <span>{{ getProgramDetails('smp').highlight2 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('smp').highlight3">
                    <span class="highlight-dot dot-blue"></span>
                    <span>{{ getProgramDetails('smp').highlight3 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('smp').highlight4">
                    <span class="highlight-dot dot-blue"></span>
                    <span>{{ getProgramDetails('smp').highlight4 }}</span>
                  </div>
                </div>
              </div>

              <!-- Keunggulan & Fasilitas Program -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Keunggulan &amp; Fasilitas Belajar</h4>
                  <span class="section-subtitle-clean">Standar fasilitas bimbingan di seluruh cabang BTA Group</span>
                </div>
                <div class="popup-benefits-grid">
                  <div class="benefit-box border-blue">
                    <div class="benefit-num-tag num-blue">01</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Kelas Semi-Privat &amp; Nyaman</strong>
                      <p class="benefit-body">Kapasitas terbatas 10–15 siswa per kelas memastikan pengajar dapat membimbing dan memantau pemahaman setiap anak secara personal dan interaktif.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-blue">
                    <div class="benefit-num-tag num-blue">02</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Standby Teacher &amp; Tanya PR</strong>
                      <p class="benefit-body">Fasilitas konsultasi di luar jam les reguler untuk membantu pengerjaan PR sekolah, persiapan ulangan harian, dan review materi yang belum dipahami.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-blue">
                    <div class="benefit-num-tag num-blue">03</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Try Out &amp; Evaluasi Berkala</strong>
                      <p class="benefit-body">Simulasi ujian rutin berstandar Asesmen Nasional dan Ujian Sekolah dengan pembahasan detail serta laporan evaluasi hasil belajar ke orang tua.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-blue">
                    <div class="benefit-num-tag num-blue">04</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Persiapan Masuk SMA Favorit</strong>
                      <p class="benefit-body">Pembekalan materi khusus seleksi masuk SMA unggulan (SMA Negeri Favorit, Labschool, dsb.) termasuk latihan tes potensi skolastik dan akademik.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tahapan Kurikulum Belajar -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Tahapan Program Belajar</h4>
                  <span class="section-subtitle-clean">Alur kurikulum terstruktur menuju prestasi maksimal</span>
                </div>
                <div class="popup-stages-grid">
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-blue">Fase 1</span>
                      <span class="stage-timing">Semester 1</span>
                    </div>
                    <strong class="stage-name">Penguatan Konsep Dasar</strong>
                    <p class="stage-desc">Pendalaman materi semester ganjil kurikulum sekolah, latihan soal konseptual, dan persiapan Penilaian Tengah Semester (PTS/STS).</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-blue">Fase 2</span>
                      <span class="stage-timing">Semester 2</span>
                    </div>
                    <strong class="stage-name">Pemantapan Materi &amp; Rapor</strong>
                    <p class="stage-desc">Penguasaan materi semester genap untuk meraih nilai rapor optimal, persiapan Penilaian Akhir Tahun (PAT/SAS), dan review berkala.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-blue">Fase 3</span>
                      <span class="stage-timing">Semester 2 (Kls 9)</span>
                    </div>
                    <strong class="stage-name">Persiapan Ujian Sekolah</strong>
                    <p class="stage-desc">Pendalaman materi gabungan kelas 7–9, drilling soal-soal Asesmen Sumatif Akhir Jenjang, dan simulasi ujian sekolah berstandar tinggi.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-blue">Fase 4</span>
                      <span class="stage-timing">Menjelang Kelulusan</span>
                    </div>
                    <strong class="stage-name">Sukses Masuk SMA Pilihan</strong>
                    <p class="stage-desc">Pembekalan materi tes seleksi masuk SMA favorit, konsultasi jalur PPDB (Zonasi, Prestasi, Afirmasi), dan tes kemampuan skolastik.</p>
                  </div>
                </div>
              </div>

              <!-- Pilihan Waktu Belajar (Pola Hari) -->
              <div class="popup-schedule-box">
                <div class="schedule-head-row">
                  <h5 class="schedule-title">Pilihan Pola Hari &amp; Waktu Belajar di Cabang</h5>
                  <span class="schedule-note">* Pilihan sesi disesuaikan dengan ketersediaan kuota masing-masing cabang</span>
                </div>
                <div class="schedule-cols-grid">
                  <div class="schedule-col" v-for="(col, sIdx) in (getProgramDetails('smp').scheduleCols || [])" :key="sIdx">
                    <span class="sched-badge">{{ col.badge }}</span>
                    <p class="sched-text" v-html="col.text"></p>
                  </div>
                </div>
              </div>

              <!-- Materi yang Dipelajari -->
              <div class="popup-subjects-box">
                <h5 class="subjects-box-title">Mata Pelajaran yang Dipelajari</h5>
                <div class="subjects-tag-list">
                  <span class="subject-tag-clean tag-blue-clean">Matematika (Aljabar, Geometri, Statistika)</span>
                  <span class="subject-tag-clean tag-blue-clean">IPA (Fisika, Biologi, Kimia Terapan)</span>
                  <span class="subject-tag-clean tag-blue-clean">Bahasa Indonesia (Literasi &amp; Teks)</span>
                  <span class="subject-tag-clean tag-blue-clean">Bahasa Inggris (Grammar &amp; Reading)</span>
                  <span class="subject-tag-clean tag-blue-clean">IPS Terpadu (Sejarah, Geografi, Ekonomi)</span>
                  <span class="subject-tag-clean tag-blue-clean">Latihan Skolastik / Penalaran Masuk SMA</span>
                </div>
              </div>

              <!-- Cabang & WhatsApp Action Bar -->
              <div class="popup-action-card">
                <div class="action-card-left">
                  <span class="action-card-label">CABANG BIMBINGAN TERPILIH</span>
                  <div v-if="selectedCabang" class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title">{{ getSelectedCabangName() }}</h4>
                      <span class="action-branch-badge" :class="isAvailableInBranch('smp') ? 'badge-available' : 'badge-unavailable'">
                        {{ isAvailableInBranch('smp') ? 'Tersedia' : 'Belum Tersedia' }}
                      </span>
                    </div>
                    <p class="action-branch-desc" v-if="isAvailableInBranch('smp')">
                      Program Kelas SMP aktif dan dapat didaftarkan di cabang ini. Silakan hubungi admin cabang untuk konfirmasi kuota kelas.
                    </p>
                    <p class="action-branch-desc text-danger" v-else>
                      Program ini belum dibuka di cabang yang Anda pilih. Silakan pilih cabang alternatif BTA lainnya.
                    </p>
                  </div>
                  <div v-else class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title text-muted">Cabang Belum Dipilih</h4>
                    </div>
                    <p class="action-branch-desc">
                      Pilih cabang bimbingan terlebih dahulu untuk melihat ketersediaan jadwal dan kuota kelas.
                    </p>
                  </div>
                </div>
                <div class="action-card-right">
                  <div class="branch-dropdown-wrapper">
                    <button class="action-btn-secondary" v-on:click="showBranchDropdown = !showBranchDropdown">
                      <svg class="action-btn-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                      <span>{{ selectedCabang ? 'Ganti Cabang' : 'Pilih Cabang' }}</span>
                    </button>
                    <ul v-if="showBranchDropdown" class="action-dropdown-list">
                      <li v-for="b in primaryBranches" :key="b.id" v-on:click="selectCabangFromModal(b.id)" class="action-dropdown-item">
                        {{ b.name }}
                      </li>
                    </ul>
                  </div>
                  <a :href="getWhatsAppUrl('smp')" target="_blank" class="action-btn-primary btn-blue-primary">
                    <svg class="action-btn-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 001.335 4.963L2 22l5.233-1.372a9.932 9.932 0 004.773 1.218h.004c5.502 0 9.986-4.478 9.988-9.986a9.974 9.974 0 00-2.925-7.064A9.948 9.948 0 0012.012 2zm5.787 14.41c-.247.696-1.443 1.265-1.996 1.328-.5.056-1.155.086-1.85-.14a11.39 11.39 0 01-4.708-3.08 10.375 10.375 0 01-2.096-3.23c-.332-.578-.65-1.258-.65-1.92 0-1.365.704-2.034.954-2.288.25-.254.67-.32.993-.32.105 0 .205.003.29.008.25.013.376.03.54.37.202.42.693 1.693.753 1.82.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.3-.36.42-.12.12-.24.25-.1.49a8.125 8.125 0 001.522 1.884c.642.57 1.182.934 1.815 1.255.195.106.376.09.516-.07.153-.177.67-.783.847-1.05.176-.268.353-.223.593-.133.24.09 1.527.72 1.79.85.263.13.438.196.503.31.065.113.065.658-.182 1.353z"/></svg>
                    <span>Konsultasi &amp; Pendaftaran</span>
                  </a>
                </div>
              </div>

            </div>
          </b-modal>

          <!-- ============================================ -->
          <!-- POP-UP MODAL ALUMNI / GAP YEAR               -->
          <!-- ============================================ -->
          <b-modal
            v-model="modalAl"
            size="xl"
            centered
            hide-footer
            hide-header
            content-class="p-0 border-0 rounded-24 custom-popup"
            modal-class="program-popup-modal"
          >
            <div class="popup-wrapper">
              <button class="popup-close-btn" v-on:click="modalAl = false" aria-label="Tutup Popup">&times;</button>
              
              <!-- Header Section -->
              <div class="popup-header-clean">
                <span class="popup-badge-clean badge-green">PROGRAM INTENSIF ALUMNI &amp; GAP YEAR</span>
                <h2 class="popup-title-clean">PROGRAM ALUMNI &amp; GAP YEAR</h2>
                <h3 class="popup-subtitle-clean text-green-theme">Bimbingan Penuh Waktu Menuju PTN &amp; Sekolah Kedinasan Impian</h3>
                <p class="popup-desc-clean">
                  Program intensif khusus bagi lulusan SMA atau gap year yang berfokus penuh menembus universitas negeri impian. Pembelajaran terstruktur dari konsep dasar hingga drilling soal level tinggi untuk UTBK-SNBT, SIMAK UI, CBT UGM, serta Ujian Mandiri lainnya.
                </p>

                <!-- Quick Highlights Bar -->
                <div class="popup-highlights-bar">
                  <div class="highlight-item" v-if="getProgramDetails('alumni').highlight1">
                    <span class="highlight-dot dot-green"></span>
                    <span>{{ getProgramDetails('alumni').highlight1 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('alumni').highlight2">
                    <span class="highlight-dot dot-green"></span>
                    <span>{{ getProgramDetails('alumni').highlight2 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('alumni').highlight3">
                    <span class="highlight-dot dot-green"></span>
                    <span>{{ getProgramDetails('alumni').highlight3 }}</span>
                  </div>
                  <div class="highlight-item" v-if="getProgramDetails('alumni').highlight4">
                    <span class="highlight-dot dot-green"></span>
                    <span>{{ getProgramDetails('alumni').highlight4 }}</span>
                  </div>
                </div>
              </div>

              <!-- Keunggulan & Fasilitas Program -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Keunggulan &amp; Fasilitas Belajar</h4>
                  <span class="section-subtitle-clean">Standar fasilitas bimbingan di seluruh cabang BTA Group</span>
                </div>
                <div class="popup-benefits-grid">
                  <div class="benefit-box border-green">
                    <div class="benefit-num-tag num-green">01</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Program Belajar Penuh Waktu</strong>
                      <p class="benefit-body">Jadwal belajar pagi hingga siang yang kondusif agar siswa fokus penuh mempersiapkan tes tanpa terpecah tugas sekolah.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-green">
                    <div class="benefit-num-tag num-green">02</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Drilling Soal Prediktif &amp; IRT</strong>
                      <p class="benefit-body">Latihan ribuan bank soal UTBK &amp; Mandiri terupdate dengan sistem penilaian IRT dan analisis kelemahan per subtes secara detail.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-green">
                    <div class="benefit-num-tag num-green">03</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Konsultasi &amp; Rasionalisasi PTN</strong>
                      <p class="benefit-body">Pendampingan strategi pemilihan jurusan dan universitas impian secara personal berbasis pemetaan histori passing grade.</p>
                    </div>
                  </div>
                  <div class="benefit-box border-green">
                    <div class="benefit-num-tag num-green">04</div>
                    <div class="benefit-text">
                      <strong class="benefit-head">Supercamp / Drilling Intensif</strong>
                      <p class="benefit-body">Sesi bedah materi super intensif dan pendalaman soal-soal tingkat lanjut bersama master teacher menjelang gelombang ujian.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tahapan Kurikulum Belajar -->
              <div class="popup-section-clean">
                <div class="section-title-row">
                  <h4 class="section-title-clean">Tahapan Program Belajar</h4>
                  <span class="section-subtitle-clean">Alur kurikulum terstruktur menuju seleksi PTN</span>
                </div>
                <div class="popup-stages-grid">
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-green">Fase 1</span>
                      <span class="stage-timing">Bulan Awal</span>
                    </div>
                    <strong class="stage-name">Re-Building Konsep Dasar</strong>
                    <p class="stage-desc">Membangun kembali fondasi konsep materi TPS, Penalaran Matematika, Literasi, dan TKA dari dasar secara mendalam.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-green">Fase 2</span>
                      <span class="stage-timing">Pertengahan</span>
                    </div>
                    <strong class="stage-name">Drilling Tipe Soal &amp; Trik Cepat</strong>
                    <p class="stage-desc">Melatih kecepatan dan akurasi menyelesaikan soal HOTS (Higher Order Thinking Skills) dengan teknik eliminasi dan manajemen waktu.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-green">Fase 3</span>
                      <span class="stage-timing">Jelang UTBK</span>
                    </div>
                    <strong class="stage-name">Simulasi Try Out Maraton</strong>
                    <p class="stage-desc">Simulasi rutin dengan software dan format standar SNPMB, evaluasi perankingan nasional, dan penguatan ketahanan mental ujian.</p>
                  </div>
                  <div class="stage-card">
                    <div class="stage-badge-row">
                      <span class="stage-pill pill-green">Fase 4</span>
                      <span class="stage-timing">Pasca UTBK</span>
                    </div>
                    <strong class="stage-name">Fokus Seleksi Mandiri PTN</strong>
                    <p class="stage-desc">Pendalaman materi khusus SIMAK UI, CBT UGM, SM ITB, Undip, Unair, serta seleksi masuk Sekolah Kedinasan.</p>
                  </div>
                </div>
              </div>

              <!-- Pilihan Waktu Belajar (Pola Hari) -->
              <div class="popup-schedule-box">
                <div class="schedule-head-row">
                  <h5 class="schedule-title">Pilihan Pola Hari &amp; Waktu Belajar di Cabang</h5>
                  <span class="schedule-note">* Pilihan sesi disesuaikan dengan ketersediaan kuota masing-masing cabang</span>
                </div>
                <div class="schedule-cols-grid">
                  <div class="schedule-col" v-for="(col, sIdx) in (getProgramDetails('alumni').scheduleCols || [])" :key="sIdx">
                    <span class="sched-badge">{{ col.badge }}</span>
                    <p class="sched-text" v-html="col.text"></p>
                  </div>
                </div>
              </div>

              <!-- Materi yang Dipelajari -->
              <div class="popup-subjects-box">
                <h5 class="subjects-box-title">Mata Pelajaran yang Dipelajari</h5>
                <div class="subjects-tag-list">
                  <span class="subject-tag-clean tag-green-clean">TPS (Penalaran Umum, Pengetahuan Kuantitatif, PPU, PBM)</span>
                  <span class="subject-tag-clean tag-green-clean">Literasi Bahasa Indonesia &amp; Bahasa Inggris</span>
                  <span class="subject-tag-clean tag-green-clean">Penalaran Matematika Standar SNBT</span>
                  <span class="subject-tag-clean tag-green-clean">TKA Saintek (Fisika, Kimia, Biologi, Matematika Lanjut)</span>
                  <span class="subject-tag-clean tag-green-clean">TKA Soshum (Ekonomi, Sejarah, Sosiologi, Geografi)</span>
                  <span class="subject-tag-clean tag-green-clean">Materi Khusus Ujian Mandiri (SIMAK UI &amp; CBT UGM)</span>
                </div>
              </div>

              <!-- Cabang & WhatsApp Action Bar -->
              <div class="popup-action-card">
                <div class="action-card-left">
                  <span class="action-card-label">CABANG BIMBINGAN TERPILIH</span>
                  <div v-if="selectedCabang" class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title">{{ getSelectedCabangName() }}</h4>
                      <span class="action-branch-badge" :class="isAvailableInBranch('alumni') ? 'badge-available' : 'badge-unavailable'">
                        {{ isAvailableInBranch('alumni') ? 'Tersedia' : 'Belum Tersedia' }}
                      </span>
                    </div>
                    <p class="action-branch-desc" v-if="isAvailableInBranch('alumni')">
                      Program Alumni aktif dan dapat didaftarkan di cabang ini. Silakan hubungi admin cabang untuk konfirmasi kuota kelas.
                    </p>
                    <p class="action-branch-desc text-danger" v-else>
                      Program ini belum dibuka di cabang yang Anda pilih. Silakan pilih cabang alternatif BTA lainnya.
                    </p>
                  </div>
                  <div v-else class="action-branch-info">
                    <div class="action-branch-name-row">
                      <h4 class="action-branch-title text-muted">Cabang Belum Dipilih</h4>
                    </div>
                    <p class="action-branch-desc">
                      Pilih cabang bimbingan terlebih dahulu untuk melihat ketersediaan jadwal dan kuota kelas.
                    </p>
                  </div>
                </div>
                <div class="action-card-right">
                  <div class="branch-dropdown-wrapper">
                    <button class="action-btn-secondary" v-on:click="showBranchDropdown = !showBranchDropdown">
                      <svg class="action-btn-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                      <span>{{ selectedCabang ? 'Ganti Cabang' : 'Pilih Cabang' }}</span>
                    </button>
                    <ul v-if="showBranchDropdown" class="action-dropdown-list">
                      <li v-for="b in primaryBranches" :key="b.id" v-on:click="selectCabangFromModal(b.id)" class="action-dropdown-item">
                        {{ b.name }}
                      </li>
                    </ul>
                  </div>
                  <a :href="getWhatsAppUrl('alumni')" target="_blank" class="action-btn-primary btn-green-primary">
                    <svg class="action-btn-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 001.335 4.963L2 22l5.233-1.372a9.932 9.932 0 004.773 1.218h.004c5.502 0 9.986-4.478 9.988-9.986a9.974 9.974 0 00-2.925-7.064A9.948 9.948 0 0012.012 2zm5.787 14.41c-.247.696-1.443 1.265-1.996 1.328-.5.056-1.155.086-1.85-.14a11.39 11.39 0 01-4.708-3.08 10.375 10.375 0 01-2.096-3.23c-.332-.578-.65-1.258-.65-1.92 0-1.365.704-2.034.954-2.288.25-.254.67-.32.993-.32.105 0 .205.003.29.008.25.013.376.03.54.37.202.42.693 1.693.753 1.82.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.3-.36.42-.12.12-.24.25-.1.49a8.125 8.125 0 001.522 1.884c.642.57 1.182.934 1.815 1.255.195.106.376.09.516-.07.153-.177.67-.783.847-1.05.176-.268.353-.223.593-.133.24.09 1.527.72 1.79.85.263.13.438.196.503.31.065.113.065.658-.182 1.353z"/></svg>
                    <span>Konsultasi &amp; Pendaftaran</span>
                  </a>
                </div>
              </div>

            </div>
          </b-modal>

        </section>
        <!-- ===============================================-->
        <!-- Penutup Program Bimbingan Section              -->
        <!-- ===============================================-->

        <!-- CABANG TERDEKAT SECTION (Interactive Map) -->
        <!-- ============================================-->
        <section id="cabang" class="bta-cabang-section">
          <div class="container">
            <!-- Header section -->
            <div class="row mb-4 mb-md-5">
              <div class="col-lg-8 mx-auto text-center">
                <div class="mb-2 mb-md-3">
                  <div class="bta-cabang-badge">
                    <span>📍</span> 13 CABANG BTA GROUP
                  </div>
                </div>
                <h2 class="bta-cabang-title">
                  Temukan <span style="color: #E12029;">Cabang BTA</span> Terdekat
                </h2>
                <p class="bta-cabang-subtitle">
                  Belajar lebih nyaman di cabang yang sesuai dengan lokasi dan kebutuhanmu.
                </p>
              </div>
            </div>

            <!-- Two Column Layout -->
            <div class="row g-4 align-items-stretch">
              
              <!-- Sidebar Info (Left Column) -->
              <div class="col-lg-4 d-flex flex-column">
                <div class="bta-cabang-card card w-100 border-0 shadow-sm position-relative">
                  
                  <!-- Dynamic Content State -->
                  <div class="d-flex flex-column h-100 justify-content-between">
                    
                    <!-- STATE 1: Default Instructions (No Active Branch Selected) -->
                    <div v-if="!activeBranch || !activeBranchMeta" class="d-flex flex-column h-100 justify-content-between">
                      
                      <!-- Collage Suasana Cabang (Menggunakan Foto Lokal BTA) -->
                      <div class="bta-collage-container">
                        <div class="bta-collage-main">
                          <img src="/static/images/page/about/bta_building.jpg" alt="Gedung Cabang BTA" />
                        </div>
                        <div class="bta-collage-sub-tr">
                          <img src="/static/images/page/about/classroom.jpg" alt="Ruang Belajar BTA" />
                        </div>
                        <div class="bta-collage-sub-bl">
                          <img src="/static/images/page/about/students_studying.jpg" alt="Siswa BTA Berdiskusi" />
                        </div>
                        <div class="bta-collage-sub-br">
                          <img src="/static/images/page/about/cafeteria.jpg" alt="Fasilitas BTA" />
                        </div>
                      </div>

                      <div class="mb-3">
                        <h4 class="bta-instruction-title">
                          Pilih cabang pada peta untuk melihat informasi lokasi
                        </h4>
                      </div>

                      <!-- Instructions Steps list -->
                      <div class="bta-step-list flex-grow-1">
                        <div class="bta-step-item">
                          <div class="bta-step-num">1</div>
                          <div>
                            <strong class="bta-step-name">Klik salah satu pin</strong>
                            <span class="bta-step-desc">Pilih cabang BTA yang ingin kamu ketahui</span>
                          </div>
                        </div>
                        <div class="bta-step-item">
                          <div class="bta-step-num">2</div>
                          <div>
                            <strong class="bta-step-name">Lihat informasi cabang</strong>
                            <span class="bta-step-desc">Dapatkan detail alamat, kontak, dan fasilitas</span>
                          </div>
                        </div>
                        <div class="bta-step-item">
                          <div class="bta-step-num">3</div>
                          <div>
                            <strong class="bta-step-name">Kunjungi cabang</strong>
                            <span class="bta-step-desc">Temukan rute terbaik menuju lokasi belajar</span>
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- STATE 2: Detailed Branch Info (When Active Branch is Set) -->
                    <div v-else class="d-flex flex-column h-100 justify-content-between">
                      
                      <!-- Back button -->
                      <button @click="activeBranchId = ''" class="bta-back-btn btn btn-sm btn-link text-muted font-weight-bold p-0 mb-3 text-start">
                        ← Kembali ke Panduan
                      </button>

                      <!-- Branch Image Hero -->
                      <div class="bta-branch-img-wrapper position-relative overflow-hidden mb-3">
                        <img :src="activeBranchMeta.image" alt="Suasana Cabang" class="bta-branch-cover-img" @error="$event.target.style.display='none'" />
                        <div class="bta-branch-title-overlay">
                          <h3 class="bta-branch-hero-title">
                            {{ activeBranch.name }}
                          </h3>
                        </div>
                      </div>

                      <!-- Details Body -->
                      <div class="bta-branch-details-body flex-grow-1">
                        
                        <!-- Status indicator -->
                        <div class="d-flex align-items-center mb-1">
                          <span class="badge" :class="selectedCabang === activeBranch.id ? 'bta-badge-selected' : 'bta-badge-alt'">
                            {{ selectedCabang === activeBranch.id ? '📍 Cabang Pilihanmu ✓' : '📍 Cabang Alternatif' }}
                          </span>
                        </div>

                        <!-- Alamat -->
                        <div class="bta-info-row">
                          <span class="bta-info-icon">📍</span>
                          <div>
                            <strong class="bta-info-label">Alamat</strong>
                            <span class="bta-info-val">{{ activeBranchMeta.address }}</span>
                          </div>
                        </div>

                        <!-- Telepon -->
                        <div class="bta-info-row">
                          <span class="bta-info-icon">☎️</span>
                          <div>
                            <strong class="bta-info-label">Kontak Telepon</strong>
                            <span class="bta-info-val">{{ activeBranchMeta.phone }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Interactive CTA & Navigation Controls -->
                      <div class="bta-branch-controls mt-auto border-top pt-3">
                        
                        <!-- Tombol Tambahan: Detail Program Cabang Ini (di atas tombol Google Maps) -->
                        <button @click="goToProgramCabang(activeBranch.id)" class="btn btn-danger w-100 mb-2 py-2 font-weight-bold shadow-sm d-flex align-items-center justify-content-center bta-btn-program">
                          <span>📚</span>
                          <span>Lihat Detail Program Cabang Ini</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                          </svg>
                        </button>

                        <!-- Route to Google Maps -->
                        <a :href="activeBranchMeta.mapsUrl" target="_blank" rel="noopener noreferrer" class="btn btn-outline-danger w-100 mb-2 py-2 font-weight-bold bta-btn-maps">
                          Lihat di Google Maps ↗
                        </a>

                        <!-- Global Sync Selection button (jika belum terpilih) -->
                        <button v-if="selectedCabang !== activeBranch.id" @click="updateGlobalCabang(activeBranch.id)" class="btn btn-light w-100 py-2 font-weight-bold mb-1 bta-btn-select-branch">
                          ✓ Jadikan Cabang Pilihan
                        </button>

                        <!-- Carousel Prev/Next Navigation links -->
                        <div class="d-flex justify-content-between align-items-center mt-3 px-1 bta-branch-nav-links">
                          <button @click="navigateBranch('prev')" class="btn btn-link text-muted p-0">← Cabang Sebelumnya</button>
                          <span>·</span>
                          <button @click="navigateBranch('next')" class="btn btn-link text-muted p-0">Cabang Berikutnya →</button>
                        </div>

                      </div>

                    </div>

                  </div>

                  <!-- Skyline decor overlay -->
                  <div class="skyline-decor position-absolute bottom-0 left-0 right-0 pointer-events-none">
                    <svg viewBox="0 0 400 100" fill="#E12029" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
                      <rect x="10" y="50" width="20" height="50" />
                      <rect x="35" y="30" width="25" height="70" />
                      <rect x="65" y="60" width="15" height="40" />
                      <rect x="85" y="45" width="30" height="55" />
                      <rect x="120" y="20" width="25" height="80" />
                      <rect x="150" y="55" width="20" height="45" />
                      <rect x="175" y="40" width="35" height="60" />
                      <rect x="215" y="65" width="15" height="35" />
                      <rect x="235" y="30" width="30" height="70" />
                      <rect x="270" y="50" width="25" height="50" />
                      <rect x="300" y="15" width="20" height="85" />
                      <rect x="325" y="45" width="30" height="55" />
                      <rect x="360" y="55" width="25" height="45" />
                    </svg>
                  </div>
                  
                </div>
              </div>

              <!-- Map Container Panel (Right Column) -->
              <div class="col-lg-8 d-flex flex-column">
                <div class="bta-cabang-map-card card w-100 border-0 shadow-sm">
                  <!-- Leaflet Map mounts here -->
                  <div id="map-cabang"></div>
                </div>
              </div>

            </div>

            <!-- POP-UP PILIH JENJANG PROGRAM DI CABANG INI -->
            <b-modal
              v-model="modalBranchPrograms"
              size="lg"
              centered
              hide-footer
              hide-header
              content-class="p-0 border-0 rounded-24 custom-popup"
              modal-class="branch-program-modal"
            >
              <div class="popup-wrapper">
                <button class="popup-close-btn" v-on:click="modalBranchPrograms = false">&times;</button>
                
                <!-- Modal Header -->
                <div class="text-center pt-2 pb-3 border-bottom">
                  <div class="d-inline-flex align-items-center mb-2">
                    <span class="badge bta-badge-selected px-3 py-1 font-weight-bold" style="font-size: 0.8rem;">
                      📍 {{ activeBranch ? activeBranch.name : 'Cabang BTA' }}
                    </span>
                  </div>
                  <h3 class="font-weight-bold text-dark mb-1" style="font-size: 1.45rem;">
                    Pilih Jenjang Program Bimbingan
                  </h3>
                  <p class="text-muted small mb-0" style="max-width: 520px; margin: 0 auto; line-height: 1.45;">
                    Pilih jenjang bimbingan untuk melihat rincian kurikulum, jadwal belajar, dan konsultasi pendaftaran di cabang ini:
                  </p>
                </div>

                <!-- 4 Program Options Grid -->
                <div class="branch-prog-picker-grid py-3">
                  
                  <!-- Option 1: Kelas 12 SMA -->
                  <div 
                    class="branch-prog-card card-orange" 
                    :class="{ 'branch-prog-disabled': !isProgramAvailable(activeBranch, 'sma12') }"
                    @click="isProgramAvailable(activeBranch, 'sma12') ? selectBranchProgram('12') : null"
                  >
                    <div class="branch-prog-card-top">
                      <span class="branch-prog-pill bg-orange-soft">🚀 Unggulan PTN</span>
                      <span class="branch-prog-arrow">{{ isProgramAvailable(activeBranch, 'sma12') ? '→' : '✕' }}</span>
                    </div>
                    <h4 class="branch-prog-title">Kelas 12 SMA &amp; UTBK</h4>
                    <p class="branch-prog-desc">Persiapan komprehensif tembus PTN &amp; Jurusan Impian (SNBT &amp; Mandiri).</p>
                    <div v-if="isProgramAvailable(activeBranch, 'sma12')" class="branch-prog-action text-orange">Lihat Detail Program &rarr;</div>
                    <div v-else class="branch-prog-action text-danger font-italic small font-weight-bold">⚠️ Tidak tersedia di cabang ini</div>
                  </div>

                  <!-- Option 2: Kelas 10/11 SMA -->
                  <div 
                    class="branch-prog-card card-purple" 
                    :class="{ 'branch-prog-disabled': !isProgramAvailable(activeBranch, 'sma10') }"
                    @click="isProgramAvailable(activeBranch, 'sma10') ? selectBranchProgram('10') : null"
                  >
                    <div class="branch-prog-card-top">
                      <span class="branch-prog-pill bg-purple-soft">📚 Pondasi &amp; Rapor</span>
                      <span class="branch-prog-arrow">{{ isProgramAvailable(activeBranch, 'sma10') ? '→' : '✕' }}</span>
                    </div>
                    <h4 class="branch-prog-title">Kelas 10 &amp; 11 SMA</h4>
                    <p class="branch-prog-desc">Pemahaman konsep mendalam sekolah &amp; persiapan jalur prestasi SNBP.</p>
                    <div v-if="isProgramAvailable(activeBranch, 'sma10')" class="branch-prog-action text-purple">Lihat Detail Program &rarr;</div>
                    <div v-else class="branch-prog-action text-danger font-italic small font-weight-bold">⚠️ Tidak tersedia di cabang ini</div>
                  </div>

                  <!-- Option 3: Kelas 7/8/9 SMP -->
                  <div 
                    class="branch-prog-card card-blue" 
                    :class="{ 'branch-prog-disabled': !isProgramAvailable(activeBranch, 'smp') }"
                    @click="isProgramAvailable(activeBranch, 'smp') ? selectBranchProgram('9') : null"
                  >
                    <div class="branch-prog-card-top">
                      <span class="branch-prog-pill bg-blue-soft">🎒 Masuk SMA Favorit</span>
                      <span class="branch-prog-arrow">{{ isProgramAvailable(activeBranch, 'smp') ? '→' : '✕' }}</span>
                    </div>
                    <h4 class="branch-prog-title">Kelas 7, 8 &amp; 9 SMP</h4>
                    <p class="branch-prog-desc">Kuasai pelajaran sekolah &amp; persiapan masuk SMA Unggulan / Titian.</p>
                    <div v-if="isProgramAvailable(activeBranch, 'smp')" class="branch-prog-action text-blue">Lihat Detail Program &rarr;</div>
                    <div v-else class="branch-prog-action text-danger font-italic small font-weight-bold">⚠️ Tidak tersedia di cabang ini</div>
                  </div>

                  <!-- Option 4: Alumni / Gap Year -->
                  <div 
                    class="branch-prog-card card-green" 
                    :class="{ 'branch-prog-disabled': !isProgramAvailable(activeBranch, 'alumni') }"
                    @click="isProgramAvailable(activeBranch, 'alumni') ? selectBranchProgram('al') : null"
                  >
                    <div class="branch-prog-card-top">
                      <span class="branch-prog-pill bg-green-soft">🎯 Spesialis PTN</span>
                      <span class="branch-prog-arrow">{{ isProgramAvailable(activeBranch, 'alumni') ? '→' : '✕' }}</span>
                    </div>
                    <h4 class="branch-prog-title">Alumni / Gap Year</h4>
                    <p class="branch-prog-desc">Fokus belajar intensif satu tahun penuh untuk menembus PTN impian.</p>
                    <div v-if="isProgramAvailable(activeBranch, 'alumni')" class="branch-prog-action text-green">Lihat Detail Program &rarr;</div>
                    <div v-else class="branch-prog-action text-danger font-italic small font-weight-bold">⚠️ Tidak tersedia di cabang ini</div>
                  </div>

                </div>

                <!-- Footer info & link to full section -->
                <div class="text-center pt-2 pb-1 border-top d-flex justify-content-center align-items-center flex-wrap gap-2">
                  <span class="text-muted small">Ingin melihat perbandingan semua program di halaman?</span>
                  <button @click="modalBranchPrograms = false; scrollToServices();" class="btn btn-link btn-sm text-danger p-0 font-weight-bold" style="text-decoration: none;">
                    Bandingkan Semua Program &darr;
                  </button>
                </div>

              </div>
            </b-modal>

          </div>
        </section>

        <!-- ============================================-->
        <!-- PENUTUP CABANG TERDEKAT SECTION (Interactive Map) -->
        <!-- ============================================-->

        
        <!-- ============================================-->
        <!-- BENEFITS SECTION -->
        <!-- ============================================-->

        <section class="py-5 bg-white" id="benefits">
          <div class="container">
            <div class="benefits-card position-relative shadow-sm">
              
              <!-- GAMBAR MOCKUP LAPTOP & HP (Desktop View - Menggunakan sistembaru.png) -->
              <img src="/static/images/page/about/sistembaru.png" alt="Sistem E-Learning BTA" class="d-none d-lg-block card-mockup-img-desktop">
              
              <div class="row align-items-center">
                <!-- Content Column (Kiri) -->
                <div class="col-lg-8 col-xl-9 position-relative" style="z-index: 2;">
                  <h2 class="benefits-title">
                    Nikmati Keuntungan Sistem <span class="benefits-title-highlight">E-Learning</span> BTA Group
                  </h2>
                  
                  <div class="row">
                    <!-- Benefit 1: Belajar Fleksibel -->
                    <div class="col-12 col-md-6 col-xl-3 mb-4 mb-xl-0">
                      <div class="benefit-item">
                        <div class="benefit-icon-wrapper benefit-icon-red">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="benefit-svg">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                          </svg>
                        </div>
                        <div>
                          <h4 class="benefit-content-title">Belajar Fleksibel</h4>
                          <p class="benefit-content-desc">Kapan saja, di mana saja sesuai kebutuhanmu.</p>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Benefit 2: Materi Lengkap -->
                    <div class="col-12 col-md-6 col-xl-3 mb-4 mb-xl-0">
                      <div class="benefit-item">
                        <div class="benefit-icon-wrapper benefit-icon-blue">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="benefit-svg">
                            <circle cx="12" cy="12" r="10"/>
                            <polygon points="10 8 16 12 10 16 10 8"/>
                          </svg>
                        </div>
                        <div>
                          <h4 class="benefit-content-title">Materi Lengkap</h4>
                          <p class="benefit-content-desc">Rangkuman, video, dan latihan soal terstruktur.</p>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Benefit 3: Evaluasi & Progress -->
                    <div class="col-12 col-md-6 col-xl-3 mb-4 mb-md-0">
                      <div class="benefit-item">
                        <div class="benefit-icon-wrapper benefit-icon-orange">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="benefit-svg">
                            <path d="M3 3v18h18"/>
                            <path d="m18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
                          </svg>
                        </div>
                        <div>
                          <h4 class="benefit-content-title">Evaluasi & Progress</h4>
                          <p class="benefit-content-desc">Pantau perkembangan belajarmu secara real-time.</p>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Benefit 4: Akses Mudah -->
                    <div class="col-12 col-md-6 col-xl-3">
                      <div class="benefit-item">
                        <div class="benefit-icon-wrapper benefit-icon-purple">
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="benefit-svg">
                            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                            <line x1="12" y1="18" x2="12.01" y2="18"/>
                          </svg>
                        </div>
                        <div>
                          <h4 class="benefit-content-title">Akses Mudah</h4>
                          <p class="benefit-content-desc">Login praktis di berbagai perangkat.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- GAMBAR MOCKUP LAPTOP & HP (Mobile View - Menggunakan sistembaru.png) -->
              <div class="d-block d-lg-none mobile-mockup-wrapper">
                <img src="/static/images/page/about/sistembaru.png" alt="Sistem E-Learning BTA" class="img-fluid card-mockup-img-mobile">
              </div>
              
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!-- PENUTUP BENEFITS SECTION -->
        <!-- ============================================-->
        

        <!-- ============================================-->
        <!--  TESTIMONIALS SECTION  =======-->
        <!-- ============================================-->

        <section class="bta-testimonials-section py-6 py-lg-8" id="testimonial">
          <div class="container">
            <div class="row align-items-center">
              
              <!-- Kolom Kiri: Judul & Testimonial Carousel -->
              <div class="col-lg-7 mb-5 mb-lg-0">
                <div class="bta-header-group">
                  <span class="bta-subtitle">Cerita Alumni BTA</span>
                  <h2 class="bta-title">
                    Langkah Nyata Menembus <br>
                    <span class="bta-text-red">PTN & Jurusan Impian</span>
                  </h2>
                </div>
                
                <!-- Slider Area Wrapper -->
                <div 
                  class="bta-slider-container"
                  @mouseenter="stopAutoPlay"
                  @mouseleave="startAutoPlay"
                >
                  <div class="bta-slider-track" :style="trackStyle">
                    
                    <!-- Card Loop -->
                    <div 
                      v-for="(testi, idx) in testimonials" 
                      :key="idx" 
                      class="bta-card"
                    >
                      <div class="bta-card-header">
                        <div class="bta-avatar-wrapper">
                          <!-- Fallback avatar jika gambar error/tidak ditemukan -->
                          <img 
                            v-if="!testi.imageError" 
                            class="bta-avatar" 
                            :src="testi.image" 
                            :alt="testi.people" 
                            @error="handleImageError(idx)"
                          />
                          <div v-else class="bta-avatar-fallback">
                            {{ testi.people.charAt(0) }}
                          </div>
                        </div>
                        <div class="bta-meta-info">
                          <div class="bta-name-row">
                            <h6 class="bta-name">{{ testi.people }}</h6>
                            <span v-if="testi.branch" class="bta-testi-branch-badge">
                              📍 {{ testi.branch }}
                            </span>
                          </div>
                          <p class="bta-meta">{{ testi.school }} <span class="bta-dot">•</span> {{ testi.major }}</p>
                        </div>
                      </div>
                      <div class="bta-quote-container">
                        <p class="bta-quote-text">
                          {{ testi.content }}
                        </p>
                        <svg class="bta-quote-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.5 9.5C9.5 7.567 7.933 6 6 6C4.067 6 2.5 7.567 2.5 9.5C2.5 12.879 5.201 16.48 8.162 18L9.5 16.662C7.746 15.343 6.5 13.5 6.5 12.5C6.5 12.5 7.5 12.5 8 12C9 11 9.5 10.5 9.5 9.5ZM21.5 9.5C21.5 7.567 19.933 6 18 6C16.067 6 14.5 7.567 14.5 9.5C14.5 12.879 17.201 16.48 20.162 18L21.5 16.662C19.746 15.343 18.5 13.5 18.5 12.5C18.5 12.5 19.5 12.5 20 12C21 11 21.5 10.5 21.5 9.5Z" fill="#E52E35"/>
                        </svg>
                      </div>
                    </div>
                    
                  </div>
                </div>
                
                <!-- Navigasi Dots Indicator -->
                <div class="bta-slider-dots">
                  <button 
                    v-for="i in slideCount" 
                    :key="i"
                    :class="['bta-dot-indicator', { active: currentSlide === i - 1 }]"
                    @click="goToSlide(i - 1)"
                    aria-label="Slide Indicator"
                  ></button>
                </div>
              </div>
              
              <!-- Kolom Kanan: Video Player YouTube (Revert Stabil) -->
              <div class="col-lg-5">
                <div class="bta-video-card shadow">
                  <div class="bta-video-wrapper">
                    <iframe 
                      src="https://www.youtube.com/embed/_ZHI-F93aaU?si=b7FQC1Q1wAyHU6x_" 
                      title="YouTube video player" 
                      frameborder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!--  PENUTUP TESTIMONIALS SECTION  =======-->
        <!-- ============================================-->


        <!-- ============================================-->
        <!--  END SECTION  =======-->
        <!-- ============================================-->
        
        <section class="py-6 py-lg-7 position-relative overflow-hidden" id="end-section" style="background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);">
          <div class="container position-relative" style="z-index: 2;">
            <!-- Card Container Banner Merah Premium -->
            <div class="cta-card p-4 p-md-5 position-relative overflow-hidden">
              
              <!-- Ambient Background Light Decorations -->
              <div class="cta-bg-glow-top"></div>
              <div class="cta-bg-glow-bottom"></div>
              <div class="cta-pattern-overlay"></div>

              <div class="row align-items-center position-relative" style="z-index: 3;">
                
                <!-- Section Kiri: Ikon Roket, Badge, & Teks Inspiratif -->
                <div class="col-lg-8 d-flex flex-column flex-sm-row align-items-center align-items-sm-start text-center text-sm-start mb-4 mb-lg-0">
                  <div class="cta-icon-wrapper me-0 me-sm-4 mb-3 mb-sm-0 flex-shrink-0">
                    <div class="cta-rocket-bubble">
                      <!-- Ikon Roket dengan Animasi Lembut -->
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="white" width="46" height="46" class="cta-rocket-svg" style="transform: rotate(45deg); transform-origin: center;">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2C12 2 10 6 10 12c0 2.5 1 4.5 2 5.5L10 20c-.5.5-.2 1.5.5 1.5h11c.7 0 1-1 .5-1.5l-2-2.5c1-1 2-3 2-5.5 0-6-2-10-6-10z M16 8.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
                        <path d="M15 20.5 L16 31 L17 20.5 Z M12.5 20.5 L11.2 28.5 L13.5 20.5 Z M18.5 20.5 L20.8 28.5 L19.5 20.5 Z"/>
                      </svg>
                    </div>
                  </div>
                  <div>
                    <div class="cta-badge-pill mb-2">
                      <span class="cta-badge-star">✨</span> PENDAFTARAN TAHUN AJARAN BARU DIBUKA
                    </div>
                    <h2 class="cta-title">Siap untuk Menggapai Cita-citamu?</h2>
                    <p class="cta-subtitle mb-3">
                      Bergabunglah bersama 100.000+ alumni sukses BTA Group! Raih PTN impian &amp; sekolah favorit bersama para pengajar terbaik.
                    </p>
                    <div class="cta-feature-tags d-flex flex-wrap justify-content-center justify-content-sm-start gap-2">
                      <span class="cta-tag-item">✓ 40+ Tahun Berpengalaman</span>
                      <span class="cta-tag-item">✓ Pengajar Ahli &amp; Teruji</span>
                      <span class="cta-tag-item">✓ Konsultasi Program Gratis</span>
                    </div>
                  </div>
                </div>
                
                <!-- Section Kanan: Tombol Daftar Sekarang Menuju Selector Hero -->
                <div class="col-lg-4 d-flex flex-column align-items-center align-items-lg-end justify-content-center">
                  <button 
                    class="btn cta-btn d-inline-flex align-items-center justify-content-center shadow-lg" 
                    @click="scrollToHeroSelector"
                  >
                    <span>Daftar Sekarang</span>
                    <svg class="ms-2 cta-btn-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                    </svg>
                  </button>
                  <span class="cta-btn-hint mt-2 small text-center text-lg-end" style="color: rgba(255,255,255,0.85); font-size: 0.78rem;">
                    Pilih program &amp; cabang belajarmu
                  </span>
                </div>
                
              </div>
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!--  PENUTUP END SECTION  =======-->
        <!-- ============================================-->


      </main>
      <!-- ===============================================-->
      <!--    End of Main Content-->
      <!-- ===============================================-->

      <!-- ===============================================-->
      <!--    JavaScripts-->
      <!-- ===============================================-->
      <script type="application/javascript" src="vendors/@popperjs/popper.min.js"></script>
      <script type="application/javascript" src="vendors/bootstrap/bootstrap.min.js"></script>
      <script type="application/javascript" src="vendors/is/is.min.js"></script>
      <script type="application/javascript" src="assets/js/theme.js"></script>

      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&amp;display=swap"
        rel="stylesheet"
      />
      <script type="application/javascript" src="assets/js/jquery.min.js"></script>
      <script type="application/javascript" src="assets/js/bootstrap-navbar.js"></script>
      <script type="application/javascript" src="assets/js/detector.js"></script>
      <script type="application/javascript" src="assets/js/scroll-to-top.js"></script>
      <script type="application/javascript" src="assets/js/theme.js"></script>
      <script type="application/javascript" src="assets/js/theme.min.js"></script>
      <script type="application/javascript" src="assets/js/utils.js"></script>
    </body>
  </html>
</template>

<script type="application/javascript">
export default {
  name: "Index",

  data: function () {
    return {
      selectedProgram: '',
      selectedCabang: '',
      showBranchDropdown: false,
      isSelectorGlowing: false,
      selectorGlowTimer: null,
      
      gambarHomes: [
        {
          image: "/static/images/page/about/natasya-home-new-resize2.png", 
        },
      ],
      popup: true,
      modal9: false,
      modal10: false,
      modal12: false,
      modalAl: false,
      modalBranchPrograms: false,
      
      programList: [
        { id: 'sma12', name: 'Kelas 12 SMA' },
        { id: 'sma10', name: 'Kelas 10 & 11 SMA' },
        { id: 'smp', name: 'Kelas 8 & 9 SMP' },
        { id: 'alumni', name: 'Alumni / Gap Year' }
      ],      
      primaryBranches: [
        { id: 'jakarta', name: 'BTA 8 JAKARTA', isPrimary: true },
        { id: '45', name: 'BTA 45', isPrimary: true },
        { id: 'duta', name: 'BTA 8 DUTA', isPrimary: true },
        { id: 'fatmawati', name: 'BTA 8 FATMAWATI', isPrimary: true },
        { id: 'depok', name: 'BTA 8 DEPOK', isPrimary: true },
        { id: 'kelapa gading', name: 'BTA 8 KELAPA GADING', isPrimary: true },
        { id: 'cibubur', name: 'BTA 8 KOTA WISATA CIBUBUR', isPrimary: true },
        { id: 'bsd', name: 'BTA 8 BSD', isPrimary: false },
        { id: 'bintaro', name: 'BTA 8 BINTARO', isPrimary: false },
        { id: 'bekasi', name: 'BTA 8 BEKASI', isPrimary: false },
        { id: 'cilegon', name: 'BTA 8 CILEGON', isPrimary: false },
        { id: 'ciledug', name: 'BTA 8 CILEDUG', isPrimary: false },
        { id: 'sulsel', name: 'BTA 8 CABANG SULAWESI SELATAN', isPrimary: false }
      ],  

      branchesWaMap: [
        { key: 'jakarta', wa: '62811962322' },
        { key: '45', wa: '628111834545' },
        { key: 'duta', wa: '6281291575317' },
        { key: 'fatmawati', wa: '6282113115543' },
        { key: 'depok', wa: '628119408460' },
        { key: 'kelapa gading', wa: '6285716869512' },
        { key: 'cibubur', wa: '6285772897428' },
        { key: 'bsd', wa: '6281314510325' },
        { key: 'bintaro', wa: '6285890503400' },
        { key: 'bekasi', wa: '6281383331374' },
        { key: 'cilegon', wa: '6287771510356' },
        { key: 'ciledug', wa: '6281314613053' },
        { key: 'sulsel', wa: '6281214868383' }
      ],

      // DATA DETAIL PROGRAM DEFAULT (Untuk jika belum pilih cabang atau memilih cabang mitra)
      defaultProgramDetails: {
        sma12: {
          badge: 'Program Unggulan',
          desc: 'Persiapan intensif UTBK-SNBT, Ujian Mandiri PTN, Ujian Sekolah, dan peningkatan nilai rapor semester 5.',
          info1Label: 'Tersedia di',
          info1Val: 'Seluruh Cabang BTA',
          capacity: '10 – 15 Siswa / Kelas',
          polaLabel: 'Pilihan Waktu Belajar',
          polaVal: 'Senin-Rabu / Selasa-Kamis / Weekend',
          focusTitle: 'Fokus Utama',
          focusBold: 'UTBK-SNBT & Ujian Mandiri PTN',
          focusDesc: 'Materi ter-update, tryout IRT berkala, dan rasionalisasi peluang lolos PTN impian.',
          highlight1: 'Kapasitas 10–15 Siswa / Kelas',
          highlight2: 'Standby Teacher & Consult Class',
          highlight3: 'Simulasi Try Out Berkala (IRT)',
          highlight4: 'Konsultasi & Rasionalisasi PTN',
          scheduleCols: [
            { badge: 'Pola Reguler (Hari Kerja)', text: 'Pilihan hari: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu belajar: <strong>16.30 – 20.00 WIB</strong> (@ 2 sesi pelajaran / hari)' },
            { badge: 'Pola Akhir Pekan (Weekend)', text: 'Pilihan hari: <strong>Sabtu ATAU Minggu</strong> (Khusus Kelas 12)<br>Waktu belajar: <strong>08.00 – 15.00 WIB</strong> (@ 4 sesi pelajaran / hari)' }
          ]
        },
        sma10: {
          badge: 'Program Akademik',
          desc: 'Pendalaman materi Kurikulum Merdeka untuk memaksimalkan nilai rapor semester 1 – 4 dan persiapan awal penalaran TPS.',
          info1Label: 'Tersedia di',
          info1Val: 'Seluruh Cabang BTA',
          capacity: '10 – 15 Siswa / Kelas',
          polaLabel: 'Pola Belajar',
          polaVal: '2 Hari / Minggu (Sore Hari)',
          focusTitle: 'Fokus Utama',
          focusBold: 'Kurikulum Merdeka & Pengenalan TPS',
          focusDesc: 'Penguatan konsep dasar untuk mendongkrak peluang lolos jalur SNBP dan prestasi sekolah.',
          highlight1: 'Kapasitas 10–15 Siswa / Kelas',
          highlight2: 'Standby Teacher & Tanya PR',
          highlight3: 'Try Out Berkala Semesteran',
          highlight4: 'Pengenalan Tes Potensi Skolastik',
          scheduleCols: [
            { badge: 'Pola Reguler (Hari Kerja)', text: 'Pilihan hari: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu belajar: <strong>16.30 – 20.00 WIB</strong> (@ 2 sesi pelajaran / hari)' },
            { badge: 'Pola Akhir Pekan (Weekend)', text: 'Pilihan hari: <strong>Sabtu ATAU Minggu</strong><br>Waktu belajar: <strong>08.00 – 14.30 WIB</strong> (@ 3–4 sesi pelajaran / hari)' }
          ]
        },
        smp: {
          badge: 'Program SMP',
          desc: 'Bimbingan komprehensif untuk mendongkrak nilai rapor, sukses asesmen/ujian sekolah, & persiapan masuk SMA/SMK unggulan.',
          info1Label: 'Tersedia di',
          info1Val: 'Seluruh Cabang BTA',
          capacity: '10 – 15 Siswa / Kelas',
          polaLabel: 'Pola Belajar',
          polaVal: '2 Hari / Minggu (Sore Hari)',
          focusTitle: 'Fokus Utama',
          focusBold: 'Prestasi Rapor & Masuk SMA Favorit',
          focusDesc: 'Bantuan PR, pendalaman sains & matematika, serta latihan skolastik seleksi SMA unggulan.',
          highlight1: 'Kapasitas 10–15 Siswa / Kelas',
          highlight2: 'Standby Teacher & Bantuan PR',
          highlight3: 'Simulasi Ujian Sekolah & Asesmen',
          highlight4: 'Pemantauan Progres Belajar Siswa',
          scheduleCols: [
            { badge: 'Pola Reguler (Hari Kerja)', text: 'Pilihan hari: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu belajar: <strong>16.00 – 19.30 WIB</strong> (@ 2 sesi pelajaran / hari)' },
            { badge: 'Pola Akhir Pekan (Weekend)', text: 'Pilihan hari: <strong>Sabtu ATAU Minggu</strong><br>Waktu belajar: <strong>08.00 – 14.30 WIB</strong> (@ 3–4 sesi pelajaran / hari)' }
          ]
        },
        alumni: {
          badge: 'Program Khusus',
          desc: 'Bimbingan intensif penuh waktu 100% fokus UTBK-SNBT, SIMAK UI, CBT UGM, dan Sekolah Kedinasan tanpa distraksi sekolah.',
          info1Label: 'Tersedia di',
          info1Val: 'Seluruh Cabang BTA',
          capacity: '10 – 15 Siswa / Kelas',
          polaLabel: 'Pola Belajar',
          polaVal: 'Kelas Pagi / Siang (Senin – Kamis)',
          focusTitle: 'Fokus Utama',
          focusBold: 'Persiapan Intensif UTBK & Ujian Mandiri',
          focusDesc: 'Drilling ribuan bank soal prediktif, evaluasi skor IRT mingguan, dan konseling prodi PTN.',
          highlight1: 'Kapasitas 10–15 Siswa / Kelas',
          highlight2: 'Jadwal Belajar Pagi / Siang Terjadwal',
          highlight3: 'Simulasi Try Out Berkala (IRT)',
          highlight4: 'Konseling & Rasionalisasi Jurusan',
          scheduleCols: [
            { badge: 'Sesi Belajar Pagi / Siang', text: 'Pilihan hari: <strong>Senin s.d. Kamis</strong><br>Waktu belajar: <strong>09.00 – 14.30 WIB</strong> (@ 3–4 sesi pelajaran / hari)' },
            { badge: 'Sesi Tambahan & Try Out', text: 'Pilihan hari: <strong>Jumat &amp; Sabtu</strong><br>Waktu belajar: <strong>Simulasi Try Out, Bimbingan Mandiri &amp; Konsultasi Jurusan</strong>' }
          ]
        }
      },

      // DATA DETAIL PROGRAM SPESIFIK TIAP CABANG UTAMA (Sesuai Brosur Resmi Masing-Masing Cabang)
      branchBrochurePrograms: {
        'jakarta': {
          sma12: {
            badge: 'BTA 8 JAKARTA',
            desc: 'Program persiapan TKA, UTBK-SNBT, dan Seleksi Mandiri PTN 2027 di BTA 8 Jakarta (Sampit, Kebayoran Baru).',
            info1Label: 'Pilihan Program',
            info1Val: 'Reguler, Supsus, Khusus & Online',
            capacity: '10 – 22 Siswa / Kelas',
            polaLabel: 'Pola Hari Belajar',
            polaVal: 'Sabtu/Minggu (06.45-12.00) & Weekday Sore',
            focusTitle: 'Keunggulan BTA 8 Jakarta',
            focusBold: 'Super Intensif + Standby Teacher Harian',
            focusDesc: 'Modul per bab, tryout SNBT berkala, dan drilling harian pasca ujian sekolah.',
            highlight1: 'Pilihan: Reguler (22), Khusus (15), Supsus (10)',
            highlight2: 'Standby Teacher Pkl 16.30-20.00 WIB',
            highlight3: 'Analisis Hasil Try Out (TO) Berbasis IRT',
            highlight4: '71% Siswa Lolos PTN/Kedinasan (UI 25%, ITB 17%)',
            scheduleCols: [
              { badge: 'Program Reguler (Maks 22 Siswa)', text: 'Pilihan: <strong>Sabtu Pagi (06.45-12.00)</strong>, <strong>Minggu Pagi (06.45-12.00)</strong>, atau <strong>Minggu Siang (12.30-17.45)</strong>' },
              { badge: 'Program Khusus (Maks 15) & Supsus (Maks 10)', text: 'Pilihan: <strong>Senin &amp; Rabu</strong> (16.30-20.00), <strong>Selasa &amp; Kamis</strong> (16.30-20.00), atau <strong>Senin-Rabu-Jumat</strong> (Supsus)' }
            ]
          },
          sma10: {
            badge: 'BTA 8 JAKARTA',
            desc: 'Bimbingan tatap muka offline Kelas X & XI di BTA 8 Jakarta dengan pendampingan modul sekolah & pengenalan TPS.',
            info1Label: 'Format Belajar',
            info1Val: 'Offline (4 Sesi Pelajaran @90 Menit)',
            capacity: 'Maks. 15 Siswa / Kelas',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Senin & Rabu / Selasa & Kamis (16.30-20.00)',
            focusTitle: 'Fasilitas Belajar',
            focusBold: 'Standby Class Pkl 16.30 - 20.00 WIB',
            focusDesc: 'Bantuan PR, persiapan Penilaian Akhir Semester, dan konsultasi pelajaran mandiri.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Standby Class Senin s.d. Kamis',
            highlight3: 'Pendalaman Materi & Rapor Semester',
            highlight4: 'Modul Eksklusif BTA 8 Jakarta',
            scheduleCols: [
              { badge: 'Kelas X & XI IPA/IPS', text: 'Pilihan hari: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (@ 2 sesi pelajaran / hari)' },
              { badge: 'Kelas Standby BTA 8 Jakarta', text: 'Hari: <strong>Senin s.d. Kamis</strong> (16.30 – 20.00 WIB) untuk tanya PR & konsultasi mandiri' }
            ]
          },
          smp: {
            badge: 'BTA 8 JAKARTA',
            desc: 'Bimbingan khusus Kelas IX SMP di BTA 8 Jakarta untuk memperkuat pemahaman konsep dan lolos SMA favorit.',
            info1Label: 'Format Belajar',
            info1Val: 'Offline (4 Sesi Pelajaran @90 Menit)',
            capacity: 'Maks. 15 Siswa / Kelas',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Selasa & Kamis (16.30 – 20.00 WIB)',
            focusTitle: 'Materi & Target',
            focusBold: 'Matematika, IPA, Bahasa & Skolastik',
            focusDesc: 'Penguatan konsep dasar, tryout berkala, dan persiapan seleksi SMA unggulan.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Pengajar Berpengalaman BTA 8',
            highlight3: 'Try Out Asesmen & Ujian Sekolah',
            highlight4: 'Konsultasi Belajar Mandiri',
            scheduleCols: [
              { badge: 'Pola Belajar Kelas IX', text: 'Hari: <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (4 sesi pelajaran @ 90 menit)' },
              { badge: 'Standby Class BTA 8 Jakarta', text: 'Fasilitas konsultasi materi sulit dan persiapan ujian sekolah' }
            ]
          },
          alumni: {
            badge: 'BTA 8 JAKARTA',
            desc: 'Program persiapan intensif UTBK-SNBT, SIMAK UI, dan CBT UM UGM untuk alumni di BTA 8 Jakarta.',
            info1Label: 'Target Kelulusan',
            info1Val: 'Top PTN (UI, ITB, UGM, Unpad, dll)',
            capacity: 'Maks. 15 Siswa / Kelas',
            polaLabel: 'Pola Belajar',
            polaVal: 'Intensif Tatap Muka & Drilling Soal',
            focusTitle: 'Prestasi Teruji',
            focusBold: '71% Diterima PTN / Kedinasan 2024/2025',
            focusDesc: 'Sistem analisis IRT btagroup.co.id, video pembahasan, dan rasionalisasi peluang PTN.',
            highlight1: 'Kapasitas Terbatas 15 Siswa',
            highlight2: 'Sistem Informasi Akademik Siswa',
            highlight3: 'Forum Tanya Jawab Soal Online',
            highlight4: 'Super Intensif Menjelang UTBK',
            scheduleCols: [
              { badge: 'Sesi Belajar Terjadwal', text: 'Senin s.d. Kamis dengan bimbingan intensif materi UTBK & Mandiri' },
              { badge: 'Simulasi Try Out IRT', text: 'Simulasi berkala berbasis website btagroup.co.id dengan analisis ranking' }
            ]
          }
        },

        '45': {
          sma12: {
            badge: 'BTA 45 TEBET',
            desc: 'Program Signature (8 siswa) & Platinum (15 siswa) di BTA 45 Tebet dengan klaster peminatan prodi PTN.',
            info1Label: 'Pilihan Paket',
            info1Val: 'Signature (8 Siswa) & Platinum (15 Siswa)',
            capacity: 'Signature: 8 Siswa | Platinum: 15 Siswa',
            polaLabel: 'Pilihan Waktu Belajar',
            polaVal: 'Weekday Sore (16.30-20.00) / Weekend (08.00-15.00)',
            focusTitle: 'Klaster 12 IPA & IPS BTA 45',
            focusBold: 'Klaster Kedokteran, Keteknikan, Bisnis & Hukum',
            focusDesc: 'Berdasarkan peminatan prodi: Kedokteran, Teknik, Komputer, Ekonomi, Hukum, Hubungan Internasional.',
            highlight1: 'Signature: 8 Siswa | Platinum: 15 Siswa',
            highlight2: 'Standby Teacher & Bimbingan Eksklusif',
            highlight3: 'Fasilitas Klaster Jurusan IPA & IPS',
            highlight4: 'Super Intensif Menjelang SNBT & Mandiri',
            scheduleCols: [
              { badge: 'Program Signature (8 Siswa)', text: 'Pilihan: <strong>Senin, Rabu &amp; Jumat</strong> (16.30-20.00) ATAU <strong>Sabtu &amp; Minggu</strong> (08.00-13.00)' },
              { badge: 'Program Platinum (15 Siswa)', text: 'Pilihan: <strong>Senin &amp; Rabu</strong> (16.30-20.00), <strong>Selasa &amp; Kamis</strong> (16.30-20.00), atau <strong>Sabtu</strong> (08.00-15.00)' }
            ]
          },
          sma10: {
            badge: 'BTA 45 TEBET',
            desc: 'Program Platinum Kelas 10 & 11 SMA di BTA 45 Tebet: persiapan Kurikulum Merdeka & pengenalan TPS sejak dini.',
            info1Label: 'Pilihan Belajar',
            info1Val: 'Offline & Online (4 Sesi / Pekan)',
            capacity: 'Kapasitas 15 Siswa per Kelas',
            polaLabel: 'Pilihan Hari Belajar',
            polaVal: 'Senin-Rabu / Selasa-Kamis (16.30-20.00) / Minggu',
            focusTitle: 'Fasilitas BTA 45',
            focusBold: 'Standby Teacher + Tambahan PAS & PAT',
            focusDesc: 'Penguatan konsep materi, persiapan ulangan harian, dan pengenalan materi Tes Potensi Skolastik.',
            highlight1: 'Kapasitas 15 Siswa per Kelas',
            highlight2: 'Standby Teacher & Tambahan Belajar',
            highlight3: 'Pengenalan Materi TPS Sejak Dini',
            highlight4: 'Tersedia Kelas Offline & Online',
            scheduleCols: [
              { badge: 'Kelas 10/11 IPA', text: '<strong>Senin &amp; Rabu</strong> (16.30-20.00), <strong>Selasa &amp; Kamis</strong> (16.30-20.00), atau <strong>Minggu</strong> (08.00-15.00)' },
              { badge: 'Kelas 10/11 IPS', text: '<strong>Selasa &amp; Kamis</strong> (16.30-20.00) atau <strong>Jumat &amp; Sabtu</strong> (16.30-20.00 / 08.00-11.15)' }
            ]
          },
          smp: {
            badge: 'BTA 45 TEBET',
            desc: 'Program Platinum Kelas 8 & 9 SMP di BTA 45 Tebet: pendampingan Kurikulum Merdeka & seleksi SMA Unggulan.',
            info1Label: 'Format Belajar',
            info1Val: 'Hanya Tersedia Offline (4 Sesi / Pekan)',
            capacity: 'Kapasitas 15 Siswa per Kelas',
            polaLabel: 'Pilihan Hari Belajar',
            polaVal: 'Senin-Rabu / Selasa-Kamis (15.30-18.30 / 16.30-20.00)',
            focusTitle: 'Target Khusus SMP',
            focusBold: 'Persiapan Masuk SMA Swasta Unggulan & TKA',
            focusDesc: 'Persiapan TKA khusus kelas 9, penguatan mata pelajaran sekolah, dan pendampingan ujian kelulusan.',
            highlight1: 'Kapasitas 15 Siswa per Kelas',
            highlight2: 'Persiapan Masuk SMA Swasta Unggulan',
            highlight3: 'Persiapan TKA Khusus Kelas 9',
            highlight4: 'Pengajar Spesialis Kurikulum Merdeka',
            scheduleCols: [
              { badge: 'Pilihan Sesi 1', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (15.30 – 18.30 WIB)' },
              { badge: 'Pilihan Sesi 2 & Weekend', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB) / <strong>Jumat &amp; Sabtu</strong>' }
            ]
          },
          alumni: {
            badge: 'BTA 45 TEBET',
            desc: 'Program Alumni (Gap Year) di BTA 45 Tebet: bimbingan tatap muka intensif pagi hari fokus UTBK-SNBT.',
            info1Label: 'Format Belajar',
            info1Val: 'Hanya Tersedia Offline (6 Sesi / Pekan)',
            capacity: 'Kapasitas 15 Siswa per Kelas',
            polaLabel: 'Waktu Belajar Pagi',
            polaVal: 'Senin, Rabu & Jumat (08.00 – 11.30 WIB)',
            focusTitle: 'Fasilitas Alumni BTA 45',
            focusBold: 'Standby Teacher + Super Intensif SNBT & Mandiri',
            focusDesc: 'Belajar di jam produktif pagi hari, pembahasan bank soal terupdate, dan konseling prodi PTN.',
            highlight1: 'Kapasitas 15 Siswa per Kelas',
            highlight2: 'Jadwal Pagi: Senin, Rabu, Jumat',
            highlight3: 'Layanan Standby Teacher Mandiri',
            highlight4: 'Super Intensif Menjelang Hari H Ujian',
            scheduleCols: [
              { badge: 'Jadwal Kelas Pagi', text: 'Hari: <strong>Senin, Rabu &amp; Jumat</strong><br>Waktu: <strong>08.00 – 11.30 WIB</strong> (@ 2 sesi / hari)' },
              { badge: 'Super Intensif Pasca Sem 2', text: 'Drilling harian soal-soal UTBK-SNBT & Ujian Mandiri PTN' }
            ]
          }
        },

        'fatmawati': {
          sma12: {
            badge: 'BTA 8 FATMAWATI',
            desc: 'Program Khusus Kelas XII IPA/IPS di BTA 8 Fatmawati: Penguatan konsep semester 5 (jalur rapor) hingga persiapan SNBT.',
            info1Label: 'Pilihan Sesi',
            info1Val: 'Weekday Sore (16.30-20.00) / Sabtu (08.00-13.30)',
            capacity: 'Semi-Privat (Kapasitas Terbatas)',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Senin-Rabu / Selasa-Kamis / Sabtu',
            focusTitle: 'Keunggulan BTA Fatmawati',
            focusBold: '70%+ Lolos PTN dari 240 SMA Favorit se-Jabodetabek',
            focusDesc: 'Review materi X & XI, evaluasi tryout berkala, persiapan TKA, psikotes, seminar & superintensif harian.',
            highlight1: 'Kelas Semi-Privat Berstandar Tinggi',
            highlight2: 'Standby Teacher Menjelang Ujian',
            highlight3: 'Tryout Online & Pembahasan Interaktif',
            highlight4: 'Psikotes, Seminar & Konsultasi Jurusan',
            scheduleCols: [
              { badge: 'Pola Hari Kerja (Weekday)', text: 'Pilihan: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Pola Akhir Pekan (Sabtu)', text: 'Hari: <strong>Sabtu</strong> (08.00 – 13.30 WIB) & Superintensif harian pasca US' }
            ]
          },
          sma10: {
            badge: 'BTA 8 FATMAWATI',
            desc: 'Program Khusus Kelas X & XI di BTA 8 Fatmawati untuk peningkatan nilai rapor dan penguatan konsep dasar.',
            info1Label: 'Kurikulum',
            info1Val: 'Kurikulum Terbaru + Review Materi',
            capacity: 'Kelas Semi-Privat Terarah',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Senin & Rabu / Selasa & Kamis (16.30 – 20.00 WIB)',
            focusTitle: 'Fasilitas Fatmawati',
            focusBold: 'Standby Teacher Menjelang PTS & PAS',
            focusDesc: 'Konsultasi pelajaran, buku materi unggul dan terkini, serta pemantauan rapor semester.',
            highlight1: 'Kapasitas Semi-Privat Kondusif',
            highlight2: 'Standby Teacher Ulangan Harian & PR',
            highlight3: 'Materi Berkualitas Kurikulum Terbaru',
            highlight4: 'Bimbingan Konsultasi Pelajaran',
            scheduleCols: [
              { badge: 'Pilihan Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (@ 2 pelajaran / hari)' },
              { badge: 'Layanan Tambahan', text: 'Standby teacher di luar jam les reguler untuk bedah materi sulit' }
            ]
          },
          smp: {
            badge: 'BTA 8 FATMAWATI',
            desc: 'Program Khusus SMP di BTA 8 Fatmawati untuk peningkatan nilai rapor dan persiapan ujian masuk SMA unggulan.',
            info1Label: 'Mata Pelajaran',
            info1Val: 'Matematika, IPA, Bahasa & IPS',
            capacity: 'Kelas Semi-Privat Terarah',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Senin & Rabu / Selasa & Kamis (15.30 – 18.30 WIB)',
            focusTitle: 'Keunggulan Program SMP',
            focusBold: 'Tryout Bulanan + Persiapan TKA & SMA Unggulan',
            focusDesc: 'Latihan soal variasi setiap bulan, konsultasi pelajaran, dan pembekalan seleksi SMA favorit.',
            highlight1: 'Kapasitas Semi-Privat Terarah',
            highlight2: 'Tryout Bulanan Variasi Soal',
            highlight3: 'Persiapan Tes Masuk SMA Unggulan',
            highlight4: 'Konsultasi Pelajaran Sekolah',
            scheduleCols: [
              { badge: 'Pilihan Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>15.30 – 18.30 WIB</strong> (@ 2 pelajaran / hari)' },
              { badge: 'Evaluasi Berkala', text: 'Tryout setiap bulan dan bimbingan tanya jawab tugas sekolah' }
            ]
          },
          alumni: {
            badge: 'BTA 8 FATMAWATI',
            desc: 'Bimbingan intensif persiapan UTBK-SNBT dan Ujian Mandiri di BTA 8 Fatmawati dengan staf pengajar dari PTN favorit.',
            info1Label: 'Target Program',
            info1Val: 'SNBT, SIMAK UI & Ujian Mandiri',
            capacity: 'Kelas Semi-Privat Intensif',
            polaLabel: 'Pola Belajar',
            polaVal: 'Intensif Terjadwal & Superintensif',
            focusTitle: 'Fasilitas Alumni',
            focusBold: 'Sistem Informatika Terpadu + Konsultasi PTN',
            focusDesc: 'Akses video interaktif, forum tanya jawab btagroup.co.id, dan bimbingan strategi jurusan.',
            highlight1: 'Staf Pengajar dari PTN Terkemuka',
            highlight2: 'Simulasi Try Out Berbasis IRT',
            highlight3: 'Superintensif Menjelang Ujian',
            highlight4: 'Bimbingan & Rasionalisasi PTN',
            scheduleCols: [
              { badge: 'Sesi Belajar Reguler', text: 'Jadwal intensif terjadwal sesuai pilihan sesi di Fatmawati' },
              { badge: 'Superintensif Harian', text: 'Kegiatan belajar harian menjelang pelaksanaan gelombang ujian PTN' }
            ]
          }
        },

        'depok': {
          sma12: {
            badge: 'BTA 8 DEPOK',
            desc: 'Program Khusus Kelas XII di BTA 8 Depok: Penguatan konsep semester 5 (jalur rapor) hingga persiapan SNBT & SIMAK UI.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin & Rabu ATAU Selasa & Kamis',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Waktu Belajar',
            polaVal: '16.30 – 20.00 WIB (2 Sesi @90 Mnt + Break 30 Mnt)',
            focusTitle: 'Program BTA Depok',
            focusBold: 'SNBP, TKA, UTBK SNBT & SIMAK UI',
            focusDesc: 'Latihan soal X-XII, evaluasi tryout berkala, serta program Super Intensif harian (Senin-Sabtu).',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Waktu: 16.30-20.00 WIB (2 Sesi @90 Menit)',
            highlight3: 'Review Materi X & XI + Persiapan TKA',
            highlight4: 'Super Intensif Senin s.d. Sabtu Pasca Sem 6',
            scheduleCols: [
              { badge: 'Jadwal Kelas XII', text: 'Pilihan: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (Sesi 1 = 90 mnt, Break = 30 mnt, Sesi 2 = 90 mnt)' },
              { badge: 'Super Intensif Harian', text: 'Dimulai setelah semester 6 berakhir, berlangsung setiap hari <strong>Senin s.d. Sabtu</strong>' }
            ]
          },
          sma10: {
            badge: 'BTA 8 DEPOK',
            desc: 'Program Khusus Kelas X & XI di BTA 8 Depok untuk penguasaan Kurikulum Merdeka dan persiapan nilai rapor.',
            info1Label: 'Jadwal Belajar',
            info1Val: 'Kls X: Selasa-Kamis | Kls XI: Senin-Rabu',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Waktu Belajar',
            polaVal: '16.30 – 20.00 WIB (2 Sesi @90 Mnt + Break 30 Mnt)',
            focusTitle: 'Fokus Belajar BTA Depok',
            focusBold: 'Kurikulum Merdeka & Evaluasi PTS/PAS',
            focusDesc: 'Konsultasi pelajaran, penguatan konsep dasar materi sekolah, dan tryout semester berkala.',
            highlight1: 'Kelas X: Khusus Kurikulum Merdeka',
            highlight2: 'Kelas XI: Program IPA & IPS Terarah',
            highlight3: 'Kapasitas Maksimal 15 Siswa',
            highlight4: 'Try Out Tengah & Akhir Semester',
            scheduleCols: [
              { badge: 'Kelas X (Kurikulum Merdeka)', text: 'Hari: <strong>Selasa &amp; Kamis</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (Sesi 1 = 90 mnt, Break = 30 mnt, Sesi 2 = 90 mnt)' },
              { badge: 'Kelas XI (IPA & IPS)', text: 'Hari: <strong>Senin &amp; Rabu</strong><br>Waktu: <strong>16.30 – 20.00 WIB</strong> (Sesi 1 = 90 mnt, Break = 30 mnt, Sesi 2 = 90 mnt)' }
            ]
          },
          smp: {
            badge: 'BTA 8 DEPOK',
            desc: 'Program SMP saat ini belum diselenggarakan di cabang BTA 8 Depok (Fokus SMA & Alumni).',
            info1Label: 'Status Program',
            info1Val: 'Belum Tersedia di Depok',
            capacity: '-',
            polaLabel: 'Rekomendasi Cabang',
            polaVal: 'Tebet (BTA 8 / BTA 45) atau Fatmawati',
            focusTitle: 'Catatan Cabang',
            focusBold: 'Khusus Jenjang SMA & Alumni',
            focusDesc: 'Silakan pilih cabang BTA lainnya yang menyediakan program bimbingan jenjang SMP.',
            highlight1: 'Belum Tersedia di BTA 8 Depok',
            highlight2: 'Pilihan Cabang Lain: Jakarta, 45, Fatmawati',
            highlight3: 'Fokus Cabang Depok: SMA & Alumni',
            highlight4: 'Hubungi Admin untuk Info Lebih Lanjut',
            scheduleCols: [
              { badge: 'Keterangan Program', text: 'Program bimbingan Kelas SMP saat ini belum dibuka di cabang BTA 8 Depok' }
            ]
          },
          alumni: {
            badge: 'BTA 8 DEPOK',
            desc: 'Program Khusus Intensif - Super Intensif di BTA 8 Depok fokus 100% menghadapi SNBT UTBK dan SIMAK UI.',
            info1Label: 'Format Program',
            info1Val: 'Intensif & Super Intensif (Senin - Sabtu)',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Pola Belajar',
            polaVal: 'Kegiatan Belajar Harian & Tryout Mingguan',
            focusTitle: 'Keunggulan Alumni Depok',
            focusBold: 'Drilling Soal Prediktif + Evaluasi IRT Mingguan',
            focusDesc: 'Intensif dimulai pasca semester 5, Super Intensif harian Senin-Sabtu pasca semester 6.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Fokus Penuh SNBT & Ujian Mandiri',
            highlight3: 'Try Out SNBT Setiap Pekan',
            highlight4: 'Super Intensif Senin s.d. Sabtu',
            scheduleCols: [
              { badge: 'Tahap 1: Program Intensif', text: 'Dimulai setelah semester 5 berakhir dengan evaluasi tryout mingguan' },
              { badge: 'Tahap 2: Super Intensif', text: 'Dimulai setelah semester 6 berakhir, berlangsung setiap hari <strong>Senin s.d. Sabtu</strong>' }
            ]
          }
        },

        'kelapa gading': {
          sma12: {
            badge: 'BTA 8 KELAPA GADING',
            desc: 'Program intensif Kelas 12 di BTA 8 Kelapa Gading: evaluasi harian, quiz, dan persiapan masuk PTN.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Weekday Sore (16.30-20.00) / Weekend (08.00-15.00)',
            capacity: 'Kapasitas 10 – 15 Siswa',
            polaLabel: 'Pola Belajar',
            polaVal: 'Senin-Rabu / Selasa-Kamis / Sabtu / Minggu',
            focusTitle: 'Fasilitas Kelapa Gading',
            focusBold: 'Quiz Harian, Standby Class & Consult Class',
            focusDesc: 'Laporan berkala ke orang tua, E-Learning web BTA, tryout online, dan seminar pendidikan.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Quiz Harian & Evaluasi Berkala',
            highlight3: 'Standby Class & Consult by Request',
            highlight4: 'Seminar Pendidikan & Info PTN',
            scheduleCols: [
              { badge: 'Pola Hari Reguler', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Pola Khusus Kelas 12 (Weekend)', text: '<strong>Sabtu</strong> (08.00 – 15.00 WIB) ATAU <strong>Minggu</strong> (08.00 – 15.00 WIB)' }
            ]
          },
          sma10: {
            badge: 'BTA 8 KELAPA GADING',
            desc: 'Program reguler Kelas 10 & 11 SMA di BTA 8 Kelapa Gading untuk pendalaman konsep dan perbaikan rapor.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin & Rabu / Selasa & Kamis (16.30-20.00)',
            capacity: 'Kapasitas 10 – 15 Siswa',
            polaLabel: 'Pola Belajar',
            polaVal: '2 Hari / Minggu (@ 2 Sesi Pelajaran)',
            focusTitle: 'Fasilitas Belajar',
            focusBold: 'Quiz Harian & Consult Class by Request',
            focusDesc: 'Pemantauan berkala nilai sekolah, bimbingan PR mandiri, dan laporan progres ke orang tua.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Quiz Harian Pemahaman Materi',
            highlight3: 'Consult Class by Request',
            highlight4: 'Laporan Progres Belajar Berkala',
            scheduleCols: [
              { badge: 'Pola Hari Les', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Layanan Konsultasi', text: 'Standby class & consult class by request untuk persiapan ulangan' }
            ]
          },
          smp: {
            badge: 'BTA 8 KELAPA GADING',
            desc: 'Program bimbingan SMP di BTA 8 Kelapa Gading untuk penguatan akademik dan persiapan masuk SMA favorit.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin & Rabu / Selasa & Kamis (16.30-20.00)',
            capacity: 'Kapasitas 10 – 15 Siswa',
            polaLabel: 'Pola Belajar',
            polaVal: '2 Hari / Minggu (@ 2 Sesi Pelajaran)',
            focusTitle: 'Fasilitas Belajar',
            focusBold: 'Standby Class & Laporan Evaluasi Berkala',
            focusDesc: 'Bantuan pengerjaan PR sekolah, tryout rutin, dan quiz harian untuk mengukur pemahaman materi.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Quiz Harian & Pemantauan Nilai',
            highlight3: 'Bantuan PR & Ulangan Harian',
            highlight4: 'Persiapan Masuk SMA Unggulan',
            scheduleCols: [
              { badge: 'Pola Hari Les', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Konsultasi Mandiri', text: 'Consult class by request menjelang ujian tengah & akhir semester' }
            ]
          },
          alumni: {
            badge: 'BTA 8 KELAPA GADING',
            desc: 'Kelas intensif persiapan masuk PTN favorit untuk siswa gap year / alumni di BTA 8 Kelapa Gading.',
            info1Label: 'Target Program',
            info1Val: 'UTBK-SNBT & Ujian Mandiri PTN',
            capacity: 'Kapasitas 10 – 15 Siswa',
            polaLabel: 'Format Belajar',
            polaVal: 'Intensif Penuh Waktu + Tryout Online',
            focusTitle: 'Fasilitas Alumni',
            focusBold: 'Kelas Persiapan PTN & Konsultasi Jurusan',
            focusDesc: 'E-learning website BTA, simulasi tryout berkala, evaluasi skor IRT, dan seminar pendidikan.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Try Out & Evaluasi Online',
            highlight3: 'Seminar Pendidikan & Info PTN',
            highlight4: 'Konsultasi Jurusan Berkelanjutan',
            scheduleCols: [
              { badge: 'Sesi Intensif PTN', text: 'Jadwal belajar terstruktur fokus pendalaman materi dan bank soal' },
              { badge: 'Layanan Tambahan', text: 'Konsultasi prodi PTN berbasis passing grade dan histori kelulusan' }
            ]
          }
        },

        'duta': {
          sma12: {
            badge: 'BTA 8 DUTA',
            desc: 'Program SMA Kelas 12 di BTA 8 Duta (Dukuh, Jakarta Timur) untuk persiapan UTBK, TKA Saintek/Soshum, & Mandiri.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin-Rabu / Selasa-Kamis / Jumat-Sabtu',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Pilihan Waktu',
            polaVal: 'Weekday (16.30-20.00) & Weekend (07.30-11.00)',
            focusTitle: 'Materi Bimbingan Duta',
            focusBold: 'TPS, Penalaran Umum & TKA Lengkap',
            focusDesc: 'Saintek (Fisika, Kimia, Biologi, MTK Minat) & Soshum (Geografi, Sosiologi, Ekonomi, Sejarah).',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Saintek & Soshum Lengkap',
            highlight3: 'Pola Weekday Sore & Weekend Pagi',
            highlight4: 'Bimbingan Pilihan Jurusan PTN',
            scheduleCols: [
              { badge: 'Pola Hari Reguler', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Pola Kombinasi Weekend', text: '<strong>Jumat</strong> (16.30 – 20.00 WIB) &amp; <strong>Sabtu</strong> (07.30 – 11.00 WIB)' }
            ]
          },
          sma10: {
            badge: 'BTA 8 DUTA',
            desc: 'Program SMA Kelas 10 & 11 di BTA 8 Duta untuk pemantapan mata pelajaran wajib dan peminatan.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin & Rabu / Selasa & Kamis (16.30-20.00)',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Pola Belajar',
            polaVal: '2 Hari / Minggu (@ 2 Sesi Pelajaran)',
            focusTitle: 'Fokus Belajar',
            focusBold: 'Bahasa, Matematika Wajib & Mapel Peminatan',
            focusDesc: 'Bimbingan konsep dasar, penguatan nilai rapor semester, dan persiapan dini seleksi PTN.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Penguatan Mapel Wajib & Peminatan',
            highlight3: 'Bantuan Tugas & Ulangan Harian',
            highlight4: 'Persiapan Dini UTBK-SNBT',
            scheduleCols: [
              { badge: 'Pilihan Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Konsultasi Pelajaran', text: 'Pendampingan persiapan ulangan harian dan tugas sekolah' }
            ]
          },
          smp: {
            badge: 'BTA 8 DUTA',
            desc: 'Program SMP Kelas 9 di BTA 8 Duta untuk persiapan ujian sekolah dan seleksi masuk SMA unggulan.',
            info1Label: 'Pilihan Hari',
            info1Val: 'Senin & Rabu / Selasa & Kamis (16.30-20.00)',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Materi Belajar',
            polaVal: 'Matematika, IPA, Bahasa & IPS',
            focusTitle: 'Fokus Kelas 9 SMP',
            focusBold: 'Sukses Ujian Sekolah & Masuk SMA Favorit',
            focusDesc: 'Latihan soal terstruktur, pembedahan materi sulit, dan simulasi asesmen kelulusan.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Materi Khusus Kelas 9 SMP',
            highlight3: 'Latihan Soal Ujian Sekolah',
            highlight4: 'Persiapan Seleksi Masuk SMA',
            scheduleCols: [
              { badge: 'Pilihan Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Mata Pelajaran', text: 'Bhs Indonesia, Bhs Inggris, Matematika, IPA (Fisika &amp; Biologi), IPS' }
            ]
          },
          alumni: {
            badge: 'BTA 8 DUTA',
            desc: 'Program intensif persiapan UTBK-SNBT dan seleksi mandiri PTN untuk alumni di BTA 8 Duta.',
            info1Label: 'Format Belajar',
            info1Val: 'Intensif Fokus PTN',
            capacity: 'Maks. 15 Siswa per Kelas',
            polaLabel: 'Target Ujian',
            polaVal: 'UTBK-SNBT, SIMAK UI & CBT UGM',
            focusTitle: 'Fasilitas Alumni',
            focusBold: 'Drilling Soal Saintek / Soshum Lengkap',
            focusDesc: 'Latihan intensif tipe soal penalaran, tryout berkala, dan konsultasi pemilihan program studi.',
            highlight1: 'Kapasitas Maksimal 15 Siswa',
            highlight2: 'Fokus Penuh Seleksi PTN Favorit',
            highlight3: 'Try Out Standar Nasional',
            highlight4: 'Konsultasi Pemilihan Jurusan',
            scheduleCols: [
              { badge: 'Jadwal Belajar Intensif', text: 'Sesi terstruktur fokus bedah bank soal SNBT dan Ujian Mandiri' },
              { badge: 'Pendampingan PTN', text: 'Konsultasi personal pemilihan prodi kampus negeri favorit' }
            ]
          }
        },

        'cibubur': {
          sma12: {
            badge: 'BTA 8 CIBUBUR',
            desc: 'Program unggulan Kelas 12 SMA di BTA 8 Kota Wisata Cibubur untuk persiapan intensif masuk PTN impian.',
            info1Label: 'Pilihan Waktu',
            info1Val: 'Weekday Sore (16.30-20.00) / Weekend (08.00-15.00)',
            capacity: 'Semi-Privat 10 – 15 Siswa',
            polaLabel: 'Pilihan Hari',
            polaVal: 'Senin-Rabu / Selasa-Kamis / Weekend',
            focusTitle: 'Fasilitas BTA Cibubur',
            focusBold: 'Kelas Nyaman Madison Square + Standby Teacher',
            focusDesc: 'Tryout IRT berkala, modul lengkap persiapan SNBT dan seleksi mandiri PTN ternama.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Standby Teacher Konsultasi PR',
            highlight3: 'Simulasi Try Out IRT Berkala',
            highlight4: 'Konsultasi & Rasionalisasi PTN',
            scheduleCols: [
              { badge: 'Pola Reguler (Weekday)', text: 'Pilihan: <strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Pola Akhir Pekan (Weekend)', text: 'Pilihan: <strong>Sabtu ATAU Minggu</strong> (08.00 – 15.00 WIB)' }
            ]
          },
          sma10: {
            badge: 'BTA 8 CIBUBUR',
            desc: 'Program reguler Kelas 10 & 11 SMA di BTA 8 Kota Wisata Cibubur untuk penguasaan konsep dan peningkatan rapor.',
            info1Label: 'Format Kelas',
            info1Val: 'Tatap Muka Semi-Privat',
            capacity: 'Semi-Privat 10 – 15 Siswa',
            polaLabel: 'Pola Belajar',
            polaVal: '2 Hari / Minggu (16.30 – 20.00 WIB)',
            focusTitle: 'Fokus Belajar',
            focusBold: 'Kurikulum Merdeka & Pengenalan TPS',
            focusDesc: 'Bimbingan ulangan harian, konsultasi tugas sekolah, dan persiapan rapor semester.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Standby Teacher & Bantuan PR',
            highlight3: 'Penguatan Nilai Rapor Semester',
            highlight4: 'Lingkungan Belajar Kondusif',
            scheduleCols: [
              { badge: 'Pola Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.30 – 20.00 WIB)' },
              { badge: 'Konsultasi Tambahan', text: 'Sesi konsultasi mandiri bersama guru pengajar' }
            ]
          },
          smp: {
            badge: 'BTA 8 CIBUBUR',
            desc: 'Program bimbingan SMP di BTA 8 Kota Wisata Cibubur untuk persiapan ujian sekolah dan masuk SMA favorit.',
            info1Label: 'Format Kelas',
            info1Val: 'Semi-Privat 10 – 15 Siswa',
            capacity: 'Kapasitas 10 – 15 Siswa',
            polaLabel: 'Pola Belajar',
            polaVal: '2 Hari / Minggu (16.00 – 19.30 WIB)',
            focusTitle: 'Target SMP Cibubur',
            focusBold: 'Prestasi Akademik & Sukses Masuk SMA Unggulan',
            focusDesc: 'Pendalaman materi sains, matematika, bahasa, dan latihan skolastik persiapan masuk SMA.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Bantuan Tugas & PR Sekolah',
            highlight3: 'Simulasi Ujian Sekolah',
            highlight4: 'Bimbingan Akademik Terarah',
            scheduleCols: [
              { badge: 'Pilihan Hari Belajar', text: '<strong>Senin &amp; Rabu</strong> ATAU <strong>Selasa &amp; Kamis</strong> (16.00 – 19.30 WIB)' },
              { badge: 'Evaluasi Berkala', text: 'Latihan soal rutin dan pemantauan perkembangan hasil belajar' }
            ]
          },
          alumni: {
            badge: 'BTA 8 CIBUBUR',
            desc: 'Program persiapan intensif alumni / gap year di BTA 8 Kota Wisata Cibubur fokus tembus PTN favorit.',
            info1Label: 'Target Program',
            info1Val: 'UTBK-SNBT & Ujian Mandiri PTN',
            capacity: 'Semi-Privat 10 – 15 Siswa',
            polaLabel: 'Format Belajar',
            polaVal: 'Intensif Terjadwal & Drilling Soal',
            focusTitle: 'Fasilitas Alumni',
            focusBold: 'Drilling Soal Prediktif & Konseling Jurusan',
            focusDesc: 'Pendalaman konsep dasar dari awal, tryout IRT berkala, dan strategi pemilihan prodi.',
            highlight1: 'Kapasitas 10–15 Siswa / Kelas',
            highlight2: 'Jadwal Belajar Intensif Terstruktur',
            highlight3: 'Simulasi Try Out IRT',
            highlight4: 'Konseling Pemilihan Kampus',
            scheduleCols: [
              { badge: 'Jadwal Intensif Pagi / Siang', text: 'Bimbingan intensif materi UTBK &amp; Mandiri' },
              { badge: 'Simulasi Try Out', text: 'Simulasi ujian berkala dan evaluasi peringkat' }
            ]
          }
        }
      },

      // STATE SLIDER TESTIMONIAL
      currentSlide: 0,
      itemsPerSlide: 2, 
      autoPlayTimer: null,

      // DATA TESTIMONIAL ALUMNI 7 CABANG UTAMA BTA GROUP
      testimonials: [
        // BTA 8 JAKARTA (dari Brosur BTA 8 Jakarta)
        {
          branch: "BTA 8 JAKARTA",
          people: "Vivianne Audrey Charmaine",
          school: "SMAK 1 Penabur Jakarta",
          major: "Pendidikan Dokter UI (SNBT)",
          image: "/static/images/page/about/xxx.jpg",
          content: "Selama belajar di BTA, aku dapat banyak sumber (video pembahasan, TO & kelas online) yang bantu aku paham dan re-call materi yang harus dipelajari di SNBT. Kakak pengajar menjelaskan pembahasan tiap soal dengan sangat jelas dan mudah dimengerti.",
          imageError: false
        },
        {
          branch: "BTA 8 JAKARTA",
          people: "Makayla Zefanya Nadiba",
          school: "SMAN 8 Bogor",
          major: "FTI ITB (SNBT)",
          image: "/static/images/page/about/xxx.jpg",
          content: "BTA ibarat cahaya di tengah kegelapan malam, soalnya beneran bikin suasana belajar yang super asik di tengah kerumetan UTBK! Asli gak ada tandingannya, mulai dari kakak pengajar yang gokil sampai materi dan TO yang 11/12 sama aslinya.",
          imageError: false
        },
        {
          branch: "BTA 8 JAKARTA",
          people: "Fransiskus Theodorus",
          school: "SMA Kemurnian 2",
          major: "Pendidikan Dokter UGM (CBT UM UGM)",
          image: "/static/images/page/about/xxx.jpg",
          content: "10000000000% rekomen! BTA sangat membantu saya untuk bisa diterima di FK UGM. Lingkungan belajarnya sangat baik, kakak pengajarnya ramah dan pintar mengajar karena mereka juga pernah melalui perjuangan yang sama seperti kami.",
          imageError: false
        },

        // BTA 45 (dari Brosur BTA 45 Halaman 6)
        {
          branch: "BTA 45",
          people: "Muhammad Rizky Nugroho",
          school: "SMAN 8 Jakarta",
          major: "Kedokteran UNS (SNBP)",
          image: "/static/images/page/about/xxx.jpg",
          content: "3 tahun di BTA 45 terasa benar-benar seru. Para pengajarnya ramah, sabar, dan sangat piawai menjelaskan materi. Tips dan trik pengerjaan soal selalu membantu saat menghadapi ujian. Kakak pengajar dan binglas sudah seperti keluarga sendiri.",
          imageError: false
        },
        {
          branch: "BTA 45",
          people: "Chandrani Muntazhiri",
          school: "SMA JISC",
          major: "Kedokteran UI (SNBT)",
          image: "/static/images/page/about/xxx.jpg",
          content: "Sejak kelas 9, aku udah di BTA dan it has helped me a lot! Lingkungan belajar yang suportif tapi juga kompetitif beneran bantu aku untuk push myself to be better. Dari standby teacher sampai TO yang beneran susah sangat ngebantu meraih impianku!",
          imageError: false
        },
        {
          branch: "BTA 45",
          people: "Tarida Jesse G.S.",
          school: "SMA St Laurensia",
          major: "Kedokteran Gigi UI (SIMAK UI)",
          image: "/static/images/page/about/xxx.jpg",
          content: "Bimbel di BTA 45 tuh kayak tempat recharge semangat setelah sekolah soalnya ketemu teman-teman seru dan kakak pengajar yang asik banget! Iklim belajarnya kompetitif, santai tapi nancep. BTA 45 udah jadi rumah ketiga yang isinya orang-orang keren!",
          imageError: false
        },

        // BTA 8 FATMAWATI (dari Brosur BTA Fatmawati Halaman 4)
        {
          branch: "BTA 8 FATMAWATI",
          people: "Alika Shifa Sofya Noor",
          school: "SMA Al Izhar Pondok Labu",
          major: "Kedokteran UIN Jakarta (SNBP)",
          image: "/static/images/page/about/xxx.jpg",
          content: "Belajar di BTA itu seruuuu bangeeettt!! Kelas belajarnya nyamann, kakak2 binglas & pengajarnya asikk. Jadi belajarnya juga enakk. Aku belajar di BTA dari kelas 11 dan alhamdulillah nilai rapor aku sangat terbantu & bisa mempermudah lolos SNBP.",
          imageError: false
        },
        {
          branch: "BTA 8 FATMAWATI",
          people: "Nayyara Syalsabillah",
          school: "SMA Garuda Cendekia",
          major: "SBM ITB",
          image: "/static/images/page/about/xxx.jpg",
          content: "Belajar di BTA tuh bener-bener jadi bagian penting perjalanan aku, mulai dari persiapan UTBK sampai kelas mandiri & IUP. Pengajar super suportif, cara ngajarnya jelas dan asik. Makasih banyak BTA udah nemenin proses perjuangan ini!",
          imageError: false
        },
        {
          branch: "BTA 8 FATMAWATI",
          people: "Kayzira Azalya Siregar",
          school: "SMA Garuda Cendekia",
          major: "Ilmu Hukum UI",
          image: "/static/images/page/about/xxx.jpg",
          content: "Semua pertemuan dan video-video pembahasan itu bantu banget, apalagi kalau ada yang ketinggalan di kelas atau perlu mendalami ulang soalnya. Pokoknya, BTA bantu aku improve dari nol sampe keterima di PTN impian.",
          imageError: false
        },

        // BTA 8 DEPOK (dari Brosur BTA Depok Halaman 4)
        {
          branch: "BTA 8 DEPOK",
          people: "Diva Aulia",
          school: "SMAN 3 Depok",
          major: "Psikologi UI 2023",
          image: "/static/images/page/about/xxx.jpg",
          content: "BTA 8 Depok itu definisi comfort place buat pejuang PTN! Kakak binglasnya super friendly, kelasnya nyaman, fasilitasnya SUPER lengkap, dan websitenya keren banget nyediain video materi dan pembahasan try out yang super useful.",
          imageError: false
        },
        {
          branch: "BTA 8 DEPOK",
          people: "Anastasia",
          school: "SMA Gonzaga",
          major: "Farmasi ITB 2023",
          image: "/static/images/page/about/xxx.jpg",
          content: "Bimbel di BTA enak banget. Kakak pengajar dan binglas ramah dan friendly. BTA 8 Depok bantu aku banget untuk belajar lebih mudah terutama di kelas 12, bukan cuma penjelasan materi tapi juga bisa konsultasi tugas sekolah.",
          imageError: false
        },
        {
          branch: "BTA 8 DEPOK",
          people: "Ghefira",
          school: "SMAN 2 Depok",
          major: "Ilmu Administrasi Fiskal UI 2024",
          image: "/static/images/page/about/xxx.jpg",
          content: "100% gak nyesel milih BTA as a place to learn, truly feels like home! Kakak-kakaknya baik dan helpful banget, belajarnya no pressure tapi tetep TOP 1 hihihi >_< thank you BTA.",
          imageError: false
        }
      ],
      googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
      
      mapObject: null,
      mapMarkers: {},
      activeBranchId: '',
      mapLeafletLoaded: false,
      
      branchMetadata: {
        'jakarta': {
          coords: [-6.2447026, 106.7961325],
          address: "Jl. Sampit I No. 56, RT 01/RW 06, Kebayoran Baru, Jakarta Selatan, 12130",
          phone: "(021) 48679169",
          wa: "62811962322",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+JAKARTA+Kebayoran+Baru"
        },
        '45': {
          coords: [-6.2378774, 106.8504789],
          address: "Jl. Tebet Barat VIII No. 53, Jakarta Selatan",
          phone: "(021) 8309364",
          wa: "628111834545",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+45+Tebet"
        },
        'duta': {
          coords: [-6.2890882, 106.8764919],
          address: "Jl. Bokir bin Dji'un no. 28, Dukuh, Jakarta Timur",
          phone: "(021) 8414613",
          wa: "6281291575317",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Duta"
        },
        'fatmawati': {
          coords: [-6.3060202, 106.7936429],
          address: "Jl. RS. Fatmawati No. 36, Jakarta Selatan",
          phone: "(021) 27654521",
          wa: "6282113115543",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Fatmawati"
        },
        'depok': {
          coords: [-6.4040512, 106.8328327],
          address: "Victoria Hills Business Park, Jl. Tole Iskandar No. 33, Kec. Pancoran Mas, Kota Depok, Jawa Barat 16431",
          phone: "(021) 77826423",
          wa: "628119408460",
          programs: ['sma12', 'sma10', 'alumni'], // Sesuai brosur resmi: X, XI, XII, Alumni/Intensif (tidak ada SMP)
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Depok"
        },
        'kelapa gading': {
          coords: [-6.1682078, 106.9043979],
          address: "Jl. Gading Putih Raya Utara CB 2/9, RT 11/RW 12, Kelapa Gading, Jakarta Utara, Jakarta 14240",
          phone: "(021) 21698562",
          wa: "6285716869512",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Kelapa+Gading"
        },
        'cibubur': {
          coords: [-6.3512847, 106.9614697],
          address: "Ruko Madison Square, SHC 2 No. 31–32, Jl. Raya Kota Wisata, Cibubur, Kec. Gunung Putri, Kabupaten Bogor, Jawa Barat 16986",
          phone: "(021) 89082894",
          wa: "6285772897428",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Kota+Wisata+Cibubur"
        },
        'bsd': {
          coords: [-6.281862, 106.663185],
          address: "Jl. Letnan Soetopo, Ruko Barcelona, Bumi Serpong Damai, Serpong, Tangerang Selatan",
          phone: "08811245449",
          wa: "6281314510325",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+BSD"
        },
        'bintaro': {
          coords: [-6.262530, 106.744111],
          address: "Ruko Graha Matercella No. 85E, Jl. Bintaro Utama Raya 3A, Tangerang Selatan",
          phone: "(021) 73880850",
          wa: "6285890503400",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Bintaro"
        },
        'bekasi': {
          coords: [-6.281586, 106.992416],
          address: "Jl. Duta 2 Blok JJ No. 17, Kemang Pratama Raya, RT 006/RW 022, Bojong Rawalumbu, Kec. Rawalumbu, Kota Bekasi, Jawa Barat 17116",
          phone: "081383331374",
          wa: "6281383331374",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Bekasi"
        },
        'cilegon': {
          coords: [-6.017368, 106.012586],
          address: "Ruko PPI Blok KK1 No. 19, Cilegon",
          phone: "087771510356",
          wa: "6287771510356",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Cilegon"
        },
        'ciledug': {
          coords: [-6.228185, 106.728185],
          address: "Jl. Raden Fatah No. 78, Sudimara Barat, Ciledug, Tangerang",
          phone: "081586066638",
          wa: "6281314613053",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Ciledug"
        },
        'sulsel': {
          coords: [-5.141503, 119.412497],
          address: "Jl. Botolempangan No. 10C, Kec. Ujung Pandang, Makassar",
          phone: "081214868383",
          wa: "6281214868383",
          programs: ['sma12', 'sma10', 'smp', 'alumni'],
          image: "/static/images/page/about/xxx.jpg",
          mapsUrl: "https://maps.google.com/?q=BTA+8+Sulawesi+Selatan"
        }
      }
    };
  },

  computed: {
    activeBranch() {
      if (!this.activeBranchId || !this.primaryBranches || this.primaryBranches.length === 0) return null;
      return this.primaryBranches.find(b => b.id == this.activeBranchId || b.name === this.activeBranchId) || null;
    },
    activeBranchMeta() {
      if (!this.activeBranch) return null;
      return this.getBranchMetadata(this.activeBranch);
    },
    trackStyle() {
      const gap = 20;
      return {
        transform: `translate3d(calc(-${this.currentSlide * 100}% - ${this.currentSlide * gap}px), 0, 0)`
      };
    },
    slideCount() {
      return Math.ceil(this.testimonials.length / this.itemsPerSlide);
    }
  },

  watch: {
    selectedCabang: function (newVal) {
      if (newVal) {
        this.activeBranchId = newVal;
        this.syncMapToSelectedCabang();
      }
    }
  },

  methods: {
    updateItemsPerSlide() {
      this.itemsPerSlide = window.innerWidth >= 992 ? 2 : 1;
      if (this.currentSlide >= this.slideCount) {
        this.currentSlide = Math.max(0, this.slideCount - 1);
      }
    },
    goToSlide(index) {
      if (index >= this.slideCount) {
        this.currentSlide = 0;
      } else if (index < 0) {
        this.currentSlide = this.slideCount - 1;
      } else {
        this.currentSlide = index;
      }
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        this.goToSlide(this.currentSlide + 1);
      }, 6000); 
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
      }
    },
    handleImageError(index) {
      this.testimonials[index].imageError = true;
    },
    fetchProgramData: function () {
      // Bypassed database loading, using local static programList
    },
    registerNow: function () {
      // Kasus 1: Pengguna hanya memilih Cabang tanpa memilih Program di hero
      if (!this.selectedProgram && this.selectedCabang) {
        this.activeBranchId = this.selectedCabang;
        const elCabang = document.getElementById('cabang');
        if (elCabang) {
          elCabang.scrollIntoView({ behavior: 'smooth' });
        }
        setTimeout(() => {
          this.syncMapToSelectedCabang();
        }, 500);
        return;
      }

      // Kasus 2: Pengguna memilih Program (baik dengan cabang maupun tanpa cabang)
      if (this.selectedProgram) {
        const el = document.getElementById('services');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }

        setTimeout(() => {
          const program = this.programList.find(p => p.id == this.selectedProgram || p.name === this.selectedProgram);
          if (program) {
            const name = program.name.toLowerCase();
            if (name.includes('12')) {
              this.modal12 = true;
            } else if (name.includes('10') || name.includes('11')) {
              this.modal10 = true;
            } else if (name.includes('8') || name.includes('9') || name.includes('smp')) {
              this.modal9 = true;
            } else if (name.includes('alumni')) {
              this.modalAl = true;
            }
          }
        }, 800);
        return;
      }

      // Kasus 3: Belum memilih program maupun cabang sama sekali
      this.triggerSelectorGlow();
      const elServices = document.getElementById('services');
      if (elServices) {
        elServices.scrollIntoView({ behavior: 'smooth' });
      }
    },
    goToProgramCabang: function (branchId) {
      if (branchId) {
        this.selectedCabang = branchId;
        this.activeBranchId = branchId;
      }
      this.modalBranchPrograms = true;
    },
    selectBranchProgram: function (progType) {
      const progKeyMap = { '12': 'sma12', '10': 'sma10', '9': 'smp', 'al': 'alumni' };
      const progKey = progKeyMap[progType];
      if (this.activeBranch && progKey && !this.isProgramAvailable(this.activeBranch, progKey)) {
        return;
      }
      this.modalBranchPrograms = false;
      if (this.activeBranch) {
        this.selectedCabang = this.activeBranch.id;
        if (progKey) {
          this.selectedProgram = progKey;
        }
      }
      var self = this;
      setTimeout(function () {
        if (progType === '12') {
          self.modal12 = true;
        } else if (progType === '10') {
          self.modal10 = true;
        } else if (progType === '9') {
          self.modal9 = true;
        } else if (progType === 'al') {
          self.modalAl = true;
        }
      }, 250);
    },
    scrollToServices: function () {
      var el = document.getElementById('services');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToHeroSelector: function () {
      const el = document.getElementById('hero-selector-box') || document.getElementById('home');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      setTimeout(() => {
        this.triggerSelectorGlow();
      }, 400);
    },
    triggerSelectorGlow: function () {
      this.isSelectorGlowing = true;
      if (this.selectorGlowTimer) {
        clearTimeout(this.selectorGlowTimer);
      }
      this.selectorGlowTimer = setTimeout(() => {
        this.isSelectorGlowing = false;
      }, 3500);
    },
    isProgramHighlighted(programKey) {
      if (!this.selectedProgram) return false;
      const program = this.programList.find(p => p.id == this.selectedProgram);
      if (!program) return false;

      const name = program.name.toLowerCase();
      if (programKey === 'sma12' && name.includes('12')) return true;
      if (programKey === 'sma10' && (name.includes('10') || name.includes('11'))) return true;
      if (programKey === 'smp' && (name.includes('8') || name.includes('9') || name.includes('smp'))) return true;
      if (programKey === 'alumni' && name.includes('alumni')) return true;

      return false;
    },
    getSelectedCabangName() {
      if (!this.selectedCabang) return '';
      if (this.primaryBranches && this.primaryBranches.length > 0) {
        const found = this.primaryBranches.find(
          c => c.id == this.selectedCabang || c.name === this.selectedCabang
        );
        return found ? found.name : this.selectedCabang;
      }
      return this.selectedCabang;
    },
    selectCabangFromModal(cabangId) {
      this.selectedCabang = cabangId;
      this.showBranchDropdown = false;
    },
    getBranchSupportedPrograms(branchOrId) {
      if (!branchOrId) return ['sma12', 'sma10', 'smp', 'alumni'];
      const id = (typeof branchOrId === 'object' && branchOrId) ? branchOrId.id : branchOrId;
      if (this.branchMetadata && this.branchMetadata[id] && this.branchMetadata[id].programs) {
        return this.branchMetadata[id].programs;
      }
      return ['sma12', 'sma10', 'smp', 'alumni'];
    },
    isProgramAvailable(branchOrId, programId) {
      if (!programId) return true;
      const progs = this.getBranchSupportedPrograms(branchOrId);
      return progs.indexOf(programId) !== -1;
    },
    isProgramDisabledInCabang(programId) {
      if (!this.selectedCabang) return false;
      return !this.isProgramAvailable(this.selectedCabang, programId);
    },
    isCabangDisabledForProgram(branchId) {
      if (!this.selectedProgram) return false;
      return !this.isProgramAvailable(branchId, this.selectedProgram);
    },
    onCabangChange() {
      if (this.selectedCabang && this.selectedProgram) {
        if (!this.isProgramAvailable(this.selectedCabang, this.selectedProgram)) {
          this.selectedProgram = '';
        }
      }
      this.syncMapToSelectedCabang();
    },
    onProgramChange() {
      if (this.selectedProgram && this.selectedCabang) {
        if (!this.isProgramAvailable(this.selectedCabang, this.selectedProgram)) {
          this.selectedCabang = '';
        }
      }
    },
    isAvailableInBranch(programKey) {
      const branchId = this.selectedCabang;
      if (!branchId) return true;
      return this.isProgramAvailable(branchId, programKey);
    },
    getProgramDetails(programKey) {
      const selectedId = this.selectedCabang;
      let isPrimary = false;

      if (selectedId) {
        const branchObj = this.primaryBranches.find(function(b) {
          return b.id == selectedId || b.name === selectedId;
        });
        if (branchObj && branchObj.isPrimary) {
          isPrimary = true;
        }
      }

      // Jika belum pilih cabang ATAU memilih cabang mitra, otomatis kembalikan data DEFAULT
      if (!selectedId || !isPrimary) {
        if (this.defaultProgramDetails && this.defaultProgramDetails[programKey]) {
          var base = Object.assign({}, this.defaultProgramDetails[programKey]);
          if (selectedId) {
            base.info1Val = this.getSelectedCabangName();
          }
          return base;
        }
        return {};
      }

      // Jika cabang utama yang memiliki data brosur resmi
      if (this.branchBrochurePrograms && this.branchBrochurePrograms[selectedId] && this.branchBrochurePrograms[selectedId][programKey]) {
        return this.branchBrochurePrograms[selectedId][programKey];
      }

      // Fallback aman ke default
      if (this.defaultProgramDetails && this.defaultProgramDetails[programKey]) {
        return this.defaultProgramDetails[programKey];
      }
      return {};
    },
    getWhatsAppUrl(programKey) {
      const branch = this.primaryBranches.find(b => b.id == this.selectedCabang || b.name === this.selectedCabang);
      let phone = '';

      if (branch) {
        // Look up directly in branchesWaMap
        const mapping = this.branchesWaMap.find(m => m.key === branch.id);
        if (mapping) {
          phone = mapping.wa;
        }
      }

      if (!phone) {
        phone = '62811962322'; // fallback to BTA 8 JAKARTA
      }

      let customText = '';
      const branchName = this.getSelectedCabangName() || 'Terdekat';

      switch(programKey) {
        case 'sma12':
          customText = `Halo BTA, saya tertarik mendaftar program Kelas 12 SMA di cabang ${branchName}. Apakah bisa dibantu untuk informasi jadwal belajar dan biaya investasinya? Terima kasih.`;
          break;
        case 'sma10':
          customText = `Halo BTA, saya ingin berkonsultasi mengenai program bimbingan Kelas 10/11 SMA di ${branchName} untuk persiapan kenaikan kelas dan raport. Mohon info rinciannya ya.`;
          break;
        case 'smp':
          customText = `Halo Admin BTA, saya tertarik mendaftarkan program bimbingan Kelas 8/9 SMP di ${branchName} untuk persiapan masuk SMA Favorit. Bagaimana proses seleksi masuknya?`;
          break;
        case 'alumni':
          customText = `Halo Kak, saya alumni SMA dan berminat mendaftar Program Alumni Gap Year di ${branchName} untuk persiapan UTBK/SNBT tahun depan. Mohon info kelas terdekat yang masih tersedia.`;
          break;
        default:
          customText = `Halo BTA, saya tertarik mendaftar program bimbingan di ${branchName}. Mohon informasinya.`;
      }

      return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(customText)}`;
    },
    getWaNumber(branch) {
      const mapping = this.branchesWaMap.find(m => m.key === branch.id);
      return mapping ? mapping.wa : '';
    },
    getWaLink(branch) {
      const phone = this.getWaNumber(branch);
      if (!phone) return null;
      const text = encodeURIComponent(`Halo, boleh tanya mengenai Program Bimbingan di ${branch.name}?`);
      return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
    },
    fetchBranchData() {
      if (this.axios && process.env.API_URL) {
        this.axios
          .get(process.env.API_URL + "/branch", { params: { isHidden: false } })
          .then((response) => {
            if (response && response.data && response.data.data && response.data.data.length > 0) {
              const apiData = response.data.data;
              this.primaryBranches.forEach((branch) => {
                const found = apiData.find((b) =>
                  (b.name && b.name.toLowerCase().includes(branch.id)) ||
                  (branch.name && b.name && b.name.toLowerCase() === branch.name.toLowerCase())
                );
                if (found) {
                  if (found.address) branch.address = found.address;
                  if (found.phone) branch.phone = found.phone;
                }
              });
            }
          })
          .catch(() => {
            // Tetap menggunakan fallback konfigurasi static branch
          })
          .finally(() => {
            this.$nextTick(() => {
              if (this.mapObject) {
                this.plotMarkers();
              } else {
                this.loadLeaflet();
              }
            });
          });
      } else {
        this.$nextTick(() => {
          if (this.mapObject) {
            this.plotMarkers();
          } else {
            this.loadLeaflet();
          }
        });
      }
    },
    checkLoginAndGo() {
      const isUserLoggedIn = this.$store.getters.isAuthenticated;
      const profile = this.$store.state.profile;

      if (isUserLoggedIn && profile && profile.student) {
        const student = profile.student;
        const gradeId = (student && student.btaGradeID) || 
                        (student && student.btaGrade && student.btaGrade.id) || 
                        (student && student.gradeID);

        if (gradeId) {
          window.location.href = "/account/student/score";
        } else {
          window.location.href = "/account/student/score";
        }
      } else {
        localStorage.setItem('redirectAfterLogin', 'PENDING_SPECIFIC_LINK');
        this.popup = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          alert("Kamu belum login. Masuk dulu untuk lanjut 📢");
        }, 800);
      }
    },
    loadLeaflet() {
      if (window.L) {
        this.initMap();
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
      link.crossOrigin = '';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
      script.crossOrigin = '';
      script.onload = () => {
        this.initMap();
      };
      document.head.appendChild(script);
    },
    initMap() {
      if (this.mapObject) return;
      const container = document.getElementById('map-cabang');
      if (!container) {
        setTimeout(() => {
          if (!this.mapObject && document.getElementById('map-cabang')) {
            this.initMap();
          }
        }, 250);
        return;
      }
      const L = window.L;
      if (!L) return;
      
      this.mapObject = L.map('map-cabang', {
        zoomControl: false,
        attributionControl: false
      }).setView([-6.27, 106.85], 11);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.mapObject);

      this.mapObject.on('locationerror', () => {
        alert("Tidak dapat mendeteksi lokasi otomatis. Silakan pilih cabang secara manual pada peta.");
      });

      this.addCustomMapControls(L);
      this.mapLeafletLoaded = true;

      this.plotMarkers();
    },
    plotMarkers() {
      if (!this.mapLeafletLoaded || !this.mapObject || !this.primaryBranches || this.primaryBranches.length === 0) return;
      const L = window.L;

      Object.values(this.mapMarkers).forEach(m => m.remove());
      this.mapMarkers = {};

      this.primaryBranches.forEach(branch => {
        if (branch.isHidden) return;
        const meta = this.getBranchMetadata(branch);
        if (!meta) return;

        const shortName = branch.name.replace("BTA 8 ", "").replace("BTA 45 ", "").replace(" (Cabang Utama)", "");
        const customIcon = L.divIcon({
          className: 'custom-bta-marker-container',
          html: `
            <div class="bta-marker-wrapper" id="map-marker-${branch.id}">
              <div class="bta-marker-pin">
                <svg viewBox="0 0 24 24" fill="currentColor" style="width:14px; height:14px; color:white; transform:rotate(45deg);">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <div class="bta-marker-label">
                <span>${shortName}</span>
              </div>
            </div>
          `,
          iconSize: [120, 40],
          iconAnchor: [15, 38]
        });

        const marker = L.marker(meta.coords, { icon: customIcon }).addTo(this.mapObject);
        this.mapMarkers[branch.id] = marker;

        marker.on('click', () => {
          this.selectBranchFromMap(branch);
        });
      });

      if (this.selectedCabang) {
        this.syncMapToSelectedCabang();
      }
    },
    addCustomMapControls(L) {
      const controlsContainer = L.control({ position: 'bottomright' });
      controlsContainer.onAdd = () => {
        const div = L.DomUtil.create('div', 'custom-map-controls-container flex flex-column gap-2 m-3 pointer-events-auto');
        div.style.display = 'flex';
        div.style.flexDirection = 'column';
        div.style.gap = '8px';
        div.style.margin = '15px';
        div.style.pointerEvents = 'auto';
        
        div.innerHTML = `
          <button id="zoom-in-map" class="map-ctrl-btn" style="background: white; border: 1px solid #edf2f7; box-shadow: 0 4px 10px rgba(0,0,0,0.08); width: 36px; height: 36px; border-radius: 10px; font-weight: bold; cursor: pointer; font-size: 1.1rem; display: flex; align-items: center; justify-content: center;" title="Perbesar">+</button>
          <button id="zoom-out-map" class="map-ctrl-btn" style="background: white; border: 1px solid #edf2f7; box-shadow: 0 4px 10px rgba(0,0,0,0.08); width: 36px; height: 36px; border-radius: 10px; cursor: pointer; display: flex; align-items: center; justify-content: center;" title="Perkecil">-</button>
          <button id="locate-me-map" class="map-ctrl-btn" style="background: white; border: 1px solid #edf2f7; box-shadow: 0 4px 10px rgba(0,0,0,0.08); width: 36px; height: 36px; border-radius: 10px; cursor: pointer; display: flex; align-items: center; justify-content: center;" title="Lokasi Saya">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#E12029" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="3"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
            </svg>
          </button>
        `;
        return div;
      };
      controlsContainer.addTo(this.mapObject);

      this.$nextTick(() => {
        const btnIn = document.getElementById('zoom-in-map');
        const btnOut = document.getElementById('zoom-out-map');
        const btnLoc = document.getElementById('locate-me-map');
        if (btnIn) btnIn.addEventListener('click', () => { if (this.mapObject) this.mapObject.zoomIn(); });
        if (btnOut) btnOut.addEventListener('click', () => { if (this.mapObject) this.mapObject.zoomOut(); });
        if (btnLoc) btnLoc.addEventListener('click', () => {
          if (this.mapObject) this.mapObject.locate({ setView: true, maxZoom: 14 });
        });
      });
    },
    getBranchMetadata(branch) {
      if (!branch) return null;
      
      // Look up directly by ID first
      if (branch.id && this.branchMetadata[branch.id]) {
        const meta = this.branchMetadata[branch.id];
        return {
          coords: meta.coords,
          address: branch.address || meta.address,
          phone: branch.phone || meta.phone,
          image: meta.image,
          mapsUrl: meta.mapsUrl,
          programs: meta.programs || ['sma12', 'sma10', 'smp', 'alumni'],
          wa: meta.wa || ''
        };
      }

      const name = (branch.name || '').toLowerCase();
      const addr = (branch.address || '').toLowerCase();
      
      let key = '';
      
      if (addr.includes('cibubur') || addr.includes('wisata') || addr.includes('madison') || name.includes('cibubur') || name.includes('wisata')) {
        key = 'cibubur';
      }
      else if (addr.includes('gading') || name.includes('gading')) {
        key = 'kelapa gading';
      }
      else if (addr.includes('fatmawati') || name.includes('fatmawati')) {
        key = 'fatmawati';
      }
      else if (addr.includes('duta') || addr.includes('bokir') || addr.includes('dukuh') || name.includes('duta') || name.includes('bokir')) {
        key = 'duta';
      }
      else if (addr.includes('depok') || addr.includes('tole') || addr.includes('pancoran mas') || name.includes('depok') || name.includes('5')) {
        key = 'depok';
      }
      else if (addr.includes('tebet') || name.includes('45') || name.includes('tebet')) {
        key = '45';
      }
      else if (addr.includes('sampit') || addr.includes('kebayoran') || name.includes('jakarta') || name.includes('sampit') || name.includes('kebayoran')) {
        key = 'jakarta';
      }

      if (key && this.branchMetadata[key]) {
        const meta = this.branchMetadata[key];
        return {
          coords: meta.coords,
          address: branch.address || meta.address,
          phone: branch.phone || meta.phone,
          image: meta.image,
          mapsUrl: meta.mapsUrl,
          programs: meta.programs || ['sma12', 'sma10', 'smp', 'alumni'],
          wa: meta.wa || ''
        };
      }
      
      return {
        coords: [-6.2378774, 106.8504789],
        address: branch.address || 'Jl. Tebet Barat VIII No. 53, Jakarta Selatan',
        phone: branch.phone || '(021) 8295415',
        image: "/static/images/page/about/xxx.jpg",
        mapsUrl: 'https://maps.google.com/?q=' + encodeURIComponent(branch.name || 'BTA Group'),
        programs: ['sma12', 'sma10', 'smp', 'alumni'],
        wa: ''
      };
    },
    selectBranchFromMap(branch) {
      this.activeBranchId = branch.id;
      this.$nextTick(() => {
        this.syncMarkerHighlight(branch.id);
      });
      const meta = this.getBranchMetadata(branch);
      if (meta && this.mapObject) {
        this.mapObject.setView(meta.coords, 14, { animate: true, duration: 1.0 });
      }
    },
    syncMapToSelectedCabang() {
      if (!this.mapLeafletLoaded || !this.mapObject) return;
      const branchId = this.selectedCabang;
      if (!branchId) return;

      const branch = this.primaryBranches.find(b => b.id == branchId || b.name === branchId);
      if (branch) {
        this.activeBranchId = branch.id;
        this.$nextTick(() => {
          this.syncMarkerHighlight(branch.id);
        });
        const meta = this.getBranchMetadata(branch);
        if (meta) {
          this.mapObject.setView(meta.coords, 14, { animate: true, duration: 1.0 });
        }
      }
    },
    syncMarkerHighlight(activeId) {
      document.querySelectorAll('.bta-marker-wrapper').forEach(el => {
        el.classList.remove('active-marker');
      });
      const activeEl = document.getElementById(`map-marker-${activeId}`);
      if (activeEl) {
        activeEl.classList.add('active-marker');
      }
    },
    updateGlobalCabang(branchId) {
      this.selectedCabang = branchId;
    },
    navigateBranch(direction) {
      if (!this.primaryBranches || this.primaryBranches.length === 0) return;
      let currentIndex = this.primaryBranches.findIndex(b => b.id == this.activeBranchId);
      if (currentIndex === -1) currentIndex = 0;

      let newIndex = currentIndex;
      if (direction === 'prev') {
        newIndex = (currentIndex - 1 + this.primaryBranches.length) % this.primaryBranches.length;
      } else if (direction === 'next') {
        newIndex = (currentIndex + 1) % this.primaryBranches.length;
      }

      const newBranch = this.primaryBranches[newIndex];
      if (newBranch) {
        this.selectBranchFromMap(newBranch);
      }
    }
  },

  created() {
    this.fetchBranchData();
    this.fetchProgramData();

    this.axios
      .all([
        this.axios.get(process.env.API_URL + "/article/most-recent"),
        this.axios.get(process.env.API_URL + "/article", {
          params: { limit: this.articleLimit, skip: 1 },
        }),
      ])
      .then(
        this.axios.spread(
          function (responseRecentArticle, responseArticles) {
            this.recentArticle = responseRecentArticle.data.data;
            this.articles = responseArticles.data.data.data;
          }.bind(this)
        )
      );
  },

  mounted() {
    document.title =
      "Bimbingan Belajar Offline/Online Terbaik No 1 Di Indonesia " +
      process.env.APP_NAME;
    
    this.loadLeaflet();

    let carouselScript = document.createElement("script");
    carouselScript.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/js/bootstrap.bundle.min.js"
    );
    document.head.appendChild(carouselScript);

    this.updateItemsPerSlide();
    window.addEventListener('resize', this.updateItemsPerSlide);
    this.startAutoPlay();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateItemsPerSlide);
    this.stopAutoPlay();
    if (this.selectorGlowTimer) {
      clearTimeout(this.selectorGlowTimer);
    }
    if (this.mapObject) {
      this.mapObject.remove();
      this.mapObject = null;
    }
  }
};
</script>


<style scoped>
/* !
 * Bootstrap v5.0.0-alpha1 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE) */

:root {
  --bs-blue: #717cff;
  --bs-indigo: #53acf8;
  --bs-purple: #ad71ff;
  --bs-pink: #ff71c3;
  --bs-red: #ff717c;
  --bs-orange: #ff8125;
  --bs-yellow: #ffee25;
  --bs-green: #5fa500;
  --bs-teal: #00a598;
  --bs-cyan: #3eb8f4;
  --bs-white: #fff;
  --bs-gray: #c3bcc4;
  --bs-gray-dark: #b0a7b2;
  --bs-primary: #717cff;
  --bs-secondary: #a79ca8;
  --bs-success: #5fa500;
  --bs-info: #3eb8f4;
  --bs-warning: #ffee25;
  --bs-danger: #ff717c;
  --bs-light: #f9fafd;
  --bs-dark: #44224b;
  --bs-font-sans-serif: "Poppins", "Open Sans", -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --bs-font-monospace: "SFMono-Regular", Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.15),
    rgba(255, 255, 255, 0)
  );
}

*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}




hr {
  margin: 1rem 0;
  color: #dfdbdf;
  background-color: currentColor;
  border: 0;
  opacity: 1;
}

hr:not([size]) {
  height: 1px;
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 500;
  line-height: 1.2;
  color: #091e40;
}

h1,
.h1 {
  font-size: calc(1.37383rem + 1.48598vw);
}

@media (min-width: 1200px) {
  h1,
  .h1 {
    font-size: 2.48832rem;
  }
}

h2,
.h2 {
  font-size: calc(1.33236rem + 0.98832vw);
}

@media (min-width: 1200px) {
  h2,
  .h2 {
    font-size: 2.0736rem;
  }
}

h3,
.h3 {
  font-size: calc(1.2978rem + 0.5736vw);
}

@media (min-width: 1200px) {
  h3,
  .h3 {
    font-size: 1.728rem;
  }
}

h4,
.h4 {
  font-size: calc(1.269rem + 0.228vw);
}

@media (min-width: 1200px) {
  h4,
  .h4 {
    font-size: 1.44rem;
  }
}

h5,
.h5 {
  font-size: 1.2rem;
}

h6,
.h6 {
  font-size: 0.83333rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 800;
}

small,
.small {
  font-size: 75%;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #717cff;
  text-decoration: none;
}

a:hover {
  color: #016b9d;
  text-decoration: underline;
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 75%;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 75%;
  color: #ff71c3;
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 75%;
  color: #fff;
  background-color: #a79ca8;
  border-radius: 0.625rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #ccc6cd;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.2rem;
  font-weight: 400;
}

.display-1 {
  font-size: calc(1.55498rem + 3.65978vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 4.29982rem;
  }
}

.display-2 {
  font-size: calc(1.48332rem + 2.79982vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 3.58318rem;
  }
}

.display-3 {
  font-size: calc(1.4236rem + 2.08318vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 2.98598rem;
  }
}

.display-4 {
  font-size: calc(1.37383rem + 1.48598vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 2.48832rem;
  }
}

.display-5 {
  font-size: calc(1.33236rem + 0.98832vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 2.0736rem;
  }
}

.display-6 {
  font-size: calc(1.2978rem + 0.5736vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 1.728rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 75%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 75%;
  color: #c3bcc4;
}

.blockquote-footer::before {
  content: "\2014\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dfdbdf;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 75%;
  color: #c3bcc4;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 1rem);
  padding-left: var(--bs-gutter-x, 1rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
  }
}

@media (min-width: 1540px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl,
  .container-xxl {
    max-width: 1480px;
  }
}

.row {
  --bs-gutter-x: 2rem;
  --bs-gutter-y: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) / -2);
  margin-left: calc(var(--bs-gutter-x) / -2);
}

.row > * {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) / 2);
  padding-left: calc(var(--bs-gutter-x) / 2);
  margin-top: var(--bs-gutter-y);
}

.col {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
}

.row-cols-auto > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 33.33333%;
}

.row-cols-4 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 16.66667%;
}

.col-auto {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 8.33333%;
}

.col-2 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 16.66667%;
}

.col-3 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 33.33333%;
}

.col-5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 41.66667%;
}

.col-6 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 58.33333%;
}

.col-8 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 66.66667%;
}

.col-9 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 83.33333%;
}

.col-11 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 91.66667%;
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.8rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.8rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 4rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 4rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 5rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 5rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 7.5rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 7.5rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 10rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 10rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 12.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 12.5rem;
}

.g-11,
.gx-11 {
  --bs-gutter-x: 15rem;
}

.g-11,
.gy-11 {
  --bs-gutter-y: 15rem;
}

@media (min-width: 576px) {
  .col-sm {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 576px) {
  .col-sm-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 576px) {
  .col-sm-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 576px) {
  .col-sm-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 576px) {
  .col-sm-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 576px) {
  .offset-sm-0 {
    margin-left: 0;
  }
}

@media (min-width: 576px) {
  .offset-sm-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-3 {
    margin-left: 25%;
  }
}

@media (min-width: 576px) {
  .offset-sm-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-6 {
    margin-left: 50%;
  }
}

@media (min-width: 576px) {
  .offset-sm-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-9 {
    margin-left: 75%;
  }
}

@media (min-width: 576px) {
  .offset-sm-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 576px) {
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 576px) {
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 576px) {
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 576px) {
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 576px) {
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 576px) {
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 576px) {
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 576px) {
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 576px) {
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 576px) {
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 576px) {
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 576px) {
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 576px) {
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 576px) {
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 576px) {
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-11,
  .gx-sm-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 576px) {
  .g-sm-11,
  .gy-sm-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 768px) {
  .row-cols-md-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 768px) {
  .col-md-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 768px) {
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 768px) {
  .col-md-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 768px) {
  .col-md-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .offset-md-0 {
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .offset-md-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-3 {
    margin-left: 25%;
  }
}

@media (min-width: 768px) {
  .offset-md-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-6 {
    margin-left: 50%;
  }
}

@media (min-width: 768px) {
  .offset-md-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-9 {
    margin-left: 75%;
  }
}

@media (min-width: 768px) {
  .offset-md-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 768px) {
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 768px) {
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 768px) {
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 768px) {
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 768px) {
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 768px) {
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 768px) {
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 768px) {
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 768px) {
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 768px) {
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 768px) {
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 768px) {
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 768px) {
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 768px) {
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 768px) {
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 768px) {
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-11,
  .gx-md-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 768px) {
  .g-md-11,
  .gy-md-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 992px) {
  .col-lg-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 992px) {
  .col-lg-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 992px) {
  .col-lg-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 992px) {
  .col-lg-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .offset-lg-0 {
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  .offset-lg-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-3 {
    margin-left: 25%;
  }
}

@media (min-width: 992px) {
  .offset-lg-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-6 {
    margin-left: 50%;
  }
}

@media (min-width: 992px) {
  .offset-lg-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-9 {
    margin-left: 75%;
  }
}

@media (min-width: 992px) {
  .offset-lg-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 992px) {
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 992px) {
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 992px) {
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 992px) {
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 992px) {
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 992px) {
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 992px) {
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 992px) {
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 992px) {
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 992px) {
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 992px) {
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 992px) {
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 992px) {
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 992px) {
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-11,
  .gx-lg-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 992px) {
  .g-lg-11,
  .gy-lg-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1200px) {
  .col-xl-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1200px) {
  .col-xl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1200px) {
  .col-xl-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 1200px) {
  .col-xl-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-0 {
    margin-left: 0;
  }
}

@media (min-width: 1200px) {
  .offset-xl-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-3 {
    margin-left: 25%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-6 {
    margin-left: 50%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-9 {
    margin-left: 75%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 1200px) {
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 1200px) {
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-11,
  .gx-xl-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-11,
  .gy-xl-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 1540px) {
  .col-xxl {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1540px) {
  .col-xxl-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-0 {
    margin-left: 0;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-3 {
    margin-left: 25%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-6 {
    margin-left: 50%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-9 {
    margin-left: 75%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1540px) {
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 1540px) {
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 1540px) {
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-11,
  .gx-xxl-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-11,
  .gy-xxl-11 {
    --bs-gutter-y: 15rem;
  }
}

.table {
  --bs-table-bg: rgba(0, 0, 0, 0);
  --bs-table-striped-color: #778295;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #778295;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #778295;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: #778295;
  vertical-align: top;
  border-color: #dfdbdf;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  -webkit-box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table > :not(:last-child) > :last-child > * {
  border-bottom-color: currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: #e3e5ff;
  --bs-table-striped-bg: #d8daf2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cccee6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d2d4ec;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #cccee6;
}

.table-secondary {
  --bs-table-bg: #edebee;
  --bs-table-striped-bg: #e1dfe2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #d5d4d6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #dbd9dc;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #d5d4d6;
}

.table-success {
  --bs-table-bg: #dfedcc;
  --bs-table-striped-bg: #d4e1c2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c9d5b8;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #cedbbd;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #c9d5b8;
}

.table-info {
  --bs-table-bg: #d8f1fd;
  --bs-table-striped-bg: #cde5f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c2d9e4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c8dfea;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #c2d9e4;
}

.table-warning {
  --bs-table-bg: #fffcd3;
  --bs-table-striped-bg: #fbf8d1;
  --bs-table-striped-color: #b0a7b2;
  --bs-table-active-bg: #f7f4d0;
  --bs-table-active-color: #b0a7b2;
  --bs-table-hover-bg: #f9f6d1;
  --bs-table-hover-color: #b0a7b2;
  color: #b0a7b2;
  border-color: #f7f4d0;
}

.table-danger {
  --bs-table-bg: #ffe3e5;
  --bs-table-striped-bg: #f2d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6ccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ecd2d4;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #e6ccce;
}

.table-light {
  --bs-table-bg: #f9fafd;
  --bs-table-striped-bg: #f5f6f9;
  --bs-table-striped-color: #b0a7b2;
  --bs-table-active-bg: #f2f2f6;
  --bs-table-active-color: #b0a7b2;
  --bs-table-hover-bg: #f4f4f7;
  --bs-table-hover-color: #b0a7b2;
  color: #b0a7b2;
  border-color: #f2f2f6;
}

.table-dark {
  --bs-table-bg: #44224b;
  --bs-table-striped-bg: #4d2d54;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #57385d;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #523359;
  --bs-table-hover-color: #fff;
  color: #fff;
  border-color: #57385d;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1539.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1rem;
}

.col-form-label-sm {
  padding-top: calc(0.1rem + 1px);
  padding-bottom: calc(0.1rem + 1px);
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 75%;
  color: #ccc6cd;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #f1f2ff;
  background-clip: padding-box;
  border: 1px solid #d5d1d6;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-control[type="file"] {
  overflow: hidden;
}

.form-control[type="file"]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: #778295;
  background-color: #f1f2ff;
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}

.form-control::-webkit-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::-moz-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::-ms-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e8e5e9;
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.5rem 1.8rem;
  margin: -0.5rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
  color: #778295;
  background-color: #e8e5e9;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #dcdadd;
}

.form-control::-webkit-file-upload-button {
  padding: 0.5rem 1.8rem;
  margin: -0.5rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
  color: #778295;
  background-color: #e8e5e9;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #dcdadd;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #778295;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.2rem + 2px);
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.form-control-sm::file-selector-button {
  padding: 0.1rem 0.5rem;
  margin: -0.1rem -0.5rem;
  -webkit-margin-end: 0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-sm::-webkit-file-upload-button {
  padding: 0.1rem 0.5rem;
  margin: -0.1rem -0.5rem;
  -webkit-margin-end: 0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 1.25rem;
}

.form-control-lg::file-selector-button {
  padding: 0.7rem 1.8rem;
  margin: -0.7rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
}

.form-control-lg::-webkit-file-upload-button {
  padding: 0.7rem 1.8rem;
  margin: -0.7rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.2rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
}

.form-control-color {
  max-width: 3rem;
  height: auto;
  padding: 0.5rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 5.4rem 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #f1f2ff;
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right 1.8rem center;
  background-size: 16px 12px;
  border: 1px solid #d5d1d6;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-select:focus {
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 1.8rem;
  background-image: none;
}

.form-select:disabled {
  background-color: #e8e5e9;
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #778295;
}

.form-select-sm {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.8rem;
  font-size: 1rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #f1f2ff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.25em;
}

.form-check-input[type="radio"] {
  border-radius: 50%;
}

.form-check-input:active {
  -webkit-filter: brightness(90%);
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-check-input:checked {
  background-color: #717cff;
  border-color: #717cff;
}

.form-check-input:checked[type="checkbox"] {
  background-image: url([svg]);
}

.form-check-input:checked[type="radio"] {
  background-image: url([svg]);
}

.form-check-input[type="checkbox"]:indeterminate {
  background-color: #717cff;
  border-color: #717cff;
  background-image: url([svg]);
}

.form-check-input:disabled {
  pointer-events: none;
  -webkit-filter: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label,
.form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url([svg]);
  background-position: left center;
  border-radius: 2em;
  -webkit-transition: background-position 0.15s ease-in-out;
  -o-transition: background-position 0.15s ease-in-out;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  background-image: url([svg]);
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url([svg]);
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn,
.btn-check:disabled + .btn {
  pointer-events: none;
  -webkit-filter: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #717cff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: #d4d8ff;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dfdbdf;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #717cff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  -moz-appearance: none;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: #d4d8ff;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dfdbdf;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: #ccc6cd;
}

.form-range:disabled::-moz-range-thumb {
  background-color: #ccc6cd;
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  padding: 1rem 1.8rem;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 1.8rem;
  pointer-events: none;
  border: 1px solid transparent;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transition: opacity 0.1s ease-in-out,
    -webkit-transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, -webkit-transform 0.1s ease-in-out;
  -o-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out,
    -webkit-transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-floating > .form-control::-webkit-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::-moz-placeholder {
  color: transparent;
}

.form-floating > .form-control:-ms-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::-ms-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::placeholder {
  color: transparent;
}

.form-floating > .form-control:not(:-moz-placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:not(:-ms-input-placeholder) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:not(:-ms-input-placeholder) ~ label {
  opacity: 0.65;
  -ms-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  -ms-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  text-align: center;
  white-space: nowrap;
  background-color: #e8e5e9;
  border: 1px solid #d5d1d6;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 1.25rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 7.2rem;
}

.input-group:not(.has-validation)
  > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation
  > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group
  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 75%;
  color: #5fa500;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(95, 165, 0, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #5fa500;
  padding-right: calc(1.5em + 1rem);
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: #5fa500;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: #5fa500;
  padding-right: 9.9rem;
  background-image: url([svg]), url([svg]);
  background-position: right 1.8rem center, center right 5.4rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
  border-color: #5fa500;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: #5fa500;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: #5fa500;
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
  color: #5fa500;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid,
.input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 75%;
  color: #ff717c;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(255, 113, 124, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #ff717c;
  padding-right: calc(1.5em + 1rem);
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #ff717c;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
  border-color: #ff717c;
  padding-right: 9.9rem;
  background-image: url([svg]), url([svg]);
  background-position: right 1.8rem center, center right 5.4rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  border-color: #ff717c;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
  border-color: #ff717c;
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
  background-color: #ff717c;
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label,
.form-check-input.is-invalid ~ .form-check-label {
  color: #ff717c;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid,
.input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 500;
  line-height: 1.5;
  color: #778295;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  border-radius: 0.313rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.btn:hover {
  color: #778295;
  text-decoration: none;
}

.btn-check:focus + .btn,
.btn:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #ff0126;
  border-color: #ff0126;
}

.btn-primary:hover {
  color: #fff;
  background-color: #016b9d;
  border-color: #016b9d;
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
  color: #fff;
  background-color: #6069d9;
  border-color: #5a63cc;
  -webkit-box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
}

.btn-check:checked + .btn-primary,
.btn-check:active + .btn-primary,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #5a63cc;
  border-color: #555dbf;
}

.btn-check:checked + .btn-primary:focus,
.btn-check:active + .btn-primary:focus,
.btn-primary:active:focus,
.btn-primary.active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
}

.btn-primary:disabled,
.btn-primary.disabled {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-secondary {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #8e858f;
  border-color: #867d86;
}

.btn-check:focus + .btn-secondary,
.btn-secondary:focus {
  color: #fff;
  background-color: #8e858f;
  border-color: #867d86;
  -webkit-box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
  box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
}

.btn-check:checked + .btn-secondary,
.btn-check:active + .btn-secondary,
.btn-secondary:active,
.btn-secondary.active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #867d86;
  border-color: #7d757e;
}

.btn-check:checked + .btn-secondary:focus,
.btn-check:active + .btn-secondary:focus,
.btn-secondary:active:focus,
.btn-secondary.active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
  box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
}

.btn-secondary:disabled,
.btn-secondary.disabled {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-success {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-success:hover {
  color: #fff;
  background-color: #518c00;
  border-color: #4c8400;
}

.btn-check:focus + .btn-success,
.btn-success:focus {
  color: #fff;
  background-color: #518c00;
  border-color: #4c8400;
  -webkit-box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
  box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
}

.btn-check:checked + .btn-success,
.btn-check:active + .btn-success,
.btn-success:active,
.btn-success.active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #4c8400;
  border-color: #477c00;
}

.btn-check:checked + .btn-success:focus,
.btn-check:active + .btn-success:focus,
.btn-success:active:focus,
.btn-success.active:focus,
.show > .btn-success.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
  box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
}

.btn-success:disabled,
.btn-success.disabled {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-info {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-info:hover {
  color: #fff;
  background-color: #359ccf;
  border-color: #3293c3;
}

.btn-check:focus + .btn-info,
.btn-info:focus {
  color: #fff;
  background-color: #359ccf;
  border-color: #3293c3;
  -webkit-box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
  box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
}

.btn-check:checked + .btn-info,
.btn-check:active + .btn-info,
.btn-info:active,
.btn-info.active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #3293c3;
  border-color: #2f8ab7;
}

.btn-check:checked + .btn-info:focus,
.btn-check:active + .btn-info:focus,
.btn-info:active:focus,
.btn-info.active:focus,
.show > .btn-info.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
  box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
}

.btn-info:disabled,
.btn-info.disabled {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-warning {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-warning:hover {
  color: #000;
  background-color: #fff146;
  border-color: #fff03b;
}

.btn-check:focus + .btn-warning,
.btn-warning:focus {
  color: #000;
  background-color: #fff146;
  border-color: #fff03b;
  -webkit-box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
  box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
}

.btn-check:checked + .btn-warning,
.btn-check:active + .btn-warning,
.btn-warning:active,
.btn-warning.active,
.show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: #fff151;
  border-color: #fff03b;
}

.btn-check:checked + .btn-warning:focus,
.btn-check:active + .btn-warning:focus,
.btn-warning:active:focus,
.btn-warning.active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
  box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
}

.btn-warning:disabled,
.btn-warning.disabled {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-danger {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-danger:hover {
  color: #fff;
  background-color: #d96069;
  border-color: #cc5a63;
}

.btn-check:focus + .btn-danger,
.btn-danger:focus {
  color: #fff;
  background-color: #d96069;
  border-color: #cc5a63;
  -webkit-box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
}

.btn-check:checked + .btn-danger,
.btn-check:active + .btn-danger,
.btn-danger:active,
.btn-danger.active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #cc5a63;
  border-color: #bf555d;
}

.btn-check:checked + .btn-danger:focus,
.btn-check:active + .btn-danger:focus,
.btn-danger:active:focus,
.btn-danger.active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
}

.btn-danger:disabled,
.btn-danger.disabled {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-light {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-light:hover {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
}

.btn-check:focus + .btn-light,
.btn-light:focus {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
  -webkit-box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
  box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
}

.btn-check:checked + .btn-light,
.btn-check:active + .btn-light,
.btn-light:active,
.btn-light.active,
.show > .btn-light.dropdown-toggle {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
}

.btn-check:checked + .btn-light:focus,
.btn-check:active + .btn-light:focus,
.btn-light:active:focus,
.btn-light.active:focus,
.show > .btn-light.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
  box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
}

.btn-light:disabled,
.btn-light.disabled {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-dark {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-dark:hover {
  color: #fff;
  background-color: #3a1d40;
  border-color: #361b3c;
}

.btn-check:focus + .btn-dark,
.btn-dark:focus {
  color: #fff;
  background-color: #3a1d40;
  border-color: #361b3c;
  -webkit-box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
  box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
}

.btn-check:checked + .btn-dark,
.btn-check:active + .btn-dark,
.btn-dark:active,
.btn-dark.active,
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #361b3c;
  border-color: #331a38;
}

.btn-check:checked + .btn-dark:focus,
.btn-check:active + .btn-dark:focus,
.btn-dark:active:focus,
.btn-dark.active:focus,
.show > .btn-dark.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
  box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
}

.btn-dark:disabled,
.btn-dark.disabled {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-outline-primary {
  color: #717cff;
  border-color: #717cff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-check:focus + .btn-outline-primary,
.btn-outline-primary:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
}

.btn-check:checked + .btn-outline-primary,
.btn-check:active + .btn-outline-primary,
.btn-outline-primary:active,
.btn-outline-primary.active,
.btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-check:checked + .btn-outline-primary:focus,
.btn-check:active + .btn-outline-primary:focus,
.btn-outline-primary:active:focus,
.btn-outline-primary.active:focus,
.btn-outline-primary.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
}

.btn-outline-primary:disabled,
.btn-outline-primary.disabled {
  color: #717cff;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #a79ca8;
  border-color: #a79ca8;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-check:focus + .btn-outline-secondary,
.btn-outline-secondary:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
  box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
}

.btn-check:checked + .btn-outline-secondary,
.btn-check:active + .btn-outline-secondary,
.btn-outline-secondary:active,
.btn-outline-secondary.active,
.btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-check:checked + .btn-outline-secondary:focus,
.btn-check:active + .btn-outline-secondary:focus,
.btn-outline-secondary:active:focus,
.btn-outline-secondary.active:focus,
.btn-outline-secondary.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
  box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
}

.btn-outline-secondary:disabled,
.btn-outline-secondary.disabled {
  color: #a79ca8;
  background-color: transparent;
}

.btn-outline-success {
  color: #5fa500;
  border-color: #5fa500;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-check:focus + .btn-outline-success,
.btn-outline-success:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
  box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
}

.btn-check:checked + .btn-outline-success,
.btn-check:active + .btn-outline-success,
.btn-outline-success:active,
.btn-outline-success.active,
.btn-outline-success.dropdown-toggle.show {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-check:checked + .btn-outline-success:focus,
.btn-check:active + .btn-outline-success:focus,
.btn-outline-success:active:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
  box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
}

.btn-outline-success:disabled,
.btn-outline-success.disabled {
  color: #5fa500;
  background-color: transparent;
}

.btn-outline-info {
  color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-check:focus + .btn-outline-info,
.btn-outline-info:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
  box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
}

.btn-check:checked + .btn-outline-info,
.btn-check:active + .btn-outline-info,
.btn-outline-info:active,
.btn-outline-info.active,
.btn-outline-info.dropdown-toggle.show {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-check:checked + .btn-outline-info:focus,
.btn-check:active + .btn-outline-info:focus,
.btn-outline-info:active:focus,
.btn-outline-info.active:focus,
.btn-outline-info.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
  box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
}

.btn-outline-info:disabled,
.btn-outline-info.disabled {
  color: #3eb8f4;
  background-color: transparent;
}

.btn-outline-warning {
  color: #ffee25;
  border-color: #ffee25;
}

.btn-outline-warning:hover {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-check:focus + .btn-outline-warning,
.btn-outline-warning:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
}

.btn-check:checked + .btn-outline-warning,
.btn-check:active + .btn-outline-warning,
.btn-outline-warning:active,
.btn-outline-warning.active,
.btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-check:checked + .btn-outline-warning:focus,
.btn-check:active + .btn-outline-warning:focus,
.btn-outline-warning:active:focus,
.btn-outline-warning.active:focus,
.btn-outline-warning.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
}

.btn-outline-warning:disabled,
.btn-outline-warning.disabled {
  color: #ffee25;
  background-color: transparent;
}

.btn-outline-danger {
  color: #ff717c;
  border-color: #ff717c;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
}

.btn-check:checked + .btn-outline-danger,
.btn-check:active + .btn-outline-danger,
.btn-outline-danger:active,
.btn-outline-danger.active,
.btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-check:checked + .btn-outline-danger:focus,
.btn-check:active + .btn-outline-danger:focus,
.btn-outline-danger:active:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
}

.btn-outline-danger:disabled,
.btn-outline-danger.disabled {
  color: #ff717c;
  background-color: transparent;
}

.btn-outline-light {
  color: #f9fafd;
  border-color: #f9fafd;
}

.btn-outline-light:hover {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-check:focus + .btn-outline-light,
.btn-outline-light:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
  box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
}

.btn-check:checked + .btn-outline-light,
.btn-check:active + .btn-outline-light,
.btn-outline-light:active,
.btn-outline-light.active,
.btn-outline-light.dropdown-toggle.show {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-check:checked + .btn-outline-light:focus,
.btn-check:active + .btn-outline-light:focus,
.btn-outline-light:active:focus,
.btn-outline-light.active:focus,
.btn-outline-light.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
  box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
}

.btn-outline-light:disabled,
.btn-outline-light.disabled {
  color: #f9fafd;
  background-color: transparent;
}

.btn-outline-dark {
  color: #44224b;
  border-color: #44224b;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-check:focus + .btn-outline-dark,
.btn-outline-dark:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
  box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
}

.btn-check:checked + .btn-outline-dark,
.btn-check:active + .btn-outline-dark,
.btn-outline-dark:active,
.btn-outline-dark.active,
.btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-check:checked + .btn-outline-dark:focus,
.btn-check:active + .btn-outline-dark:focus,
.btn-outline-dark:active:focus,
.btn-outline-dark.active:focus,
.btn-outline-dark.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
  box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
}

.btn-outline-dark:disabled,
.btn-outline-dark.disabled {
  color: #44224b;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #717cff;
  text-decoration: none;
}

.btn-link:hover {
  color: #5a63cc;
  text-decoration: underline;
}

.btn-link:focus {
  text-decoration: underline;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #c3bcc4;
}

.btn-lg,
.btn-group-lg > .btn {
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 0.625rem;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.fade {
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  -webkit-transition: height 0.35s ease;
  -o-transition: height 0.35s ease;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 1rem;
  color: #778295;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu[data-bs-popper] {
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-end {
    --bs-position: end;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
}

.dropend .dropdown-menu[data-bs-popper] {
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
}

.dropstart .dropdown-menu[data-bs-popper] {
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #a79ca8;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #968c97;
  text-decoration: none;
  background-color: #e8e5e9;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #717cff;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #ccc6cd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #c3bcc4;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1rem;
  color: #a79ca8;
}

.dropdown-menu-dark {
  color: #dfdbdf;
  background-color: #b0a7b2;
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item {
  color: #dfdbdf;
}

.dropdown-menu-dark .dropdown-item:hover,
.dropdown-menu-dark .dropdown-item:focus {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
  color: #fff;
  background-color: #717cff;
}

.dropdown-menu-dark .dropdown-item.disabled,
.dropdown-menu-dark .dropdown-item:disabled {
  color: #ccc6cd;
}

.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item-text {
  color: #dfdbdf;
}

.dropdown-menu-dark .dropdown-header {
  color: #ccc6cd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn:nth-child(n + 3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.35rem;
  padding-left: 1.35rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split,
.btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split,
.btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.35rem;
  padding-left: 1.35rem;
}

.btn-group-vertical {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #c3bcc4;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dfdbdf;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e8e5e9 #e8e5e9 #dfdbdf;
  isolation: isolate;
}

.nav-tabs .nav-link.disabled {
  color: #c3bcc4;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #b9b1bb;
  background-color: #fff;
  border-color: #dfdbdf #dfdbdf #fff;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #717cff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: inherit;
  flex-wrap: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: -0.046rem;
  padding-bottom: -0.046rem;
  margin-right: 1rem;
  font-size: calc(1.2978rem + 0.5736vw);
  white-space: nowrap;
}

@media (min-width: 1200px) {
  .navbar-brand {
    font-size: 1.728rem;
  }
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.2rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.313rem;
  -webkit-transition: -webkit-box-shadow 0.15s ease-in-out;
  transition: -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: box-shadow 0.15s ease-in-out;
  transition: box-shadow 0.15s ease-in-out;
  transition: box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: #717cff;
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: #717cff;
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.25);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: #717cff;
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.95);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url([svg]);
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: #717cff;
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.9);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url([svg]);
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 2px);
  border-top-right-radius: calc(0.25rem - 2px);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 2px);
  border-bottom-left-radius: calc(0.25rem - 2px);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 1rem;
}

.card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background-color: #faf9fa;
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 2px) calc(0.25rem - 2px) 0 0;
}

.card-footer {
  padding: 0.5rem 1rem;
  background-color: #faf9fa;
  border-top: 2px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 2px) calc(0.25rem - 2px);
}

.card-header-tabs {
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
  margin-left: -0.5rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  border-radius: calc(0.25rem - 2px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 2px);
  border-top-right-radius: calc(0.25rem - 2px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 2px);
  border-bottom-left-radius: calc(0.25rem - 2px);
}

.card-group > .card {
  margin-bottom: 1rem;
}

@media (min-width: 576px) {
  .card-group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
}

@media (min-width: 576px) {
  .card-group > .card {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-bottom: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.breadcrumb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #c3bcc4;
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: #c3bcc4;
}

.pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #717cff;
  background-color: #fff;
  border: 1px solid #dfdbdf;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: #5a63cc;
  text-decoration: none;
  background-color: #e8e5e9;
  border-color: #dfdbdf;
}

.page-link:focus {
  z-index: 3;
  color: #5a63cc;
  background-color: #e8e5e9;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.page-item.disabled .page-link {
  color: #c3bcc4;
  pointer-events: none;
  background-color: #fff;
  border-color: #dfdbdf;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.2rem;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  color: #444a99;
  background-color: #e3e5ff;
  border-color: #d4d8ff;
}

.alert-primary .alert-link {
  color: #363b7a;
}

.alert-secondary {
  color: #645e65;
  background-color: #edebee;
  border-color: #e5e1e5;
}

.alert-secondary .alert-link {
  color: #504b51;
}

.alert-success {
  color: #396300;
  background-color: #dfedcc;
  border-color: #cfe4b3;
}

.alert-success .alert-link {
  color: #2e4f00;
}

.alert-info {
  color: #256e92;
  background-color: #d8f1fd;
  border-color: #c5eafc;
}

.alert-info .alert-link {
  color: #1e5875;
}

.alert-warning {
  color: #998f16;
  background-color: #fffcd3;
  border-color: #fffabe;
}

.alert-warning .alert-link {
  color: #7a7212;
}

.alert-danger {
  color: #99444a;
  background-color: #ffe3e5;
  border-color: #ffd4d8;
}

.alert-danger .alert-link {
  color: #7a363b;
}

.alert-light {
  color: #959698;
  background-color: #fefeff;
  border-color: #fdfefe;
}

.alert-light .alert-link {
  color: #77787a;
}

.alert-dark {
  color: #29142d;
  background-color: #dad3db;
  border-color: #c7bdc9;
}

.alert-dark .alert-link {
  color: #211024;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e8e5e9;
  border-radius: 0.25rem;
}

.progress-bar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #717cff;
  -webkit-transition: width 0.6s ease;
  -o-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.progress-bar-striped {
  background-image: -o-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  -webkit-animation: 1s linear infinite progress-bar-stripes;
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    -webkit-animation: none;
    animation: none;
  }
}

.list-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #b9b1bb;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #b9b1bb;
  text-decoration: none;
  background-color: #fafafa;
}

.list-group-item-action:active {
  color: #778295;
  background-color: #e8e5e9;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  color: #a79ca8;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #c3bcc4;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #444a99;
  background-color: #e3e5ff;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
  color: #444a99;
  background-color: #cccee6;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #444a99;
  border-color: #444a99;
}

.list-group-item-secondary {
  color: #645e65;
  background-color: #edebee;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
  color: #645e65;
  background-color: #d5d4d6;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #645e65;
  border-color: #645e65;
}

.list-group-item-success {
  color: #396300;
  background-color: #dfedcc;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
  color: #396300;
  background-color: #c9d5b8;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #396300;
  border-color: #396300;
}

.list-group-item-info {
  color: #256e92;
  background-color: #d8f1fd;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
  color: #256e92;
  background-color: #c2d9e4;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #256e92;
  border-color: #256e92;
}

.list-group-item-warning {
  color: #998f16;
  background-color: #fffcd3;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
  color: #998f16;
  background-color: #e6e3be;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #998f16;
  border-color: #998f16;
}

.list-group-item-danger {
  color: #99444a;
  background-color: #ffe3e5;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
  color: #99444a;
  background-color: #e6ccce;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #99444a;
  border-color: #99444a;
}

.list-group-item-light {
  color: #959698;
  background-color: #fefeff;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
  color: #959698;
  background-color: #e5e5e6;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #959698;
  border-color: #959698;
}

.list-group-item-dark {
  color: #29142d;
  background-color: #dad3db;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
  color: #29142d;
  background-color: #c4bec5;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #29142d;
  border-color: #29142d;
}

.btn-close {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url([svg]) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}

.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}

.btn-close:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  opacity: 1;
}

.btn-close:disabled,
.btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  -webkit-filter: invert(1) grayscale(100%) brightness(200%);
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe;
  box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe;
  border-radius: 0.25rem;
}

.toast:not(.showing):not(.show) {
  opacity: 0;
}

.toast.hide {
  display: none;
}

.toast-container {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: 1rem;
}

.toast-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.5rem 0.75rem;
  color: #c3bcc4;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  -webkit-transition: -webkit-transform 0.3s ease-out;
  transition: -webkit-transform 0.3s ease-out;
  -o-transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
  -webkit-transform: translate(0, -50px);
  -ms-transform: translate(0, -50px);
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.modal.show .modal-dialog {
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}

.modal.modal-static .modal-dialog {
  -webkit-transform: scale(1.02);
  -ms-transform: scale(1.02);
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1.25rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dfdbdf;
  border-top-left-radius: calc(1.25rem - 1px);
  border-top-right-radius: calc(1.25rem - 1px);
}

.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dfdbdf;
  border-bottom-right-radius: calc(1.25rem - 1px);
  border-bottom-left-radius: calc(1.25rem - 1px);
}

.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
}

@media (min-width: 576px) {
  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }
}

@media (min-width: 576px) {
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
}

@media (min-width: 576px) {
  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}

.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[data-popper-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: 0;
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end,
.bs-tooltip-auto[data-popper-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[data-popper-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: 0;
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start,
.bs-tooltip-auto[data-popper-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1070;
  display: block;
  max-width: 276px;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1.25rem;
}

.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-end > .popover-arrow,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-end > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f0f0f0;
}

.bs-popover-start > .popover-arrow,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-start > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #091e40;
  background-color: #f0f0f0;
  border-bottom: 1px solid #d8d8d8;
  border-top-left-radius: calc(1.25rem - 1px);
  border-top-right-radius: calc(1.25rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1rem 1rem;
  color: #778295;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.6s ease-in-out;
  transition: -webkit-transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  -webkit-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  -webkit-transition: opacity 0s 0.6s;
  -o-transition: opacity 0s 0.6s;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #778295;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.9;
  -webkit-transition: opacity 0.15s ease;
  -o-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #778295;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url([svg]);
}

.carousel-control-next-icon {
  background-image: url([svg]);
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 7px;
  height: 7px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #717cff;
  background-clip: padding-box;
  border: 0;
  border-top: 0 solid transparent;
  border-bottom: 0 solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  -o-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  -webkit-filter: invert(1) grayscale(100);
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  -webkit-animation: 0.75s linear infinite spinner-grow;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }
}

.accordion-button {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: 1.5rem 2.6rem;
  font-size: 1rem;
  color: #778295;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, border-radius 0.15s ease,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: #44224b;
  background-color: #fff;
  -webkit-box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.125);
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.125);
}

.accordion-button:not(.collapsed)::after {
  background-image: url("");
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.accordion-button::after {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 1.8rem;
  height: 1.8rem;
  margin-left: auto;
  content: "";
  background-image: url("");
  background-repeat: no-repeat;
  background-size: 1.8rem;
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  -o-transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: #fff;
  outline: 0;
  -webkit-box-shadow: #f9fafd;
  box-shadow: #f9fafd;
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.125);
}

.accordion-item:first-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-item:last-of-type {
  margin-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-body {
  padding: 1.5rem 2.6rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-primary {
  color: #717cff;
}

.link-primary:hover,
.link-primary:focus {
  color: #5a63cc;
}

.link-secondary {
  color: #a79ca8;
}

.link-secondary:hover,
.link-secondary:focus {
  color: #867d86;
}

.link-success {
  color: #5fa500;
}

.link-success:hover,
.link-success:focus {
  color: #4c8400;
}

.link-info {
  color: #3eb8f4;
}

.link-info:hover,
.link-info:focus {
  color: #3293c3;
}

.link-warning {
  color: #ffee25;
}

.link-warning:hover,
.link-warning:focus {
  color: #fff151;
}

.link-danger {
  color: #ff717c;
}

.link-danger:hover,
.link-danger:focus {
  color: #cc5a63;
}

.link-light {
  color: #f9fafd;
}

.link-light:hover,
.link-light:focus {
  color: #fafbfd;
}

.link-dark {
  color: #44224b;
}

.link-dark:hover,
.link-dark:focus {
  color: #361b3c;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1540px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.d-inline-flex {
  display: -webkit-inline-box !important;
  display: -ms-inline-flexbox !important;
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  -webkit-box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe !important;
  box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe !important;
}

.shadow-sm {
  -webkit-box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15) !important;
  box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15) !important;
}

.shadow-lg {
  -webkit-box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-absolute {
  position: absolute !important;
}

.position-relative {
  position: relative !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  -webkit-transform: translateX(-50%) translateY(-50%) !important;
  -ms-transform: translateX(-50%) translateY(-50%) !important;
  transform: translateX(-50%) translateY(-50%) !important;
}

.translate-middle-x {
  -webkit-transform: translateX(-50%) !important;
  -ms-transform: translateX(-50%) !important;
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  -webkit-transform: translateY(-50%) !important;
  -ms-transform: translateY(-50%) !important;
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dfdbdf !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dfdbdf !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dfdbdf !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dfdbdf !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dfdbdf !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-facebook {
  border-color: #3c5a99 !important;
}

.border-google-plus {
  border-color: #dd4b39 !important;
}

.border-twitter {
  border-color: #1da1f2 !important;
}

.border-linkedin {
  border-color: #0077b5 !important;
}

.border-youtube {
  border-color: red !important;
}

.border-github {
  border-color: #333 !important;
}

.border-black {
  border-color: #000 !important;
}

.border-100 {
  border-color: #fafafa !important;
}

.border-200 {
  border-color: #e8e5e9 !important;
}

.border-300 {
  border-color: #dfdbdf !important;
}

.border-400 {
  border-color: #d5d1d6 !important;
}

.border-500 {
  border-color: #ccc6cd !important;
}

.border-600 {
  border-color: #c3bcc4 !important;
}

.border-700 {
  border-color: #b9b1bb !important;
}

.border-800 {
  border-color: #b0a7b2 !important;
}

.border-900 {
  border-color: #a79ca8 !important;
}

.border-1000 {
  border-color: #778295 !important;
}

.border-1100 {
  border-color: #44224b !important;
}

.border-1200 {
  border-color: #091e40 !important;
}

.border-white {
  border-color: #fff !important;
}

.border-primary {
  border-color: #717cff !important;
}

.border-secondary {
  border-color: #a79ca8 !important;
}

.border-success {
  border-color: #5fa500 !important;
}

.border-info {
  border-color: #3eb8f4 !important;
}

.border-warning {
  border-color: #ffee25 !important;
}

.border-danger {
  border-color: #ff717c !important;
}

.border-light {
  border-color: #f9fafd !important;
}

.border-dark {
  border-color: #44224b !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-25 {
  width: 25vw !important;
}

.vw-50 {
  width: 50vw !important;
}

.vw-75 {
  width: 75vw !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-25 {
  height: 25vh !important;
}

.vh-50 {
  height: 50vh !important;
}

.vh-75 {
  height: 75vh !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-25 {
  min-height: 25vh !important;
}

.min-vh-50 {
  min-height: 50vh !important;
}

.min-vh-75 {
  min-height: 75vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  -webkit-box-flex: 1 !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
}

.flex-row {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
}

.flex-column {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
}

.flex-row-reverse {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: reverse !important;
  -ms-flex-direction: row-reverse !important;
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: reverse !important;
  -ms-flex-direction: column-reverse !important;
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  -webkit-box-flex: 0 !important;
  -ms-flex-positive: 0 !important;
  flex-grow: 0 !important;
}

.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
}

.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}

.flex-nowrap {
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  -ms-flex-wrap: wrap-reverse !important;
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.8rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-6 {
  gap: 4rem !important;
}

.gap-7 {
  gap: 5rem !important;
}

.gap-8 {
  gap: 7.5rem !important;
}

.gap-9 {
  gap: 10rem !important;
}

.gap-10 {
  gap: 12.5rem !important;
}

.gap-11 {
  gap: 15rem !important;
}

.justify-content-start {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
}

.justify-content-end {
  -webkit-box-pack: end !important;
  -ms-flex-pack: end !important;
  justify-content: flex-end !important;
}

.justify-content-center {
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.justify-content-between {
  -webkit-box-pack: justify !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}

.justify-content-around {
  -ms-flex-pack: distribute !important;
  justify-content: space-around !important;
}

.justify-content-evenly {
  -webkit-box-pack: space-evenly !important;
  -ms-flex-pack: space-evenly !important;
  justify-content: space-evenly !important;
}

.align-items-start {
  -webkit-box-align: start !important;
  -ms-flex-align: start !important;
  align-items: flex-start !important;
}

.align-items-end {
  -webkit-box-align: end !important;
  -ms-flex-align: end !important;
  align-items: flex-end !important;
}

.align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.align-items-baseline {
  -webkit-box-align: baseline !important;
  -ms-flex-align: baseline !important;
  align-items: baseline !important;
}

.align-items-stretch {
  -webkit-box-align: stretch !important;
  -ms-flex-align: stretch !important;
  align-items: stretch !important;
}

.align-content-start {
  -ms-flex-line-pack: start !important;
  align-content: flex-start !important;
}

.align-content-end {
  -ms-flex-line-pack: end !important;
  align-content: flex-end !important;
}

.align-content-center {
  -ms-flex-line-pack: center !important;
  align-content: center !important;
}

.align-content-between {
  -ms-flex-line-pack: justify !important;
  align-content: space-between !important;
}

.align-content-around {
  -ms-flex-line-pack: distribute !important;
  align-content: space-around !important;
}

.align-content-stretch {
  -ms-flex-line-pack: stretch !important;
  align-content: stretch !important;
}

.align-self-auto {
  -ms-flex-item-align: auto !important;
  align-self: auto !important;
}

.align-self-start {
  -ms-flex-item-align: start !important;
  align-self: flex-start !important;
}

.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.align-self-baseline {
  -ms-flex-item-align: baseline !important;
  align-self: baseline !important;
}

.align-self-stretch {
  -ms-flex-item-align: stretch !important;
  align-self: stretch !important;
}

.order-first {
  -webkit-box-ordinal-group: 0 !important;
  -ms-flex-order: -1 !important;
  order: -1 !important;
}

.order-0 {
  -webkit-box-ordinal-group: 1 !important;
  -ms-flex-order: 0 !important;
  order: 0 !important;
}

.order-1 {
  -webkit-box-ordinal-group: 2 !important;
  -ms-flex-order: 1 !important;
  order: 1 !important;
}

.order-2 {
  -webkit-box-ordinal-group: 3 !important;
  -ms-flex-order: 2 !important;
  order: 2 !important;
}

.order-3 {
  -webkit-box-ordinal-group: 4 !important;
  -ms-flex-order: 3 !important;
  order: 3 !important;
}

.order-4 {
  -webkit-box-ordinal-group: 5 !important;
  -ms-flex-order: 4 !important;
  order: 4 !important;
}

.order-5 {
  -webkit-box-ordinal-group: 6 !important;
  -ms-flex-order: 5 !important;
  order: 5 !important;
}

.order-last {
  -webkit-box-ordinal-group: 7 !important;
  -ms-flex-order: 6 !important;
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.8rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-6 {
  margin: 4rem !important;
}

.m-7 {
  margin: 5rem !important;
}

.m-8 {
  margin: 7.5rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.m-10 {
  margin: 12.5rem !important;
}

.m-11 {
  margin: 15rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.8rem !important;
  margin-left: 1.8rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-6 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-7 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-8 {
  margin-right: 7.5rem !important;
  margin-left: 7.5rem !important;
}

.mx-9 {
  margin-right: 10rem !important;
  margin-left: 10rem !important;
}

.mx-10 {
  margin-right: 12.5rem !important;
  margin-left: 12.5rem !important;
}

.mx-11 {
  margin-right: 15rem !important;
  margin-left: 15rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.8rem !important;
  margin-bottom: 1.8rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-6 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-7 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-8 {
  margin-top: 7.5rem !important;
  margin-bottom: 7.5rem !important;
}

.my-9 {
  margin-top: 10rem !important;
  margin-bottom: 10rem !important;
}

.my-10 {
  margin-top: 12.5rem !important;
  margin-bottom: 12.5rem !important;
}

.my-11 {
  margin-top: 15rem !important;
  margin-bottom: 15rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.8rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-6 {
  margin-top: 4rem !important;
}

.mt-7 {
  margin-top: 5rem !important;
}

.mt-8 {
  margin-top: 7.5rem !important;
}

.mt-9 {
  margin-top: 10rem !important;
}

.mt-10 {
  margin-top: 12.5rem !important;
}

.mt-11 {
  margin-top: 15rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.8rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-6 {
  margin-right: 4rem !important;
}

.me-7 {
  margin-right: 5rem !important;
}

.me-8 {
  margin-right: 7.5rem !important;
}

.me-9 {
  margin-right: 10rem !important;
}

.me-10 {
  margin-right: 12.5rem !important;
}

.me-11 {
  margin-right: 15rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.8rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-6 {
  margin-bottom: 4rem !important;
}

.mb-7 {
  margin-bottom: 5rem !important;
}

.mb-8 {
  margin-bottom: 7.5rem !important;
}

.mb-9 {
  margin-bottom: 10rem !important;
}

.mb-10 {
  margin-bottom: 12.5rem !important;
}

.mb-11 {
  margin-bottom: 15rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.8rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-6 {
  margin-left: 4rem !important;
}

.ms-7 {
  margin-left: 5rem !important;
}

.ms-8 {
  margin-left: 7.5rem !important;
}

.ms-9 {
  margin-left: 10rem !important;
}

.ms-10 {
  margin-left: 12.5rem !important;
}

.ms-11 {
  margin-left: 15rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.8rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.m-n6 {
  margin: -4rem !important;
}

.m-n7 {
  margin: -5rem !important;
}

.m-n8 {
  margin: -7.5rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.m-n10 {
  margin: -12.5rem !important;
}

.m-n11 {
  margin: -15rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.8rem !important;
  margin-left: -1.8rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n6 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n7 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.mx-n8 {
  margin-right: -7.5rem !important;
  margin-left: -7.5rem !important;
}

.mx-n9 {
  margin-right: -10rem !important;
  margin-left: -10rem !important;
}

.mx-n10 {
  margin-right: -12.5rem !important;
  margin-left: -12.5rem !important;
}

.mx-n11 {
  margin-right: -15rem !important;
  margin-left: -15rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.8rem !important;
  margin-bottom: -1.8rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n6 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n7 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.my-n8 {
  margin-top: -7.5rem !important;
  margin-bottom: -7.5rem !important;
}

.my-n9 {
  margin-top: -10rem !important;
  margin-bottom: -10rem !important;
}

.my-n10 {
  margin-top: -12.5rem !important;
  margin-bottom: -12.5rem !important;
}

.my-n11 {
  margin-top: -15rem !important;
  margin-bottom: -15rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.8rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.mt-n6 {
  margin-top: -4rem !important;
}

.mt-n7 {
  margin-top: -5rem !important;
}

.mt-n8 {
  margin-top: -7.5rem !important;
}

.mt-n9 {
  margin-top: -10rem !important;
}

.mt-n10 {
  margin-top: -12.5rem !important;
}

.mt-n11 {
  margin-top: -15rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.8rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.me-n6 {
  margin-right: -4rem !important;
}

.me-n7 {
  margin-right: -5rem !important;
}

.me-n8 {
  margin-right: -7.5rem !important;
}

.me-n9 {
  margin-right: -10rem !important;
}

.me-n10 {
  margin-right: -12.5rem !important;
}

.me-n11 {
  margin-right: -15rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.8rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.mb-n6 {
  margin-bottom: -4rem !important;
}

.mb-n7 {
  margin-bottom: -5rem !important;
}

.mb-n8 {
  margin-bottom: -7.5rem !important;
}

.mb-n9 {
  margin-bottom: -10rem !important;
}

.mb-n10 {
  margin-bottom: -12.5rem !important;
}

.mb-n11 {
  margin-bottom: -15rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.8rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.ms-n6 {
  margin-left: -4rem !important;
}

.ms-n7 {
  margin-left: -5rem !important;
}

.ms-n8 {
  margin-left: -7.5rem !important;
}

.ms-n9 {
  margin-left: -10rem !important;
}

.ms-n10 {
  margin-left: -12.5rem !important;
}

.ms-n11 {
  margin-left: -15rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.8rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-6 {
  padding: 4rem !important;
}

.p-7 {
  padding: 5rem !important;
}

.p-8 {
  padding: 7.5rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.p-10 {
  padding: 12.5rem !important;
}

.p-11 {
  padding: 15rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.8rem !important;
  padding-left: 1.8rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-6 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-7 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.px-8 {
  padding-right: 7.5rem !important;
  padding-left: 7.5rem !important;
}

.px-9 {
  padding-right: 10rem !important;
  padding-left: 10rem !important;
}

.px-10 {
  padding-right: 12.5rem !important;
  padding-left: 12.5rem !important;
}

.px-11 {
  padding-right: 15rem !important;
  padding-left: 15rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.8rem !important;
  padding-bottom: 1.8rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-6 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-7 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.py-8 {
  padding-top: 7.5rem !important;
  padding-bottom: 7.5rem !important;
}

.py-9 {
  padding-top: 10rem !important;
  padding-bottom: 10rem !important;
}

.py-10 {
  padding-top: 12.5rem !important;
  padding-bottom: 12.5rem !important;
}

.py-11 {
  padding-top: 15rem !important;
  padding-bottom: 15rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.8rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-6 {
  padding-top: 4rem !important;
}

.pt-7 {
  padding-top: 5rem !important;
}

.pt-8 {
  padding-top: 7.5rem !important;
}

.pt-9 {
  padding-top: 10rem !important;
}

.pt-10 {
  padding-top: 12.5rem !important;
}

.pt-11 {
  padding-top: 15rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.8rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-6 {
  padding-right: 4rem !important;
}

.pe-7 {
  padding-right: 5rem !important;
}

.pe-8 {
  padding-right: 7.5rem !important;
}

.pe-9 {
  padding-right: 10rem !important;
}

.pe-10 {
  padding-right: 12.5rem !important;
}

.pe-11 {
  padding-right: 15rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.8rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-6 {
  padding-bottom: 4rem !important;
}

.pb-7 {
  padding-bottom: 5rem !important;
}

.pb-8 {
  padding-bottom: 7.5rem !important;
}

.pb-9 {
  padding-bottom: 10rem !important;
}

.pb-10 {
  padding-bottom: 12.5rem !important;
}

.pb-11 {
  padding-bottom: 15rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.8rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-6 {
  padding-left: 4rem !important;
}

.ps-7 {
  padding-left: 5rem !important;
}

.ps-8 {
  padding-left: 7.5rem !important;
}

.ps-9 {
  padding-left: 10rem !important;
}

.ps-10 {
  padding-left: 12.5rem !important;
}

.ps-11 {
  padding-left: 15rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs--2 {
  font-size: 0.69444rem !important;
}

.fs--1 {
  font-size: 0.83333rem !important;
}

.fs-0 {
  font-size: 1rem !important;
}

.fs-1 {
  font-size: 1.2rem !important;
}

.fs-2 {
  font-size: 1.44rem !important;
}

.fs-3 {
  font-size: 1.728rem !important;
}

.fs-4 {
  font-size: 2.0736rem !important;
}

.fs-5 {
  font-size: 2.48832rem !important;
}

.fs-6 {
  font-size: 2.98598rem !important;
}

.fs-7 {
  font-size: 3.58318rem !important;
}

.fs-8 {
  font-size: 4.29982rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-thin {
  font-weight: 100 !important;
}

.fw-lighter {
  font-weight: 200 !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semi-bold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: 800 !important;
}

.fw-black {
  font-weight: 900 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.text-primary {
  color: #016b9d !important;
}

.text-secondary {
  color: #a79ca8 !important;
}

.text-success {
  color: #5fa500 !important;
}

.text-info {
  color: #3eb8f4 !important;
}

.text-warning {
  color: #ffee25 !important;
}

.text-danger {
  color: #ff717c !important;
}

.text-light {
  color: #f9fafd !important;
}

.text-dark {
  color: #44224b !important;
}

.text-white {
  color: #fff !important;
}

.text-body {
  color: #778295 !important;
}

.text-muted {
  color: #ccc6cd !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  color: inherit !important;
}

.bg-facebook {
  background-color: #3c5a99 !important;
}

.bg-google-plus {
  background-color: #dd4b39 !important;
}

.bg-twitter {
  background-color: #1da1f2 !important;
}

.bg-linkedin {
  background-color: #0077b5 !important;
}

.bg-youtube {
  background-color: red !important;
}

.bg-github {
  background-color: #333 !important;
}

.bg-black {
  background-color: #000 !important;
}

.bg-100 {
  background-color: #fafafa !important;
  padding-top: 0.25rem;
}

.bg-200 {
  background-color: #e8e5e9 !important;
  padding-top: 0.25rem;
}

.bg-300 {
  background-color: #dfdbdf !important;
}

.bg-400 {
  background-color: #d5d1d6 !important;
}

.bg-500 {
  background-color: #ccc6cd !important;
}

.bg-600 {
  background-color: #c3bcc4 !important;
}

.bg-700 {
  background-color: #b9b1bb !important;
}

.bg-800 {
  background-color: #b0a7b2 !important;
}

.bg-900 {
  background-color: #a79ca8 !important;
}

.bg-1000 {
  background-color: #778295 !important;
}

.bg-1100 {
  background-color: #44224b !important;
}

.bg-1200 {
  background-color: #091e40 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-primary {
  background-color: #717cff !important;
}

.bg-secondary {
  background-color: #a79ca8 !important;
}

.bg-success {
  background-color: #5fa500 !important;
}

.bg-info {
  background-color: #3eb8f4 !important;
}

.bg-warning {
  background-color: #ffee25 !important;
}

.bg-danger {
  background-color: #ff717c !important;
}

.bg-light {
  background-color: #f9fafd !important;
}

.bg-dark {
  background-color: #44224b !important;
}

.bg-body {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: rgba(0, 0, 0, 0) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  -moz-user-select: all !important;
  -ms-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.625rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 1.25rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-start-radius: 0.25rem !important;
  border-top-end-radius: 0.25rem !important;
}

.rounded-top-lg {
  border-top-start-radius: 1.25rem !important;
  border-top-end-radius: 1.25rem !important;
}

.rounded-top-0 {
  border-top-start-radius: 0 !important;
  border-top-end-radius: 0 !important;
}

.rounded-end {
  border-top-end-radius: 0.25rem !important;
  border-bottom-end-radius: 0.25rem !important;
}

.rounded-end-lg {
  border-top-end-radius: 1.25rem !important;
  border-bottom-end-radius: 1.25rem !important;
}

.rounded-end-0 {
  border-top-end-radius: 0 !important;
  border-bottom-end-radius: 0 !important;
}

.rounded-bottom {
  border-bottom-end-radius: 0.25rem !important;
  border-bottom-start-radius: 0.25rem !important;
}

.rounded-bottom-lg {
  border-bottom-end-radius: 1.25rem !important;
  border-bottom-start-radius: 1.25rem !important;
}

.rounded-bottom-0 {
  border-bottom-end-radius: 0 !important;
  border-bottom-start-radius: 0 !important;
}

.rounded-start {
  border-bottom-start-radius: 0.25rem !important;
  border-top-start-radius: 0.25rem !important;
}

.rounded-start-lg {
  border-bottom-start-radius: 1.25rem !important;
  border-top-start-radius: 1.25rem !important;
}

.rounded-start-0 {
  border-bottom-start-radius: 0 !important;
  border-top-start-radius: 0 !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-85 {
  opacity: 0.85 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.text-facebook {
  color: #3c5a99 !important;
}

.text-google-plus {
  color: #dd4b39 !important;
}

.text-twitter {
  color: #1da1f2 !important;
}

.text-linkedin {
  color: #0077b5 !important;
}

.text-youtube {
  color: red !important;
}

.text-github {
  color: #333 !important;
}

.text-black {
  color: #000 !important;
}

.text-100 {
  color: #fafafa !important;
}

.text-200 {
  color: #e8e5e9 !important;
}

.text-300 {
  color: #dfdbdf !important;
}

.text-400 {
  color: #d5d1d6 !important;
}

.text-500 {
  color: #ccc6cd !important;
}

.text-600 {
  color: #c3bcc4 !important;
}

.text-700 {
  color: #b9b1bb !important;
}

.text-800 {
  color: #b0a7b2 !important;
}

.text-900 {
  color: #a79ca8 !important;
}

.text-1000 {
  color: #778295 !important;
}

.text-1100 {
  color: #44224b !important;
}

.text-1200 {
  color: #091e40 !important;
}

.text-white {
  color: #fff !important;
}

.max-vh-25 {
  max-height: 25vh !important;
}

.max-vh-50 {
  max-height: 50vh !important;
}

.max-vh-75 {
  max-height: 75vh !important;
}

.max-vh-100 {
  max-height: 100vh !important;
}

.border-x {
  border-left: 1px solid #dfdbdf !important;
  border-right: 1px solid #dfdbdf !important;
}

.border-x-0 {
  border-left: 0 !important;
  border-right: 0 !important;
}

.border-y {
  border-top: 1px solid #dfdbdf !important;
  border-bottom: 1px solid #dfdbdf !important;
}

.border-y-0 {
  border-top: 0 !important;
  border-bottom: 0 !important;
}

.border-dashed {
  border: 1px dashed #dfdbdf !important;
}

.border-dashed-top {
  border-top: 1px dashed #dfdbdf !important;
}

.border-dashed-end {
  border-right: 1px dashed #dfdbdf !important;
}

.border-dashed-start {
  border-left: 1px dashed #dfdbdf !important;
}

.border-dashed-bottom {
  border-bottom: 1px dashed #dfdbdf !important;
}

.border-dashed-x {
  border-left: 1px dashed #dfdbdf !important;
  border-right: 1px dashed #dfdbdf !important;
}

.border-dashed-y {
  border-top: 1px dashed #dfdbdf !important;
  border-bottom: 1px dashed #dfdbdf !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.bg-soft-primary {
  background-color: #f1f2ff !important;
}

.bg-soft-secondary {
  background-color: #f6f5f6 !important;
}

.bg-soft-success {
  background-color: #eff6e6 !important;
}

.bg-soft-info {
  background-color: #ecf8fe !important;
}

.bg-soft-warning {
  background-color: #fffde9 !important;
}

.bg-soft-danger {
  background-color: #fff1f2 !important;
}

.bg-soft-light {
  background-color: #feffff !important;
}

.bg-soft-dark {
  background-color: #ece9ed !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
}

@media (min-width: 576px) {
  .float-sm-end {
    float: right !important;
  }
}

@media (min-width: 576px) {
  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline {
    display: inline !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 576px) {
  .d-sm-block {
    display: block !important;
  }
}

@media (min-width: 576px) {
  .d-sm-grid {
    display: grid !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table {
    display: table !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table-row {
    display: table-row !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 576px) {
  .d-sm-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
}

@media (min-width: 576px) {
  .position-sm-static {
    position: static !important;
  }
}

@media (min-width: 576px) {
  .position-sm-absolute {
    position: absolute !important;
  }
}

@media (min-width: 576px) {
  .position-sm-relative {
    position: relative !important;
  }
}

@media (min-width: 576px) {
  .position-sm-fixed {
    position: fixed !important;
  }
}

@media (min-width: 576px) {
  .position-sm-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 576px) {
  .border-sm {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-0 {
    border: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .w-sm-25 {
    width: 25% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-50 {
    width: 50% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-75 {
    width: 75% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-100 {
    width: 100% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-auto {
    width: auto !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-25 {
    width: 25vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-50 {
    width: 50vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-75 {
    width: 75vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-100 {
    width: 100vw !important;
  }
}

@media (min-width: 576px) {
  .h-sm-25 {
    height: 25% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-50 {
    height: 50% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-75 {
    height: 75% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-100 {
    height: 100% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-auto {
    height: auto !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-25 {
    height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-50 {
    height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-75 {
    height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-100 {
    height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-0 {
    gap: 0 !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 576px) {
  .order-sm-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
}

@media (min-width: 576px) {
  .m-sm-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-auto {
    margin: auto !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 576px) {
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 576px) {
  .me-sm-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-0 {
    padding: 0 !important;
  }
}

@media (min-width: 576px) {
  .p-sm-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 576px) {
  .text-sm-start {
    text-align: left !important;
  }
}

@media (min-width: 576px) {
  .text-sm-end {
    text-align: right !important;
  }
}

@media (min-width: 576px) {
  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-youtube {
    color: red !important;
  }
}

@media (min-width: 576px) {
  .text-sm-github {
    color: #333 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-black {
    color: #000 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 576px) {
  .text-sm-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .text-sm-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 576px) {
  .text-sm-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 576px) {
  .text-sm-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-white {
    color: #fff !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .border-sm-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
}

@media (min-width: 768px) {
  .float-md-end {
    float: right !important;
  }
}

@media (min-width: 768px) {
  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline {
    display: inline !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 768px) {
  .d-md-block {
    display: block !important;
  }
}

@media (min-width: 768px) {
  .d-md-grid {
    display: grid !important;
  }
}

@media (min-width: 768px) {
  .d-md-table {
    display: table !important;
  }
}

@media (min-width: 768px) {
  .d-md-table-row {
    display: table-row !important;
  }
}

@media (min-width: 768px) {
  .d-md-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 768px) {
  .d-md-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .position-md-static {
    position: static !important;
  }
}

@media (min-width: 768px) {
  .position-md-absolute {
    position: absolute !important;
  }
}

@media (min-width: 768px) {
  .position-md-relative {
    position: relative !important;
  }
}

@media (min-width: 768px) {
  .position-md-fixed {
    position: fixed !important;
  }
}

@media (min-width: 768px) {
  .position-md-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 768px) {
  .border-md {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-0 {
    border: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .w-md-25 {
    width: 25% !important;
  }
}

@media (min-width: 768px) {
  .w-md-50 {
    width: 50% !important;
  }
}

@media (min-width: 768px) {
  .w-md-75 {
    width: 75% !important;
  }
}

@media (min-width: 768px) {
  .w-md-100 {
    width: 100% !important;
  }
}

@media (min-width: 768px) {
  .w-md-auto {
    width: auto !important;
  }
}

@media (min-width: 768px) {
  .vw-md-25 {
    width: 25vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-50 {
    width: 50vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-75 {
    width: 75vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-100 {
    width: 100vw !important;
  }
}

@media (min-width: 768px) {
  .h-md-25 {
    height: 25% !important;
  }
}

@media (min-width: 768px) {
  .h-md-50 {
    height: 50% !important;
  }
}

@media (min-width: 768px) {
  .h-md-75 {
    height: 75% !important;
  }
}

@media (min-width: 768px) {
  .h-md-100 {
    height: 100% !important;
  }
}

@media (min-width: 768px) {
  .h-md-auto {
    height: auto !important;
  }
}

@media (min-width: 768px) {
  .vh-md-25 {
    height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-50 {
    height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-75 {
    height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-100 {
    height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .flex-md-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 768px) {
  .flex-md-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 768px) {
  .flex-md-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 768px) {
  .flex-md-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 768px) {
  .flex-md-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 768px) {
  .flex-md-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 768px) {
  .gap-md-0 {
    gap: 0 !important;
  }
}

@media (min-width: 768px) {
  .gap-md-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .order-md-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 768px) {
  .order-md-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 768px) {
  .order-md-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 768px) {
  .order-md-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 768px) {
  .order-md-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 768px) {
  .order-md-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 768px) {
  .order-md-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 768px) {
  .order-md-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
}

@media (min-width: 768px) {
  .m-md-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-auto {
    margin: auto !important;
  }
}

@media (min-width: 768px) {
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 768px) {
  .mt-md-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 768px) {
  .me-md-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 768px) {
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 768px) {
  .ms-md-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-0 {
    padding: 0 !important;
  }
}

@media (min-width: 768px) {
  .p-md-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 768px) {
  .text-md-start {
    text-align: left !important;
  }
}

@media (min-width: 768px) {
  .text-md-end {
    text-align: right !important;
  }
}

@media (min-width: 768px) {
  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 768px) {
  .text-md-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 768px) {
  .text-md-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 768px) {
  .text-md-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 768px) {
  .text-md-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 768px) {
  .text-md-youtube {
    color: red !important;
  }
}

@media (min-width: 768px) {
  .text-md-github {
    color: #333 !important;
  }
}

@media (min-width: 768px) {
  .text-md-black {
    color: #000 !important;
  }
}

@media (min-width: 768px) {
  .text-md-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 768px) {
  .text-md-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 768px) {
  .text-md-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .text-md-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 768px) {
  .text-md-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 768px) {
  .text-md-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 768px) {
  .text-md-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 768px) {
  .text-md-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 768px) {
  .text-md-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 768px) {
  .text-md-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 768px) {
  .text-md-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 768px) {
  .text-md-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 768px) {
  .text-md-white {
    color: #fff !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .border-md-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
}

@media (min-width: 992px) {
  .float-lg-end {
    float: right !important;
  }
}

@media (min-width: 992px) {
  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline {
    display: inline !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 992px) {
  .d-lg-block {
    display: block !important;
  }
}

@media (min-width: 992px) {
  .d-lg-grid {
    display: grid !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table {
    display: table !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table-row {
    display: table-row !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 992px) {
  .d-lg-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .position-lg-static {
    position: static !important;
  }
}

@media (min-width: 992px) {
  .position-lg-absolute {
    position: absolute !important;
  }
}

@media (min-width: 992px) {
  .position-lg-relative {
    position: relative !important;
  }
}

@media (min-width: 992px) {
  .position-lg-fixed {
    position: fixed !important;
  }
}

@media (min-width: 992px) {
  .position-lg-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 992px) {
  .border-lg {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-0 {
    border: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .w-lg-25 {
    width: 25% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-50 {
    width: 50% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-75 {
    width: 75% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-100 {
    width: 100% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-auto {
    width: auto !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-25 {
    width: 25vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-50 {
    width: 50vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-75 {
    width: 75vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-100 {
    width: 100vw !important;
  }
}

@media (min-width: 992px) {
  .h-lg-25 {
    height: 25% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-50 {
    height: 50% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-75 {
    height: 75% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-100 {
    height: 100% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-auto {
    height: auto !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-25 {
    height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-50 {
    height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-75 {
    height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-100 {
    height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-0 {
    gap: 0 !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .order-lg-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
}

@media (min-width: 992px) {
  .m-lg-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-auto {
    margin: auto !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 992px) {
  .me-lg-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-0 {
    padding: 0 !important;
  }
}

@media (min-width: 992px) {
  .p-lg-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 992px) {
  .text-lg-start {
    text-align: left !important;
  }
}

@media (min-width: 992px) {
  .text-lg-end {
    text-align: right !important;
  }
}

@media (min-width: 992px) {
  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-youtube {
    color: red !important;
  }
}

@media (min-width: 992px) {
  .text-lg-github {
    color: #333 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-black {
    color: #000 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 992px) {
  .text-lg-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .text-lg-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 992px) {
  .text-lg-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 992px) {
  .text-lg-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-white {
    color: #fff !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .border-lg-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-end {
    float: right !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline {
    display: inline !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-block {
    display: block !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-grid {
    display: grid !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table {
    display: table !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table-row {
    display: table-row !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-static {
    position: static !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-absolute {
    position: absolute !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-relative {
    position: relative !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-fixed {
    position: fixed !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .border-xl {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-0 {
    border: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-25 {
    width: 25% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-50 {
    width: 50% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-75 {
    width: 75% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-100 {
    width: 100% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-auto {
    width: auto !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-25 {
    width: 25vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-50 {
    width: 50vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-75 {
    width: 75vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-100 {
    width: 100vw !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-25 {
    height: 25% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-50 {
    height: 50% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-75 {
    height: 75% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-100 {
    height: 100% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-auto {
    height: auto !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-25 {
    height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-50 {
    height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-75 {
    height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-100 {
    height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-0 {
    gap: 0 !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-auto {
    margin: auto !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-0 {
    padding: 0 !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-start {
    text-align: left !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-end {
    text-align: right !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-youtube {
    color: red !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-github {
    color: #333 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-black {
    color: #000 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-white {
    color: #fff !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-start {
    float: left !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-end {
    float: right !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-none {
    float: none !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline {
    display: inline !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-block {
    display: block !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-grid {
    display: grid !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table {
    display: table !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table-row {
    display: table-row !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-none {
    display: none !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-static {
    position: static !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-absolute {
    position: absolute !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-relative {
    position: relative !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-fixed {
    position: fixed !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-0 {
    border: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-25 {
    width: 25% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-50 {
    width: 50% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-75 {
    width: 75% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-100 {
    width: 100% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-auto {
    width: auto !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-25 {
    width: 25vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-50 {
    width: 50vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-75 {
    width: 75vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-100 {
    width: 100vw !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-25 {
    height: 25% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-50 {
    height: 50% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-75 {
    height: 75% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-100 {
    height: 100% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-auto {
    height: auto !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-25 {
    height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-50 {
    height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-75 {
    height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-100 {
    height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-0 {
    gap: 0 !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-0 {
    margin: 0 !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-auto {
    margin: auto !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-0 {
    padding: 0 !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-start {
    text-align: left !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-end {
    text-align: right !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-youtube {
    color: red !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-github {
    color: #333 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-black {
    color: #000 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-white {
    color: #fff !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-0 {
    border-radius: 0 !important;
  }
}

::-webkit-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::-moz-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

:-ms-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::-ms-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: smooth;
  scroll-padding-top: 6.3125rem;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

pre,
code {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

section {
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;
}

@media (min-width: 992px) {
  section {
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }
}

input,
button,
select,
optgroup,
textarea,
label,
.alert,
.badge,
.blockquote-footer,
.btn,
.navbar,
.pagination,
.valid-feedback,
.invalid-feedback {
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

pre {
  margin: 0;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

strong {
  font-weight: 600;
}

label {
  font-weight: 500 !important;
  margin-bottom: 0.5rem;
}

ol,
ul {
  padding-left: 1.1rem;
}

.firefox .dropcap:first-letter {
  margin-top: 0.175em;
}

.chrome .btn-close {
  background-clip: unset;
}

.text-smallcaps {
  font-variant: small-caps;
}

.text-superscript {
  vertical-align: super;
}

.text-word-break {
  word-break: break-word;
}

.font-sans-serif {
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

.font-base {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
}

.fs-error {
  font-size: 7rem;
}

@media (min-width: 576px) {
  .fs-error {
    font-size: 10rem;
  }
}

.text-justify {
  text-align: justify !important;
}

.shape-up {
  margin-top: -21rem;
}

.bg-holder {
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  will-change: transform, opacity, filter;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-repeat: no-repeat;
  z-index: 0;
}

.bg-holder.bg-right {
  left: auto;
  right: 0;
}

.bg-holder.overlay:before {
  position: absolute;
  content: "";
  background: rgba(0, 0, 0, 0.25);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.bg-holder.overlay-0:before {
  background: rgba(0, 0, 0, 0.7);
}

.bg-holder.overlay-1:before {
  background: rgba(0, 0, 0, 0.55);
}

.bg-holder.overlay-2:before {
  background: rgba(0, 0, 0, 0.4);
}

.bg-holder .bg-video {
  position: absolute;
  display: block;
  z-index: -1;
  top: 0;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
  min-width: 100%;
}

.bg-holder .bg-youtube {
  position: absolute !important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.bg-light-gradient {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(236, 240, 253, 0)),
    color-stop(14.32%, rgba(236, 240, 253, 0.53)),
    color-stop(45.83%, #ecf0fd),
    color-stop(84.33%, rgba(236, 240, 253, 0.43)),
    to(rgba(236, 240, 253, 0))
  );
  background: -o-linear-gradient(
    top,
    rgba(236, 240, 253, 0) 0%,
    rgba(236, 240, 253, 0.53) 14.32%,
    #ecf0fd 45.83%,
    rgba(236, 240, 253, 0.43) 84.33%,
    rgba(236, 240, 253, 0) 100%
  );
  background: linear-gradient(
    180deg,
    rgba(236, 240, 253, 0) 0%,
    rgba(236, 240, 253, 0.53) 14.32%,
    #ecf0fd 45.83%,
    rgba(236, 240, 253, 0.43) 84.33%,
    rgba(236, 240, 253, 0) 100%
  );
}

.bg-primary-gradient {
  background: -o-linear-gradient(241.82deg, #51b4f7 9.05%, #5a98f2 76.74%);
  background: linear-gradient(208.18deg, #51b4f7 9.05%, #5a98f2 76.74%);
}

.overflow-hidden[class*="rounded"] {
  -webkit-mask-image: radial-gradient(#fff, #000);
  mask-image: radial-gradient(#fff, #000);
}

.border-top-2 {
  border-top-width: 0.125rem !important;
}

.border-end-2 {
  border-right-width: 0.125rem !important;
}

.border-bottom-2 {
  border-bottom-width: 0.125rem !important;
}

.border-start-2 {
  border-left-width: 0.125rem !important;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  position: relative;
}

.all-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.flex-center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.flex-between-center {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-end-center {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.link-black {
  color: #000 !important;
}

.link-black:hover,
.link-black:focus {
  color: #000 !important;
}

.link-100 {
  color: #fafafa !important;
}

.link-100:hover,
.link-100:focus {
  color: #d4d4d4 !important;
}

.link-200 {
  color: #e8e5e9 !important;
}

.link-200:hover,
.link-200:focus {
  color: #c3bcc6 !important;
}

.link-300 {
  color: #dfdbdf !important;
}

.link-300:hover,
.link-300:focus {
  color: #bbb3bb !important;
}

.link-400 {
  color: #d5d1d6 !important;
}

.link-400:hover,
.link-400:focus {
  color: #b0a9b2 !important;
}

.link-500 {
  color: #ccc6cd !important;
}

.link-500:hover,
.link-500:focus {
  color: #a89da9 !important;
}

.link-600 {
  color: #c3bcc4 !important;
}

.link-600:hover,
.link-600:focus {
  color: #9f93a0 !important;
}

.link-700 {
  color: #b9b1bb !important;
}

.link-700:hover,
.link-700:focus {
  color: #948897 !important;
}

.link-800 {
  color: #b0a7b2 !important;
}

.link-800:hover,
.link-800:focus {
  color: #8b7e8e !important;
}

.link-900 {
  color: #a79ca8 !important;
}

.link-900:hover,
.link-900:focus {
  color: #827484 !important;
}

.link-1000 {
  color: #778295 !important;
}

.link-1000:hover,
.link-1000:focus {
  color: #545d6c !important;
}

.link-1100 {
  color: #44224b !important;
}

.link-1100:hover,
.link-1100:focus {
  color: #140a16 !important;
}

.link-1200 {
  color: #091e40 !important;
}

.link-1200:hover,
.link-1200:focus {
  color: #000 !important;
}

.link-white {
  color: #fff !important;
}

.link-white:hover,
.link-white:focus {
  color: #d9d9d9 !important;
}

.shadow-transition {
  -webkit-box-shadow: 0 25px 45px rgba(167, 156, 168, 0.075);
  box-shadow: 0 25px 45px rgba(167, 156, 168, 0.075);
  -webkit-transition: -webkit-box-shadow 0.4s ease;
  transition: -webkit-box-shadow 0.4s ease;
  -o-transition: box-shadow 0.4s ease;
  transition: box-shadow 0.4s ease;
  transition: box-shadow 0.4s ease, -webkit-box-shadow 0.4s ease;
}

.icon-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.icon-group .icon-item:not(:last-child) {
  margin-right: 0.5rem;
}

.icon-item {
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #b9b1bb;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  height: 2.5rem;
  width: 2.5rem;
  border: 0;
  font-size: 0.875rem;
  -webkit-box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15);
  box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15);
}

.icon-item:hover,
.icon-item:focus {
  background-color: #e8e5e9;
}

.icon-item.icon-item-sm {
  height: 1.875rem;
  width: 1.875rem;
}

.icon-item.icon-item-lg {
  height: 2.75rem;
  width: 2.75rem;
}

.fontawesome-i2svg-active .icon-indicator {
  opacity: 1;
}

.fit-cover {
  -o-object-fit: cover;
  object-fit: cover;
}

.z-index-1 {
  z-index: 1;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index--1 {
  z-index: -1;
}

.sticky-sidebar {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1020;
  top: 5.3125rem;
}

.circle-dashed {
  border: 1px dashed #717cff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
}

.hover-text-decoration-none:hover,
.hover-text-decoration-none:focus {
  text-decoration: none;
}

.resize-none {
  resize: none;
}

.collapsed .collapse-icon {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
}

.collapse-icon {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

[data-dismiss="dropdown"] *,
[data-offset-top] *,
[data-toggle="collapse"] *,
[data-toggle="tooltip"] *,
[data-toggle="popover"] * {
  pointer-events: none;
}

.outline-none {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.outline-none:hover,
.outline-none:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.vertical-line:after {
  position: absolute;
  content: "";
  height: 75%;
  width: 1px;
  background: #dfdbdf;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-line.vertical-line-400:after {
  background-color: #d5d1d6;
}

.transition-base {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.transition-none {
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.fsp-75 {
  font-size: 75%;
}

.min-w-0 {
  min-width: 0;
}

.terms-sidebar .nav-link {
  color: #ccc6cd;
  font-weight: 500;
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

.terms-sidebar .nav-link.active {
  color: #717cff;
}

.card-price {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
}

.backdrop {
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}

.btn-glow {
  position: relative;
}

.btn-glow::before {
  content: "";
  height: 80%;
  width: 80%;
  position: absolute;
  top: 10%;
  left: 10%;
  display: inline-block;
  background-color: inherit;
  opacity: 0.55;
  -webkit-filter: blur(26px);
  filter: blur(26px);
  -webkit-transform: translateY(45%);
  -ms-transform: translateY(45%);
  transform: translateY(45%);
  z-index: -1;
  border-radius: 10px;
}

.hover-top {
  -webkit-transform: translateY(0) translateZ(0);
  transform: translateY(0) translateZ(0);
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.hover-top.hover-top-shadow-lg:hover,
.hover-top.hover-top-shadow-lg:focus {
  -webkit-transform: translateY(-0.3125rem) translateZ(0);
  transform: translateY(-0.3125rem) translateZ(0);
}

.hover-top:hover,
.hover-top:focus {
  -webkit-transform: translateY(-0.125rem) translateZ(0);
  transform: translateY(-0.125rem) translateZ(0);
  -webkit-box-shadow: 0.5rem 0.5rem 1.5rem rgba(22, 28, 45, 0.1) !important;
  box-shadow: 0.5rem 0.5rem 1.5rem rgba(22, 28, 45, 0.1) !important;
  background-color: #016b9d;
  color: #fff;
}

.hover-top:hover .heading-color,
.hover-top:focus .heading-color {
  color: #fff;
}

.badge {
  line-height: 0.8125rem;
}

.badge-circle {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.5rem;
}

@media (min-width: 768px) {
  .badge-circle {
    height: 3.4rem;
    width: 3.4rem;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 1rem;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  color: #778295;
  text-align: center;
  opacity: 0.9;
  -webkit-transition: opacity 0.15s ease;
  -o-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #778295;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-indicators {
  position: static;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  margin: 0;
}

.carousel-indicators li {
  border-radius: 50%;
}

.carousel-indicators .active {
  opacity: 1;
  background-color: #717cff;
  width: 8px;
  height: 8px;
}

.carousel-control-prev {
  left: auto;
  right: 45px;
}

.card-span {
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  border: 0;
}

.card-span .card-span-img {
  position: absolute;
  left: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
}

.input-group {
  position: relative;
}

.input-group .input-box {
  padding-left: 2.2rem;
  vertical-align: middle;
}

.input-group .input-box-icon {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

/* # sourceMappingURL=theme.min.css.map */


/* ============================================================ */
/* NEW HERO SECTION DESIGN (BTA REDESIGN - PERFECT ZOOM LOCK)   */
/* ============================================================ */

.hero-section {
  --primary-red: #c61a09;
  --primary-red-gradient: linear-gradient(135deg, #e53935 0%, #c61a09 100%);
  --primary-hover-gradient: linear-gradient(135deg, #c61a09 0%, #a11406 100%);
  --dark-neutral: #1a1a1a;
  --muted-text: #4a5568;
  --bg-gradient: linear-gradient(135deg, #ffffff 60%, #fff5f5 100%);
  --border-color: #e2e8f0;
  --shadow-premium: 0 10px 30px -5px rgba(0, 0, 0, 0.08), 0 4px 12px -2px rgba(0, 0, 0, 0.03);
  --shadow-button: 0 8px 20px -4px rgba(198, 26, 9, 0.35);
  --shadow-stat: 0 6px 20px rgba(0, 0, 0, 0.03);
  --font-title: 'Poppins', 'Outfit', sans-serif;
  --font-body: 'Poppins', 'Inter', sans-serif;

  position: relative;
  /* DOUBLE BACKGROUND: Gradient putih di atas, kelas siswa belajar remang-remang di bawah (opacity ~6%) */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.94) 50%, rgba(255, 245, 245, 0.94) 100%), 
              url('/static/images/page/about/bta_classroom_bg.jpg') no-repeat center center;
  background-size: cover;
  height: 600px; /* Tinggi optimal desktop standar dinaikkan dari 580px */
  display: flex;
  align-items: center;
  padding: 40px 0 0 0;
  overflow: hidden;
  font-family: var(--font-body);
}

/* Background overlays & Patterns */
.hero-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(rgba(198, 26, 9, 0.08) 2px, transparent 2px);
  background-size: 32px 32px;
  opacity: 0.8;
  pointer-events: none;
  z-index: 1;
}

/* Diagonal red element on bottom right (DESKTOP ONLY) */
.hero-diagonal-red {
  position: absolute;
  bottom: -20px;
  right: -200px;
  width: 800px;
  height: 280px;
  background-color: #c61a09;
  transform: rotate(-6deg);
  transform-origin: bottom right;
  z-index: 1;
  pointer-events: none;
  opacity: 0.95;
  box-shadow: -10px 0 30px rgba(198, 26, 9, 0.15);
  transition: all 0.3s ease;
}

.hero-container {
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 24px;
  padding-left: 24px;
  position: relative;
  z-index: 2;
  height: 100%;
}

.hero-container > .row {
  height: 100%;
  align-items: stretch;
}

/* Columns Configuration */
.hero-col-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 55px; /* Ditambah sedikit */
  gap: 18px; /* Jarak/gap per baris dijauhkan dari 12px ke 18px */
  height: 100%;
  position: relative;
  z-index: 10;
  transition: all 0.3s ease;
}

.hero-col-visual {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
}

/* Typography styles */
.hero-title {
  font-family: var(--font-title) !important;
  font-size: 52px !important; /* Font diperbesar sedikit dari 48px */
  font-weight: 900 !important;
  line-height: 1.35 !important; /* Spasi antar baris dijauhkan dari 1.3 ke 1.35 */
  color: #1a1a1a !important;
  margin: 0;
  margin-bottom: 6px; /* Tambah sela bawah judul */
  letter-spacing: -1.2px;
}

.hero-title span.text-highlight {
  color: #c61a09;
}

.hero-subtitle {
  font-size: 1.02rem !important; /* Font diperbesar sedikit dari 0.95rem */
  color: #4a5568 !important;
  line-height: 1.45 !important;
  margin: 0;
  margin-bottom: 12px; /* Tambah sela bawah sub-judul */
  max-width: 540px;
}

/* Selector Card Design */
.hero-selector-card {
  background: #ffffff;
  border-radius: 12px;
  min-height: 60px;
  padding: 4px 10px;
  box-shadow: var(--shadow-premium);
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  max-width: 680px;
  margin-top: 2px;
}

.selector-group {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}

.selector-label {
  font-size: 0.65rem;
  font-weight: 700;
  color: #718096;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  text-align: left;
}

.selector-control-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.selector-icon {
  position: absolute;
  left: 0;
  width: 16px;
  height: 16px;
  color: #c61a09;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selector-select {
  width: 100%;
  padding: 2px 20px 2px 18px;
  font-size: 0.85rem;
  font-weight: 750;
  color: #1a1a1a;
  border: none;
  background: transparent;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.selector-control-wrapper::after {
  content: "";
  width: 8px;
  height: 5px;
  position: absolute;
  right: 4px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23c61a09'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  pointer-events: none;
}

.selector-separator {
  width: 1px;
  height: 30px;
  background-color: #e2e8f0;
}

.btn-register {
  background: linear-gradient(135deg, #e53935 0%, #c61a09 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 0.88rem;
  font-weight: 750;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  white-space: nowrap;
  box-shadow: 0 8px 20px -4px rgba(198, 26, 9, 0.35);
}

.btn-register:hover {
  background: linear-gradient(135deg, #c61a09 0%, #a11406 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 24px -4px rgba(198, 26, 9, 0.45);
}

/* Statistics Mini-Cards Grid */
.hero-stats-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 5px;
  max-width: 680px;
  width: 100%;
}

@media (min-width: 1200px) {
  .hero-stats-row {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 10px;
  box-shadow: var(--shadow-stat);
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.4);
}

.stat-icon-wrapper {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(198, 26, 9, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #c61a09;
}

.stat-icon-wrapper svg {
  width: 14px;
  height: 14px;
}

.stat-text {
  font-size: 0.72rem;
  color: #1a1a1a;
  line-height: 1.25;
  text-align: left;
}

.stat-text strong {
  font-weight: 800;
  font-size: 0.82rem;
}

/* Hero Image Container (DESKTOP) */
.hero-image {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 400px; /* Ukuran model dinaikkan dari 380px */
  height: 500px;    /* Ukuran model dinaikkan dari 480px */
  overflow: hidden;
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.12));
  transform: translateX(-130px);
  transition: all 0.3s ease;
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Trophy Card Floating */
.trophy-card {
  position: absolute;
  bottom: 85px;
  right: 30px;
  background: #ffffff;
  border-radius: 14px;
  padding: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.5);
  z-index: 3;
  width: 140px; /* Lebar trophy card diperbesar sedikit */
  height: auto !important;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  animation: floating 4s ease-in-out infinite;
}

@keyframes floating {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
}

.trophy-badge {
  color: #fbbf24;
}

.stars-row {
  display: flex;
  gap: 2px;
  color: #fbbf24;
}

.trophy-title {
  font-size: 0.6rem;
  color: #718096;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.trophy-year {
  font-size: 1rem;
  font-weight: 900;
  color: #1a1a1a;
  margin: 0;
  white-space: nowrap; /* Mencegah pemisahan kata '1980-an' */
}

.trophy-year span {
  color: #c61a09;
}

.trophy-subtext {
  font-size: 0.6rem;
  font-weight: 700;
  color: #4a5568;
  margin: 0;
  line-height: 1.2;
}

/* Social Media Row */
.social-media-container {
  position: absolute;
  bottom: 25px;
  right: 30px;
  z-index: 5;
  display: flex;
  gap: 8px;
}

.social-icon-btn {
  width: 34px;
  height: 34px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  border: 1px solid rgba(226, 232, 240, 0.6);
}

.social-icon-btn svg,
.social-icon-btn i {
  fill: #c61a09 !important;
  color: #c61a09 !important;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.social-icon-btn:hover {
  transform: translateY(-3px);
  background-color: #c61a09;
  border-color: #c61a09;
  box-shadow: 0 8px 20px rgba(198, 26, 9, 0.25);
}

.social-icon-btn:hover svg,
.social-icon-btn:hover i {
  fill: #ffffff !important;
  color: #ffffff !important;
  transform: scale(1.1);
}

/* ============================================================ */
/* Responsive Media Queries (OPTIMAL UNTUK SEMUA RATIO DEVICE)  */
/* ============================================================ */

/* --- 1. SCALING PROPORSIONAL UNTUK LAYAR LEBAR / LAPTOP BARU (1400px - 1749px) --- */
@media (min-width: 1400px) {
  .hero-section {
    height: 720px; /* Tinggi optimal vertikal dinaikkan */
  }

  .hero-container {
    max-width: 1440px; /* Lebar container lebih luas */
  }

  .hero-col-content {
    gap: 22px; /* Gap baris dinaikkan */
  }

  .hero-title {
    font-size: 60px !important; /* Diperbesar */
    line-height: 1.35 !important;
  }

  .hero-subtitle {
    font-size: 1.12rem !important; /* Diperbesar */
    max-width: 600px;
  }

  .hero-selector-card {
    max-width: 760px;
    min-height: 68px;
    padding: 6px 12px;
  }

  .selector-label {
    font-size: 0.7rem;
  }

  .selector-select {
    font-size: 0.92rem;
  }

  .btn-register {
    font-size: 0.92rem;
    padding: 10px 22px;
  }

  .hero-stats-row {
    max-width: 760px;
    gap: 12px;
  }

  .stat-card {
    padding: 10px 14px;
    gap: 10px;
  }

  .stat-icon-wrapper {
    width: 36px;
    height: 36px;
  }

  .stat-icon-wrapper svg {
    width: 16px;
    height: 16px;
  }

  .stat-text {
    font-size: 0.78rem;
  }

  .stat-text strong {
    font-size: 0.88rem;
  }

  .hero-image {
    max-width: 480px; /* Diperbesar */
    height: 600px;    /* Diperbesar */
    transform: translateX(-130px); /* Kunci offset agar letaknya sama tanpa tabrakan */
  }

  .hero-diagonal-red {
    width: 1000px;
    height: 330px;
    right: -250px; 
  }

  .trophy-card {
    bottom: 110px;
    right: 30px; 
    width: 160px; /* Trophy card diperbesar */
  }

  .social-media-container {
    bottom: 45px;
    right: 30px;
  }
}

/* --- 2. SCALING PROPORSIONAL UNTUK LAYAR MONITOR FULL HD / 1920px (>= 1750px) --- */
@media (min-width: 1750px) {
  .hero-section {
    height: 780px; /* Tinggi optimal vertikal dinaikkan */
  }

  .hero-container {
    max-width: 1660px; /* Container terlebar */
  }

  .hero-col-content {
    gap: 24px; /* Gap baris dinaikkan */
  }

  .hero-title {
    font-size: 68px !important; /* Diperbesar */
    line-height: 1.35 !important;
  }

  .hero-subtitle {
    font-size: 1.24rem !important; /* Diperbesar */
    max-width: 680px;
  }

  .hero-selector-card {
    max-width: 840px;
    min-height: 74px;
    padding: 8px 14px;
  }

  .selector-label {
    font-size: 0.76rem;
  }

  .selector-select {
    font-size: 0.98rem;
  }

  .btn-register {
    font-size: 1rem;
    padding: 12px 26px;
  }

  .hero-stats-row {
    max-width: 840px;
    gap: 14px;
  }

  .stat-card {
    padding: 12px 18px;
    gap: 12px;
  }

  .stat-icon-wrapper {
    width: 42px;
    height: 42px;
  }

  .stat-icon-wrapper svg {
    width: 18px;
    height: 18px;
  }

  .stat-text {
    font-size: 0.84rem;
  }

  .stat-text strong {
    font-size: 0.94rem;
  }

  .hero-image {
    max-width: 540px; /* Diperbesar maksimal */
    height: 660px;    /* Diperbesar maksimal */
    transform: translateX(-130px);
  }

  .hero-diagonal-red {
    width: 1200px;
    height: 380px;
    right: -300px;
  }

  .trophy-card {
    bottom: 125px;
    right: 30px;
    width: 175px; /* Trophy card diperbesar maksimal */
  }

  .social-media-container {
    bottom: 50px;
    right: 30px;
  }
}

/* --- TABLET VIEW & BROWSER HP DEKTOP MODE --- */
@media (max-width: 1024px) {
  .hero-section {
    height: auto;
    padding: 40px 0 20px 0;
  }

  .hero-container > .row {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-col-content {
    text-align: center;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    width: 100%;
  }
  
  .hero-subtitle {
    margin: 0 auto;
  }
  
  .hero-selector-card {
    width: 100%;
    max-width: 680px;
  }
  
  .hero-stats-row {
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
    grid-template-columns: repeat(2, 1fr);
  }
  
  /* Kolom Visual diatur di bawah secara seimbang */
  .hero-col-visual {
    justify-content: center;
    align-items: flex-end;
    margin-top: 30px;
    width: 100%;
    height: 480px;
    overflow: hidden;
    position: relative;
  }
  
  .hero-image {
    transform: translateX(-40px);
    max-width: 320px;
    height: 420px;
  }
  
  .trophy-card {
    bottom: 90px;
    right: 15%;
    height: auto !important;
  }
  
  .social-media-container {
    bottom: 30px;
    right: 15%;
  }

  .hero-diagonal-red {
    display: block;
    width: 120%;
    height: 240px;
    bottom: -10px;
    right: -10%;
    transform: rotate(-3deg);
    border-radius: 20px 20px 0 0;
  }
}

/* --- HP / SMARTPHONE VIEW (COHESIVE INTEGRATED DESIGNS) --- */
@media (max-width: 768px) {
  .hero-section {
    padding: 25px 0 15px 0;
    height: auto;
    min-height: auto;
  }
  
  .hero-container {
    padding-bottom: 10px;
  }

  .hero-container > .row {
    display: block;
    position: relative;
    margin-bottom: 0;
  }

  .hero-col-content {
    display: block;
    width: 100%;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  /* Judul & Subtitle didorong sedikit ke kiri untuk memberi ruang visual di kanan */
  .hero-title {
    font-size: 28px !important;
    line-height: 1.2 !important;
    text-align: left !important;
    padding-right: 38%;
  }

  .hero-subtitle {
    font-size: 0.85rem !important;
    text-align: left !important;
    padding-right: 38%;
    margin-top: 6px;
    margin-bottom: 15px;
    line-height: 1.4 !important;
  }

  /* Selector Card memanjang penuh di bawah */
  .hero-selector-card {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
    gap: 8px;
    width: 100%;
    margin-top: 15px;
    position: relative;
    z-index: 12;
  }
  
  .selector-separator {
    width: 100%;
    height: 1px;
    margin: 2px 0;
  }

  .selector-select {
    padding-left: 22px;
    font-size: 0.8rem;
  }
  
  .btn-register {
    justify-content: center;
    padding: 10px;
    font-size: 0.9rem;
  }

  /* Stats grid 2x2 memanjang penuh di bawah */
  .hero-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 12px;
    width: 100%;
    position: relative;
    z-index: 12;
    padding-right: 0;
    margin-bottom: 0;
  }

  .stat-card {
    padding: 6px 8px;
    border-radius: 8px;
  }

  .stat-text {
    font-size: 0.68rem;
  }

  /* KUNCI VISUAL: Posisi Absolut Pas Sejajar Teks di Atas Kotak Pilih Program */
  .hero-col-visual {
    position: absolute;
    top: 10px;
    bottom: auto;
    right: 10px;
    width: 38%;
    height: 360px;
    z-index: 99 !important; /* Set tinggi agar berada di atas content */
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: 0;
    overflow: visible;
  }

  /* HILANGKAN BACKGROUND MERAH DI HP */
  .hero-diagonal-red {
    display: none !important;
  }
  
  /* Foto model dibuat besar dan menempel rata di dasar 360px (atas kotak Pilih Program) */
  .hero-image {
    transform: none;
    width: 100%;
    max-width: 160px; 
    height: 300px;    
    z-index: 2;
    position: absolute;
    bottom: 0;        
    right: 16px;      
    overflow: visible;
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.12)) drop-shadow(0 4px 10px rgba(198, 26, 9, 0.07)) !important;
  }

  .hero-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  
  /* Trophy Card dikembalikan ke posisi kanan atas semula */
  .trophy-card {
    position: absolute;
    top: -10px;
    right: 0; 
    left: auto;
    bottom: auto;
    width: 90px; /* Dikembalikan ke ukuran semula */
    padding: 6px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    z-index: 4;
    height: auto !important;
  }

  .trophy-badge svg {
    width: 14px;
    height: 14px;
  }

  .trophy-year {
    font-size: 0.75rem;
  }

  .stars-row svg {
    width: 6px;
    height: 6px;
  }

  .trophy-title, .trophy-subtext {
    font-size: 0.5rem;
  }
  
  /* Ikon Sosmed di bawah Trophy Card - Mengikuti di bawah Trophy Card sebelah kanan */
  .social-media-container {
    position: absolute;
    top: 105px; /* Ditempatkan tepat di bawah trophy card */
    right: 0; 
    left: auto;
    bottom: auto;
    transform: none;
    z-index: 100 !important; /* Memastikan berada di paling atas agar bisa diklik */
    pointer-events: auto !important; /* Memastikan interaktif / bisa diklik */
    gap: 4px;
    display: flex;
    flex-direction: row;
  }

  .social-icon-btn {
    width: 26px; /* Diperbesar sedikit agar mudah di-tap di layar HP */
    height: 26px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  .social-icon-btn svg,
  .social-icon-btn i {
    width: 13px;
    height: 13px;
    font-size: 13px;
  }
}

/* --- SMALL SMARTPHONE BREAKPOINT (< 576px) --- */
@media (max-width: 575.98px) {
  .hero-section {
    padding: 16px 0 10px 0;
  }

  .hero-title {
    font-size: 1.45rem !important;
    line-height: 1.25 !important;
    padding-right: 32%;
  }

  .hero-subtitle {
    font-size: 0.78rem !important;
    padding-right: 30%;
    margin-top: 4px;
    margin-bottom: 12px;
  }

  .hero-col-visual {
    height: 300px;
    width: 36%;
    right: 4px;
    top: 6px;
  }

  .hero-image {
    max-width: 135px;
    height: 250px;
    right: 4px;
  }

  .trophy-card {
    width: 78px;
    padding: 4px 6px;
    top: -6px;
    right: 0;
  }

  .trophy-badge svg {
    width: 12px;
    height: 12px;
  }

  .trophy-year {
    font-size: 0.68rem;
  }

  .trophy-title, .trophy-subtext {
    font-size: 0.46rem;
  }

  .social-media-container {
    top: 84px;
    gap: 3px;
  }

  .social-icon-btn {
    width: 24px;
    height: 24px;
  }

  .social-icon-btn svg,
  .social-icon-btn i {
    width: 12px;
    height: 12px;
    font-size: 12px;
  }

  .hero-selector-card {
    padding: 10px;
    gap: 6px;
    margin-top: 10px;
    border-radius: 14px;
  }

  .selector-select {
    font-size: 0.78rem;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .btn-register {
    padding: 8px 12px;
    font-size: 0.85rem;
  }

  .hero-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    margin-top: 8px;
  }

  .stat-card {
    padding: 5px 6px;
    gap: 6px;
  }

  .stat-icon {
    width: 22px;
    height: 22px;
    font-size: 0.72rem;
  }

  .stat-text {
    font-size: 0.65rem;
  }
}

/* Extra small devices (< 375px like iPhone SE / Fold) */
@media (max-width: 374.98px) {
  .hero-title {
    font-size: 1.3rem !important;
    padding-right: 28%;
  }

  .hero-subtitle {
    font-size: 0.72rem !important;
    padding-right: 25%;
  }

  .hero-image {
    max-width: 110px;
    height: 210px;
  }

  .hero-col-visual {
    height: 260px;
    width: 34%;
  }

  .trophy-card {
    width: 70px;
    padding: 3px 4px;
  }

  .social-media-container {
    top: 76px;
  }
}



/* ==========================================
   BTA BANNERS CAROUSEL REDESIGN CSS
   ========================================== */

/* Card Utama */
.banners-card {
  background-color: #ffffff;
  border-radius: 24px !important;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.06), 0 4px 12px -2px rgba(0, 0, 0, 0.02) !important;
  padding: 40px !important;
  border: none !important;
}

/* Tipografi Header */
.banners-title {
  font-family: 'Outfit', 'Poppins', sans-serif;
  font-weight: 750;
  font-size: 1.65rem;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.banners-subtitle {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  color: #5b687a !important; /* Abu-abu kebiruan modern */
  line-height: 1.5;
}

/* Sudut Melengkung Gambar Slide */
#carouselBanners .carousel-inner {
  border-radius: 16px !important; 
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  width: 100% !important;
}

.banner-image {
  border-radius: 16px !important;
  object-fit: cover;
  transition: transform 0.5s ease;
  width: 100% !important;
}

/* Efek zoom tipis saat kursor di atas banner */
#carouselBanners .carousel-item a:hover .banner-image {
  transform: scale(1.01);
}

/* Kustomisasi Tombol Navigasi (Absolute Forcing) */
.custom-carousel-btn {
  position: absolute !important; /* Wajib absolute agar letaknya di ujung container utama */
  width: auto !important;
  height: auto !important;
  opacity: 1 !important; /* Selalu terlihat */
  z-index: 10 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  background: none !important;
  border: none !important;
  padding: 0 !important;
  transition: all 0.3s ease;
}

.custom-carousel-btn.carousel-control-prev {
  left: -24px !important; /* Efek keluar garis (overlap) di kiri */
  right: auto !important;
}

.custom-carousel-btn.carousel-control-next {
  right: -24px !important; /* Efek keluar garis (overlap) di kanan */
  left: auto !important;
}

/* Bulatan Navigasi */
.custom-carousel-icon {
  width: 48px;
  height: 48px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  color: #c61a09; /* Warna merah khas BTA */
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
}

.custom-carousel-icon:hover {
  background-color: #c61a09;
  color: #ffffff;
  transform: scale(1.08);
  box-shadow: 0 8px 24px rgba(198, 26, 9, 0.25);
}

/* Tanda Panah Menggunakan CSS Murni (100% muncul & responsif) */
.custom-carousel-icon::before {
  content: '';
  display: block;
  width: 12px;
  height: 12px;
  border-top: 3.5px solid currentColor;
  border-right: 3.5px solid currentColor;
  transition: all 0.3s ease;
}

.prev-icon::before {
  transform: rotate(-135deg); /* Mengarah ke Kiri */
  margin-left: 4px; /* Menengahkan posisi secara visual */
}

.next-icon::before {
  transform: rotate(45deg); /* Mengarah ke Kanan */
  margin-right: 4px; /* Menengahkan posisi secara visual */
}

/* Animasi mikro saat tombol di-hover */
.custom-carousel-btn:hover .prev-icon::before {
  transform: rotate(-135deg) scale(1.05);
}

.custom-carousel-btn:hover .next-icon::before {
  transform: rotate(45deg) scale(1.05);
}

/* Carousel Indicators (Dots below the carousel - Pushed down) */
#carouselBanners .carousel-indicators {
  margin-top: 24px !important; /* Memberi jarak 24px di bawah poster foto */
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

#carouselBanners .carousel-indicators [data-bs-target] {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background-color: #d1d5db !important; /* Abu-abu saat tidak aktif */
  border: none !important;
  opacity: 1 !important;
  margin: 0 !important;
  transition: all 0.3s ease !important;
  padding: 0 !important;
  box-sizing: content-box;
}

#carouselBanners .carousel-indicators .active {
  background-color: #c61a09 !important; /* Merah saat aktif */
  transform: scale(1.1);
}

/* Penyesuaian Responsif untuk perangkat Tablet dan HP */
@media (max-width: 768px) {
  .banners-card {
    padding: 24px !important;
    border-radius: 20px !important;
  }
  
  .banners-title {
    font-size: 1.35rem;
  }
  
  .banners-subtitle {
    font-size: 0.85rem;
  }
  
  .custom-carousel-icon {
    width: 38px;
    height: 38px;
  }

  .custom-carousel-icon::before {
    width: 9px;
    height: 9px;
    border-top-width: 2.5px;
    border-right-width: 2.5px;
  }
  
  .custom-carousel-btn.carousel-control-prev {
    left: -12px !important;
  }
  
  .custom-carousel-btn.carousel-control-next {
    right: -12px !important;
  }
}

@media (max-width: 576px) {
  .banners-card {
    padding: 16px !important;
    border-radius: 16px !important;
  }

  /* Menggeser tombol sedikit ke dalam agar tidak terpotong di layar HP kecil */
  .custom-carousel-btn.carousel-control-prev {
    left: -8px !important;
  }
  
  .custom-carousel-btn.carousel-control-next {
    right: -8px !important;
  }
}

/* ==========================================================================
   PROGRAM BIMBINGAN SECTION STYLES (LANDSCAPE & NO-SCROLL LAYOUT)
   ========================================================================== */

.services-section {
  padding: 50px 0;
  background-color: #fcfcfc;
  font-family: 'Inter', sans-serif;
}

/* Judul Section (Dibuat Responsive & Wrapping di HP agar tidak keluar layar) */
.section-title {
  font-weight: 800;
  font-size: 2.1rem;
  color: #1a1a1a;
  margin-bottom: 12px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
  max-width: 100%;
}

.text-orange { color: #e67e22 !important; }

.title-ray-left, .title-ray-right {
  display: inline-block;
  width: 24px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: contain;
  flex-shrink: 0;
}
.title-ray-left {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 18'%3E%3Cpath d='M4 9h6M2 3l5 3M3 15l5-3' stroke='%23e67e22' stroke-width='2.5' stroke-linecap='round'/%3E%3C/svg%3E");
}
.title-ray-right {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 18'%3E%3Cpath d='M20 9h-6M22 3l-5 3M21 15l-5-3' stroke='%23e67e22' stroke-width='2.5' stroke-linecap='round'/%3E%3C/svg%3E");
}

.section-subtitle {
  font-size: 0.95rem;
  color: #555555;
  line-height: 1.6;
}

/* Responsive Judul di HP */
@media (max-width: 576px) {
  .section-title {
    font-size: 1.4rem !important;
    gap: 8px;
    padding: 0 10px;
    text-align: center;
  }
  .title-ray-left, .title-ray-right {
    width: 18px;
    height: 14px;
  }
}

/* Grid Kartu Utama */
.program-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  gap: 24px;
  padding: 15px 0;
}

.prog-card {
  background-color: #ffffff;
  border-radius: 24px;
  border: 1px solid #e9edf2;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
}
.prog-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.prog-card.active-highlight {
  border: 2.5px solid #e67e22 !important;
  box-shadow: 0 15px 40px rgba(230, 126, 34, 0.25) !important;
  transform: translateY(-12px) scale(1.02);
}

.prog-card.prog-card-disabled {
  opacity: 0.52;
  filter: grayscale(0.85);
  box-shadow: none !important;
  transform: none !important;
  border-color: #e2e8f0 !important;
}

.prog-card.prog-card-disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

.prog-card-disabled-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(220, 38, 38, 0.95);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 6px;
  margin-top: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.prog-card-btn-disabled {
  background: #cbd5e1 !important;
  color: #64748b !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.branch-prog-card.branch-prog-disabled {
  opacity: 0.45;
  filter: grayscale(0.9);
  cursor: not-allowed !important;
  pointer-events: none;
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.prog-card-top {
  padding: 24px;
  min-height: 250px;
  position: relative;
  color: #ffffff;
}

/* Background Texture Doodles */
.card-theme-orange .prog-card-top {
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  background-image: linear-gradient(135deg, rgba(230, 126, 34, 0.93) 0%, rgba(211, 84, 0, 0.97) 100%), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34h4v4h-4zm-22-6h6v2h-6zm15-10l5 5-5 5zm-15 25h10v2H14zM8 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm38 32a3 3 0 1 1 0 6 3 3 0 0 1 0-6z'/%3E%3C/g%3E%3C/svg%3E");
}
.card-theme-blue .prog-card-top {
  background: linear-gradient(135deg, #0066cc 0%, #004080 100%);
  background-image: linear-gradient(135deg, rgba(0, 102, 204, 0.93) 0%, rgba(0, 64, 128, 0.97) 100%), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Crect x='10' y='10' width='12' height='12' rx='2' ry='2'/%3E%3Cpath d='M30 40l10-10-10-10v20zm14-16h8v2h-8z'/%3E%3Ccircle cx='18' cy='42' r='4'/%3E%3C/g%3E%3C/svg%3E");
}
.card-theme-green .prog-card-top {
  background: linear-gradient(135deg, #4d8e2d 0%, #2c5e1f 100%);
  background-image: linear-gradient(135deg, rgba(77, 142, 45, 0.93) 0%, rgba(44, 94, 31, 0.97) 100%), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M10 20h20v2H10zm35 5h15v2H45z'/%3E%3Ccircle cx='30' cy='30' r='10' stroke='%23ffffff' stroke-opacity='0.08' stroke-width='2' fill='none'/%3E%3C/g%3E%3C/svg%3E");
}
.card-theme-purple .prog-card-top {
  background: linear-gradient(135deg, #5e35b1 0%, #391e75 100%);
  background-image: linear-gradient(135deg, rgba(94, 53, 177, 0.93) 0%, rgba(57, 30, 117, 0.97) 100%), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpolygon points='30,12 35,24 48,26 38,36 41,48 30,42 19,48 22,36 12,26 25,24'/%3E%3C/g%3E%3C/svg%3E");
}

.prog-index-row { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.prog-index-badge {
  background-color: #ffffff;
  font-size: 0.9rem;
  font-weight: 800;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
.card-theme-orange .prog-index-badge { color: #e67e22; }
.card-theme-blue .prog-index-badge { color: #0066cc; }
.card-theme-green .prog-index-badge { color: #4d8e2d; }
.card-theme-purple .prog-index-badge { color: #5e35b1; }

.prog-pill-label {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.prog-card-title {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ffffff !important;
  margin-bottom: 10px;
}

.prog-card-desc-top {
  position: relative;
  z-index: 2;
  font-size: 0.8rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
  width: 63%;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.12);
}

.prog-student-img {
  position: absolute;
  right: 5px;
  bottom: -4px;
  height: 90%;
  z-index: 1;
  pointer-events: none;
  object-fit: contain;
  transition: transform 0.3s ease;
}
.prog-card:hover .prog-student-img { transform: scale(1.04); }

.prog-card-bottom {
  padding: 24px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
}

.prog-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}
.prog-info-item { display: flex; align-items: flex-start; gap: 8px; }
.prog-info-item.span-2 { grid-column: span 2; }

.info-svg-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}
.card-theme-orange .info-svg-icon { color: #e67e22; }
.card-theme-blue .info-svg-icon { color: #0066cc; }
.card-theme-green .info-svg-icon { color: #4d8e2d; }
.card-theme-purple .info-svg-icon { color: #5e35b1; }
.info-svg-icon svg { width: 100%; height: 100%; stroke: currentColor; }

.info-text { display: flex; flex-direction: column; }
.info-label { font-size: 0.65rem; color: #888888; }
.info-val { font-size: 0.8rem; font-weight: 700; color: #2c3e50; }

.prog-focus-box { display: flex; gap: 12px; padding: 12px 14px; border-radius: 12px; margin-bottom: 24px; }
.card-theme-orange .prog-focus-box { background-color: rgba(230, 126, 34, 0.05); border: 1px solid rgba(230, 126, 34, 0.12); }
.card-theme-blue .prog-focus-box { background-color: rgba(0, 102, 204, 0.05); border: 1px solid rgba(0, 102, 204, 0.12); }
.card-theme-green .prog-focus-box { background-color: rgba(77, 142, 45, 0.05); border: 1px solid rgba(77, 142, 45, 0.12); }
.card-theme-purple .prog-focus-box { background-color: rgba(94, 53, 177, 0.05); border: 1px solid rgba(94, 53, 177, 0.12); }

.focus-box-icon { width: 20px; height: 20px; flex-shrink: 0; margin-top: 2px; }
.card-theme-orange .focus-box-icon { color: #e67e22; }
.card-theme-blue .focus-box-icon { color: #0066cc; }
.card-theme-green .focus-box-icon { color: #4d8e2d; }
.card-theme-purple .focus-box-icon { color: #5e35b1; }
.focus-box-icon svg { width: 100%; height: 100%; stroke: currentColor; }

.focus-box-text { display: flex; flex-direction: column; }
.focus-title { font-size: 0.65rem; text-transform: uppercase; letter-spacing: 0.5px; }
.card-theme-orange .focus-title { color: #e67e22; }
.card-theme-blue .focus-title { color: #0066cc; }
.card-theme-green .focus-title { color: #4d8e2d; }
.card-theme-purple .focus-title { color: #5e35b1; }

.focus-bold { font-size: 0.8rem; font-weight: 700; color: #111111; margin-top: 1px; }
.focus-desc { font-size: 0.72rem; line-height: 1.4; color: #666666; margin-top: 2px; }

.prog-card-btn {
  width: 100%;
  border: none;
  font-size: 0.85rem;
  font-weight: 700;
  color: #ffffff;
  padding: 11px 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.card-theme-orange .prog-card-btn { background-color: #e67e22; box-shadow: 0 4px 10px rgba(230, 126, 34, 0.25); }
.card-theme-blue .prog-card-btn { background-color: #0066cc; box-shadow: 0 4px 10px rgba(0, 102, 204, 0.25); }
.card-theme-green .prog-card-btn { background-color: #4d8e2d; box-shadow: 0 4px 10px rgba(77, 142, 45, 0.25); }
.card-theme-purple .prog-card-btn { background-color: #5e35b1; box-shadow: 0 4px 10px rgba(94, 53, 177, 0.25); }
.prog-card-btn:hover { opacity: 0.95; transform: translateY(-1px); }

/* Responsive Grid & Card Styling for Program Bimbingan */
@media (max-width: 575.98px) {
  .program-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 10px 0;
  }

  .prog-card-top {
    min-height: 220px;
    padding: 20px 18px;
  }

  .prog-card-bottom {
    padding: 20px 18px;
  }

  .prog-card-desc-top {
    width: 60%;
    font-size: 0.78rem;
  }
}


/* Catatan: Styling Bagian Dalam Pop-up Modal dipindahkan ke blok style non-scoped di bawah
   karena b-modal Bootstrap Vue dirender di level <body> (di luar scope komponen),
   sehingga wajib non-scoped agar styling modal bekerja sempurna. */


/* ==========================================================================
   CABANG TERDEKAT SECTION (Interactive Map & Info Card)
   ========================================================================== */

.bta-cabang-section {
  padding: 60px 0;
  background-color: #fbfbfb;
  position: relative;
  font-family: 'Inter', sans-serif;
}

.bta-cabang-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fdf2f0;
  color: #c61a09;
  font-weight: 800;
  font-size: 0.78rem;
  letter-spacing: 0.8px;
  padding: 6px 14px;
  border-radius: 50px;
  border: 1px solid rgba(198, 26, 9, 0.15);
}

.bta-cabang-title {
  font-weight: 800;
  font-size: 2.1rem;
  color: #1a1a1a;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.bta-cabang-subtitle {
  font-size: 0.95rem;
  color: #555555;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

/* Card Container & Side Panels */
.bta-cabang-card {
  border-radius: 20px;
  padding: 24px;
  background: #ffffff;
  min-height: 520px;
  height: 100%;
  border: 1px solid #edf2f7;
  overflow: hidden;
}

/* Default Instruction State: Image Collage */
.bta-collage-container {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 6px;
  height: 160px;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 16px;
}

.bta-collage-main {
  grid-row: 1 / span 3;
  grid-column: 1;
  height: 100%;
  overflow: hidden;
}

.bta-collage-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.bta-collage-sub-tr {
  grid-row: 1;
  grid-column: 2;
  height: 100%;
  overflow: hidden;
}

.bta-collage-sub-tr img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bta-collage-sub-bl {
  grid-row: 2;
  grid-column: 2;
  height: 100%;
  overflow: hidden;
}

.bta-collage-sub-bl img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bta-collage-sub-br {
  grid-row: 3;
  grid-column: 2;
  height: 100%;
  overflow: hidden;
}

.bta-collage-sub-br img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bta-instruction-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.4;
  margin-bottom: 12px;
}

.bta-step-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bta-step-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  transition: background-color 0.2s ease;
}

.bta-step-item:hover {
  background: #f1f5f9;
}

.bta-step-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ffebe9;
  color: #c61a09;
  font-weight: 800;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bta-step-name {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: #1a202c;
}

.bta-step-desc {
  display: block;
  font-size: 0.72rem;
  color: #718096;
  line-height: 1.3;
}

/* Branch Detail State */
.bta-back-btn {
  text-decoration: none !important;
  font-size: 0.8rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.bta-back-btn:hover {
  color: #c61a09 !important;
}

.bta-branch-img-wrapper {
  background: linear-gradient(135deg, #c61a09 0%, #1f2937 100%);
  border-radius: 14px;
  height: 150px;
  overflow: hidden;
  position: relative;
}

.bta-branch-cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bta-branch-title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.2) 65%, transparent 100%);
  padding: 10px 14px;
}

.bta-branch-hero-title {
  color: #ffffff;
  font-size: 1.15rem;
  font-weight: 800;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.bta-branch-details-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 0;
}

.bta-badge-selected {
  background-color: #ebfbee !important;
  color: #2b8a3e !important;
  font-weight: 700;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.72rem;
  border: 1px solid rgba(43, 138, 62, 0.2);
}

.bta-badge-alt {
  background-color: #f1f3f5 !important;
  color: #495057 !important;
  font-weight: 700;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.72rem;
  border: 1px solid #e9ecef;
}

.bta-info-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 4px;
}

.bta-info-icon {
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 1px;
}

.bta-info-label {
  display: block;
  font-size: 0.68rem;
  color: #888888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bta-info-val {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.35;
}

.bta-branch-controls {
  border-top: 1px solid #edf2f7;
  padding-top: 12px;
  margin-top: auto;
}

.bta-btn-program {
  background-color: #c61a09 !important;
  border-color: #c61a09 !important;
  border-radius: 10px;
  font-size: 0.82rem;
  gap: 6px;
  transition: all 0.2s ease;
}

.bta-btn-program:hover {
  background-color: #a11406 !important;
  transform: translateY(-1px);
}

.bta-btn-maps {
  border-color: #c61a09 !important;
  color: #c61a09 !important;
  border-radius: 10px;
  font-size: 0.82rem;
  transition: all 0.2s ease;
}

.bta-btn-maps:hover {
  background-color: #c61a09 !important;
  color: #ffffff !important;
  transform: translateY(-1px);
}

.bta-btn-select-branch {
  border-radius: 10px;
  font-size: 0.8rem;
  background-color: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  color: #2d3748 !important;
}

.bta-btn-select-branch:hover {
  background-color: #edf2f7 !important;
}

.bta-branch-nav-links {
  font-size: 0.75rem;
}

.bta-branch-nav-links button {
  font-size: 0.75rem;
  text-decoration: none !important;
  font-weight: 600;
}

.skyline-decor {
  height: 60px;
  opacity: 0.05;
  z-index: 0;
}

/* Map Card & Container */
.bta-cabang-map-card {
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
  min-height: 520px;
  border: 1px solid #edf2f7;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

#map-cabang {
  width: 100%;
  height: 100%;
  min-height: 520px;
  border-radius: 20px;
}

/* Responsive Breakpoints untuk Cabang Terdekat */
@media (max-width: 991.98px) {
  .bta-cabang-card {
    min-height: auto;
    padding: 20px 16px;
    border-radius: 16px;
  }
  
  .bta-cabang-map-card {
    min-height: 380px;
    border-radius: 16px;
  }
  
  #map-cabang {
    min-height: 380px;
    height: 380px;
    border-radius: 16px;
  }
}

@media (max-width: 575.98px) {
  .bta-cabang-title {
    font-size: 1.5rem !important;
  }
  
  .bta-cabang-subtitle {
    font-size: 0.85rem;
  }
  
  .bta-collage-container {
    height: 140px;
  }
  
  .bta-cabang-map-card {
    min-height: 320px;
  }
  
  #map-cabang {
    min-height: 320px;
    height: 320px;
  }
  
  .bta-btn-program,
  .bta-btn-maps,
  .bta-btn-select-branch {
    font-size: 0.78rem;
    padding: 8px 12px;
  }
}

/* ==========================================================================
   BENEFITS SECTION
   ========================================================================== */

/* Styling Utama Benefits Card */
.benefits-card {
  position: relative;
  background-color: #f8f9fa;
  border: 1px solid #eaeaea;
  border-radius: 20px;
  padding: 2.5rem;
  overflow: hidden; /* Memotong gambar agar rapi di dalam lekukan card */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.benefits-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
}

/* Judul Section */
.benefits-title {
  font-weight: 700;
  color: #091e40;
  font-size: 1.85rem;
  letter-spacing: -0.02em;
  line-height: 1.3;
  margin-bottom: 2rem;
}

.benefits-title-highlight {
  color: #e31e24;
  font-weight: 700;
}

/* Benefit List Item */
.benefit-item {
  display: flex;
  align-items: start;
}

/* Wrapper Icon */
.benefit-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.benefit-item:hover .benefit-icon-wrapper {
  transform: scale(1.08);
}

.benefit-svg {
  color: #ffffff;
}

/* Variasi Warna Latar Belakang Ikon */
.benefit-icon-red { background-color: #C5001A; }
.benefit-icon-blue { background-color: #0F4C81; }
.benefit-icon-orange { background-color: #F58220; }
.benefit-icon-purple { background-color: #7F3F98; }

/* Typography */
.benefit-content-title {
  font-weight: 700;
  color: #091e40;
  font-size: 0.95rem;
  line-height: 1.3;
  margin-top: 2px;
  margin-bottom: 0.25rem;
}

.benefit-content-desc {
  color: #778295;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 0;
}

/* ========================================================
   PENGATURAN UKURAN & POSISI BARU UNTUK FOTO LAPTOP & HP
   ======================================================== */

/* TAMPILAN DESKTOP/LAPTOP (Di Kanan Bawah) */
.card-mockup-img-desktop {
  position: absolute;
  right: 0px;       /* Dirapatkan ke kanan agar tidak menabrak teks */
  bottom: -15px;    /* Disesuaikan agar pas dengan sudut bawah card */
  
  /* --- UKURAN LAPTOP DIPERKECIL SETENGAHNYA DI SINI --- */
  height: 160px;    /* <--- Diubah dari 280px menjadi 160px (sekitar setengahnya) */
  width: auto;
  
  object-fit: contain;
  z-index: 1;
}

/* --- CONTAINER TAMPILAN HP/MOBILE (Mengatur Jarak Atas) --- */
.mobile-mockup-wrapper {
  height: 220px;      /* Diperbesar sedikit ke 220px agar memberi ruang laptop turun */
  overflow: hidden;   /* Memotong area kosong transparan di bawah */
  
  /* --- JARAK DENGAN TULISAN DIATASNYA --- */
  margin-top: 4rem;   /* <--- Diperbesar ke 4rem agar tulisan dan laptop tidak menempel */
  
  position: relative;
  width: 100%;
}

/* --- FOTO MOCKUP HP/MOBILE (Di Tengah Bawah) --- */
.card-mockup-img-mobile {
  width: 95%;         
  max-width: 400px;
  height: auto;
  margin: 0 auto;
  display: block;
  object-fit: contain;
  
  /* --- MENURUNKAN GAMBAR KE BAWAH --- */
  /* Diubah menjadi positif (30px) untuk mendorong gambar laptop ke bawah */
  transform: translateY(30px); 
}

/* Media Query untuk Responsivitas Padding Card */
@media (max-width: 991.98px) {
  .benefits-card {
    padding: 2rem 1.5rem;
  }
}

/* ==========================================================================
   TESTIMONIALS SECTION
   ========================================================================== */

.bta-testimonials-section {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #FAFBFD; /* Latar belakang premium off-white */
  padding: 80px 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* Header Title & Subtitle */
.bta-header-group {
  margin-bottom: 28px;
}

.bta-subtitle {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #E52E35;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.bta-title {
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  line-height: 1.25;
  margin-bottom: 0;
}

.bta-text-red {
  color: #E52E35;
}

/* Slider Track & Container */
.bta-slider-container {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.bta-slider-track {
  display: flex;
  transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  gap: 20px;
  padding: 10px 0;
}

/* Premium Card Layout */
.bta-card {
  flex: 0 0 calc(50% - 10px); /* 2 Kolom di Desktop */
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(229, 231, 235, 0.7);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-height: 190px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.bta-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(229, 46, 53, 0.05);
}

/* Card Header */
.bta-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.bta-avatar-wrapper {
  position: relative;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

.bta-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #E52E35;
}

/* Fallback avatar generator style */
.bta-avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #E52E35;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
}

.bta-meta-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.bta-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 2px;
}

.bta-testi-branch-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.70rem;
  font-weight: 700;
  color: #c92a2a;
  background: #fff5f5;
  border: 1px solid #ffc9c9;
  padding: 1px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.bta-name {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 3px 0;
}

.bta-meta {
  font-size: 11.5px;
  color: #6B7280;
  margin: 0;
  font-weight: 500;
}

.bta-dot {
  color: #E52E35;
  font-weight: 700;
  margin: 0 3px;
}

/* Kutipan Testi */
.bta-quote-container {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bta-quote-text {
  font-size: 13.5px;
  color: #778295;
  line-height: 1.6;
  margin: 0;
  padding-right: 28px;
  max-height: 100px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(229, 46, 53, 0.3) transparent;
}

.bta-quote-text::-webkit-scrollbar {
  width: 3px;
}

.bta-quote-text::-webkit-scrollbar-thumb {
  background: rgba(229, 46, 53, 0.3);
  border-radius: 2px;
}

.bta-quote-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 22px;
  height: 22px;
  opacity: 0.95;
  flex-shrink: 0;
}

/* Video Player Card (Mengikuti rasio 16:9 bawaan Bootstrap) */
.bta-video-card {
  width: 100%;
  background: #000;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s ease;
}

.bta-video-card:hover {
  transform: scale(1.01);
}

/* Video Wrapper */
.bta-video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* Rasio 16:9 */
  height: 0;
}

.bta-video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  z-index: 1;
}

/* Navigasi Dots Indicator */
.bta-slider-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 30px;
}

.bta-dot-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #D1D5DB;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  padding: 0;
}

.bta-dot-indicator.active {
  width: 28px;
  background: #E52E35;
  border-radius: 4px;
}

/* Responsive breakpoint untuk card di mobile */
@media (max-width: 991px) {
  .bta-card {
    flex: 0 0 100%; /* 1 Kolom penuh di tablet/handphone */
  }
}

/* ==========================================================================
   HERO SELECTOR GLOW ANIMATION (TRIGGER DARI END SECTION & MULAI DAFTAR)
   ========================================================================== */
.hero-selector-card.selector-pulse-glow {
  border-color: #E12029 !important;
  box-shadow: 0 0 0 5px rgba(225, 32, 41, 0.35), 0 16px 45px rgba(225, 32, 41, 0.45) !important;
  transform: translateY(-4px) scale(1.02);
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  animation: heroSelectorPulseGlow 1s ease-in-out infinite alternate;
}

@keyframes heroSelectorPulseGlow {
  0% {
    box-shadow: 0 0 0 4px rgba(225, 32, 41, 0.25), 0 10px 30px rgba(225, 32, 41, 0.3);
    border-color: #E12029;
  }
  100% {
    box-shadow: 0 0 0 10px rgba(225, 32, 41, 0.5), 0 22px 55px rgba(225, 32, 41, 0.6);
    border-color: #ff3b46;
  }
}

/* ==========================================================================
   END SECTION (ENHANCED MODERN CTA BANNER)
   ========================================================================== */

/* Card Container dengan Gradasi Merah Premium & Lighting */
.cta-card {
  background: linear-gradient(135deg, #be121c 0%, #e12029 50%, #990e16 100%);
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(225, 32, 41, 0.32), 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  position: relative;
  overflow: hidden;
}

/* Ambient glow accents */
.cta-bg-glow-top {
  position: absolute;
  top: -80px;
  right: -80px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22) 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
}

.cta-bg-glow-bottom {
  position: absolute;
  bottom: -60px;
  left: 20%;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 200, 200, 0.18) 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
}

.cta-pattern-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 0);
  background-size: 20px 20px;
  pointer-events: none;
  z-index: 1;
}

/* Rocket bubble container with soft floating bounce */
.cta-rocket-bubble {
  width: 76px;
  height: 76px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.16);
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), inset 0 2px 4px rgba(255, 255, 255, 0.3);
  animation: ctaRocketFloat 3s ease-in-out infinite alternate;
}

@keyframes ctaRocketFloat {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  100% {
    transform: translateY(-6px) rotate(3deg);
  }
}

/* Badge Pill */
.cta-badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #ffffff;
  padding: 4px 14px;
  border-radius: 50px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  backdrop-filter: blur(4px);
}

.cta-badge-star {
  font-size: 0.82rem;
}

/* Judul Utama */
.cta-title {
  color: #ffffff;
  font-weight: 800;
  font-size: 1.95rem;
  margin-bottom: 0.4rem;
  line-height: 1.25;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}

/* Sub-judul */
.cta-subtitle {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.02rem;
  font-weight: 400;
  line-height: 1.55;
  max-width: 620px;
}

/* Feature tags */
.cta-feature-tags {
  gap: 8px;
}

.cta-tag-item {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 0.76rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Tombol CTA Putih Mewah */
.cta-btn {
  background: #ffffff !important;
  color: #be121c !important;
  font-weight: 800;
  font-size: 1.05rem;
  padding: 0.9rem 2.4rem;
  border-radius: 14px;
  border: none;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  white-space: nowrap;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.cta-btn:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.3), 0 0 0 4px rgba(255, 255, 255, 0.3);
  background-color: #ffffff !important;
  color: #e12029 !important;
}

.cta-btn .cta-btn-arrow {
  transition: transform 0.25s ease;
}

.cta-btn:hover .cta-btn-arrow {
  transform: translateX(5px);
}

/* Responsive breakpoint */
@media (max-width: 767.98px) {
  .cta-title {
    font-size: 1.45rem;
  }
  .cta-subtitle {
    font-size: 0.92rem;
  }
  .cta-btn {
    width: 100%;
    padding: 0.85rem 1.5rem;
    font-size: 0.98rem;
  }
  .cta-rocket-bubble {
    width: 64px;
    height: 64px;
    border-radius: 18px;
  }
  .cta-rocket-bubble svg {
    width: 38px;
    height: 38px;
  }
}

</style>

<style>

/* ==========================================================================
   BRANCH PROGRAM PICKER MODAL (PILIH JENJANG PROGRAM DI CABANG)
   ========================================================================== */

.branch-program-modal .modal-dialog {
  max-width: 780px !important;
  width: 92% !important;
  margin: 1.75rem auto !important;
}

.branch-program-modal .modal-content {
  border-radius: 24px !important;
  border: none !important;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2) !important;
  overflow: hidden !important;
}

.branch-prog-picker-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.branch-prog-card {
  background: #ffffff;
  border: 1.5px solid #edf2f7;
  border-radius: 16px;
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.branch-prog-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

.branch-prog-card.card-orange:hover {
  border-color: #e67e22;
  box-shadow: 0 10px 25px rgba(230, 126, 34, 0.15);
}

.branch-prog-card.card-purple:hover {
  border-color: #5e35b1;
  box-shadow: 0 10px 25px rgba(94, 53, 177, 0.15);
}

.branch-prog-card.card-blue:hover {
  border-color: #0066cc;
  box-shadow: 0 10px 25px rgba(0, 102, 204, 0.15);
}

.branch-prog-card.card-green:hover {
  border-color: #4d8e2d;
  box-shadow: 0 10px 25px rgba(77, 142, 45, 0.15);
}

.branch-prog-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.branch-prog-pill {
  font-size: 0.68rem;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 20px;
}

.bg-orange-soft { background-color: #fef4ea; color: #e67e22; }
.bg-purple-soft { background-color: #f3ebfc; color: #5e35b1; }
.bg-blue-soft { background-color: #ebf4fc; color: #0066cc; }
.bg-green-soft { background-color: #ecfcf0; color: #4d8e2d; }

.branch-prog-arrow {
  font-size: 1rem;
  font-weight: 800;
  color: #a0aec0;
  transition: transform 0.2s ease, color 0.2s ease;
}

.branch-prog-card:hover .branch-prog-arrow {
  transform: translateX(4px);
  color: #1a1a1a;
}

.branch-prog-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 4px;
}

.branch-prog-desc {
  font-size: 0.72rem;
  line-height: 1.4;
  color: #718096;
  margin-bottom: 10px;
}

.branch-prog-action {
  font-size: 0.75rem;
  font-weight: 700;
  margin-top: auto;
}

@media (max-width: 767.98px) {
  .branch-prog-picker-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .branch-program-modal .modal-dialog {
    max-width: 95% !important;
    width: 95% !important;
    margin: 10px auto !important;
  }
}

/* ==========================================================================
   PROGRAM BIMBINGAN SECTION STYLES
   ========================================================================== */

/* Pastikan elemen modal-dialog dari class khusus kita melebar penuh di desktop */
.program-popup-modal .modal-dialog {
  max-width: 1140px !important;
  width: 90% !important;
  margin: 1.75rem auto !important;
}

/* Memperbesar secara khusus untuk resolusi layar lebar (Desktop 1900px ke atas) */
@media (min-width: 1900px) {
  .program-popup-modal .modal-dialog {
    max-width: 1200px !important;
  }
}

/* Mempercantik kotak modal content */
.program-popup-modal .modal-content {
  border-radius: 24px !important;
  border: none !important;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.18) !important;
  overflow: hidden !important;
}

/* Aturan responsive khusus di HP */
@media (max-width: 991px) {
  .program-popup-modal .modal-dialog {
    max-width: 95% !important;
    width: 95% !important;
    margin: 10px auto !important;
  }
}

/* ==========================================================================
   STYLING BAGIAN DALAM POP-UP MODAL (BERSIH, MODERN, NON-AI)
   ========================================================================== */
.popup-wrapper {
  background-color: #ffffff;
  padding: 32px 36px 28px 36px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #1e293b;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 22px;
  position: relative;
}

.popup-close-btn {
  position: absolute;
  top: 18px;
  right: 20px;
  font-size: 1.6rem;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: #64748b;
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  line-height: 1;
}
.popup-close-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
  transform: rotate(90deg);
}

/* Header Section */
.popup-header-clean {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 18px;
}

.popup-badge-clean {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.8px;
  padding: 5px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.badge-red { background-color: #fef2f2; color: #dc2626; border: 1px solid #fee2e2; }
.badge-purple { background-color: #f5f3ff; color: #7c3aed; border: 1px solid #ede9fe; }
.badge-blue { background-color: #eff6ff; color: #2563eb; border: 1px solid #dbeafe; }
.badge-green { background-color: #f0fdf4; color: #16a34a; border: 1px solid #dcfce7; }

.popup-title-clean {
  font-size: 1.85rem;
  font-weight: 900;
  color: #0f172a;
  margin: 0 0 6px 0;
  letter-spacing: -0.6px;
  line-height: 1.15;
}

.popup-subtitle-clean {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  line-height: 1.4;
}
.text-red-theme { color: #dc2626 !important; }
.text-purple-theme { color: #7c3aed !important; }
.text-blue-theme { color: #2563eb !important; }
.text-green-theme { color: #16a34a !important; }

.popup-desc-clean {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #475569;
  margin: 0 0 16px 0;
  max-width: 900px;
}

/* Quick Highlights Bar */
.popup-highlights-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 16px;
  width: 100%;
}

.highlight-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}

.highlight-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dot-red { background-color: #dc2626; }
.dot-purple { background-color: #7c3aed; }
.dot-blue { background-color: #2563eb; }
.dot-green { background-color: #16a34a; }

/* Sections Common */
.popup-section-clean {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-title-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 6px;
}

.section-title-clean {
  font-size: 0.95rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.2px;
}

.section-subtitle-clean {
  font-size: 0.75rem;
  color: #94a3b8;
  font-weight: 500;
}

/* Benefits Grid (01, 02, 03, 04) */
.popup-benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.benefit-box {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: all 0.2s ease;
}
.benefit-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.04);
}
.benefit-box.border-red:hover { border-color: #fca5a5; }
.benefit-box.border-purple:hover { border-color: #c4b5fd; }
.benefit-box.border-blue:hover { border-color: #93c5fd; }
.benefit-box.border-green:hover { border-color: #86efac; }

.benefit-num-tag {
  font-size: 0.85rem;
  font-weight: 900;
  letter-spacing: 0.5px;
  line-height: 1;
}
.num-red { color: #dc2626; }
.num-purple { color: #7c3aed; }
.num-blue { color: #2563eb; }
.num-green { color: #16a34a; }

.benefit-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.benefit-head {
  font-size: 0.82rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.3;
}

.benefit-body {
  font-size: 0.74rem;
  color: #64748b;
  line-height: 1.45;
  margin: 0;
}

/* Tahapan Belajar (Stages Grid) */
.popup-stages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.stage-card {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stage-badge-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.stage-pill {
  font-size: 0.65rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 7px;
  border-radius: 4px;
}
.pill-red { background-color: #fee2e2; color: #b91c1c; }
.pill-purple { background-color: #ede9fe; color: #6d28d9; }
.pill-blue { background-color: #dbeafe; color: #1d4ed8; }
.pill-green { background-color: #dcfce7; color: #15803d; }

.stage-timing {
  font-size: 0.68rem;
  font-weight: 600;
  color: #94a3b8;
}

.stage-name {
  font-size: 0.82rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.3;
}

.stage-desc {
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.45;
  margin: 0;
}

/* Schedule Box */
.popup-schedule-box {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schedule-head-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 8px;
}

.schedule-title {
  font-size: 0.88rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.schedule-note {
  font-size: 0.72rem;
  color: #94a3b8;
  font-style: italic;
}

.schedule-cols-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.schedule-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sched-badge {
  font-size: 0.7rem;
  font-weight: 800;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sched-text {
  font-size: 0.78rem;
  line-height: 1.5;
  color: #475569;
  margin: 0;
}

/* Subjects Box */
.popup-subjects-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subjects-box-title {
  font-size: 0.88rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.subjects-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.subject-tag-clean {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid transparent;
  line-height: 1.3;
}
.tag-red-clean { background-color: #fef2f2; color: #b91c1c; border-color: #fee2e2; }
.tag-purple-clean { background-color: #f5f3ff; color: #6d28d9; border-color: #ede9fe; }
.tag-blue-clean { background-color: #eff6ff; color: #1d4ed8; border-color: #dbeafe; }
.tag-green-clean { background-color: #f0fdf4; color: #15803d; border-color: #dcfce7; }

/* Action Card (Branch Selector & WhatsApp CTA) */
.popup-action-card {
  background-color: #0f172a;
  border-radius: 14px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #ffffff;
  margin-top: 6px;
}

.action-card-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 58%;
}

.action-card-label {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: #94a3b8;
  text-transform: uppercase;
}

.action-branch-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.action-branch-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-branch-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
}
.action-branch-title.text-muted {
  color: #cbd5e1;
}

.action-branch-badge {
  font-size: 0.62rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge-available { background-color: #16a34a; color: #ffffff; }
.badge-unavailable { background-color: #dc2626; color: #ffffff; }

.action-branch-desc {
  font-size: 0.72rem;
  line-height: 1.4;
  color: #cbd5e1;
  margin: 0;
}

.action-card-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.branch-dropdown-wrapper {
  position: relative;
}

.action-btn-secondary {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 0.76rem;
  font-weight: 700;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: all 0.2s ease;
}
.action-btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.action-dropdown-list {
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  width: 220px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding: 6px 0;
  margin: 0;
  list-style: none;
}

.action-dropdown-item {
  padding: 8px 14px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.action-dropdown-item:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.action-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #ffffff !important;
  text-decoration: none !important;
  font-size: 0.8rem;
  font-weight: 800;
  padding: 9px 18px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  white-space: nowrap;
}
.action-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.22);
}
.btn-red-primary { background: #dc2626; }
.btn-red-primary:hover { background: #b91c1c; }
.btn-purple-primary { background: #7c3aed; }
.btn-purple-primary:hover { background: #6d28d9; }
.btn-blue-primary { background: #2563eb; }
.btn-blue-primary:hover { background: #1d4ed8; }
.btn-green-primary { background: #16a34a; }
.btn-green-primary:hover { background: #15803d; }

.action-btn-svg {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

/* ==========================================================================
   RESPONSIVE OVERRIDES UNTUK POP-UP MODAL (TABLET & SMARTPHONE)
   ========================================================================== */
@media (max-width: 991px) {
  .popup-wrapper {
    padding: 24px 20px 20px 20px;
    gap: 18px;
    max-height: 88vh;
  }
  
  .popup-title-clean {
    font-size: 1.5rem;
  }
  
  .popup-subtitle-clean {
    font-size: 0.95rem;
  }
  
  .popup-highlights-bar {
    gap: 10px 14px;
    padding: 8px 12px;
  }
  
  .popup-benefits-grid,
  .popup-stages-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .schedule-cols-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .popup-action-card {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
  
  .action-card-left {
    max-width: 100%;
  }
  
  .action-card-right {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  
  .action-btn-secondary,
  .action-btn-primary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .popup-benefits-grid,
  .popup-stages-grid {
    grid-template-columns: 1fr;
  }
  
  .popup-title-clean {
    font-size: 1.35rem;
  }
}

/* ============================================ */
/* ==========================================================================
   CABANG TERDEKAT SECTION (Interactive Map)
   ========================================================================== */

/* Leaflet Markers Global Styling (Wajib Non-Scoped) */
.custom-bta-marker-container {
  overflow: visible !important;
}
.bta-marker-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  pointer-events: auto;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.bta-marker-pin {
  width: 30px;
  height: 30px;
  background-color: #E12029;
  border: 3px solid #FFFFFF;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 2;
}
.bta-marker-pin svg {
  width: 14px;
  height: 14px;
  color: white !important;
  transform: rotate(45deg);
}
.bta-marker-label {
  background-color: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  color: #1F2937;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(0,0,0,0.06);
  position: absolute;
  left: 24px;
  opacity: 0.95;
  transition: all 0.3s ease;
  z-index: 1;
}
.bta-marker-wrapper.active-marker {
  transform: scale(1.2);
}
.bta-marker-wrapper.active-marker .bta-marker-pin {
  background-color: #9B1C1C !important;
  box-shadow: 0 8px 16px rgba(155, 28, 28, 0.4);
}
.bta-marker-wrapper.active-marker .bta-marker-label {
  border-color: #9B1C1C;
  color: #9B1C1C;
  opacity: 1;
  font-weight: 900;
}
.bta-marker-wrapper:hover {
  transform: scale(1.1);
}
.bta-marker-wrapper:hover .bta-marker-pin {
  background-color: #C21A22;
}
.bta-marker-wrapper:hover .bta-marker-label {
  opacity: 1;
}
.leaflet-container {
  background-color: #EBF3FE !important;
}
.map-ctrl-btn {
  transition: all 0.2s ease-in-out;
}
.map-ctrl-btn:hover {
  background-color: #f8f9fa !important;
  transform: scale(1.05);
}
.map-ctrl-btn svg {
  transition: transform 0.2s ease;
}
.map-ctrl-btn:hover svg {
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue